import{FaChevronDown as vl}from"@react-icons/all-files/fa/FaChevronDown";import Oo from"classnames";import{useEffect as Vo,useRef as wt,useState as St}from"react";import{createGlobalStyle as ul}from"styled-components";var g="nindo",a=e=>`${g}-${e}`,Ao=ul`
  :root {
    --${g}-primary-font: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.typography)==null?void 0:o.fonts)==null?void 0:i.primary)||""}};
    --${g}-secondary-font: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.typography)==null?void 0:o.fonts)==null?void 0:i.secondary)||""}};
    --${g}-primary-100: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.primary)==null?void 0:i[100])||""}};
  --${g}-primary-200: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.primary)==null?void 0:i[200])||""}};
    --${g}-primary-300: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.primary)==null?void 0:i[300])||""}};
    --${g}-primary-500: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.primary)==null?void 0:i[500])||""}};
    --${g}-primary-700: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.primary)==null?void 0:i[700])||""}};
    --${g}-primary-800: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.primary)==null?void 0:i[800])||""}};
    --${g}-primary-900: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.primary)==null?void 0:i[900])||""}};
    --${g}-background-100: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.background)==null?void 0:i[100])||""}};
    --${g}-background-300: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.background)==null?void 0:i[300])||""}};
    --${g}-background-500: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.background)==null?void 0:i[500])||""}};
    --${g}-background-600: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.background)==null?void 0:i[600])||""}};
    --${g}-background-700: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.background)==null?void 0:i[700])||""}};
    --${g}-background-800: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.background)==null?void 0:i[800])||""}};
    --${g}-background-900: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.background)==null?void 0:i[900])||""}};
    --${g}-text-000: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.text)==null?void 0:i["000"])||""}};
    --${g}-text-100: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.text)==null?void 0:i[100])||""}};
    --${g}-text-300: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.text)==null?void 0:i[300])||""}};
    --${g}-text-500: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.text)==null?void 0:i[500])||""}};
    --${g}-text-700: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.text)==null?void 0:i[700])||""}};
    --${g}-text-900: ${e=>{var t,o,i;return((i=(o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.text)==null?void 0:i[900])||""}};
    --${g}-white: #fff;
    --${g}-black: #000;
    --${g}-error: ${e=>{var t,o;return((o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.error)||""}};
    --${g}-success: ${e=>{var t,o;return((o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.success)||""}};
    --${g}-warning: ${e=>{var t,o;return((o=(t=e.theme)==null?void 0:t.colors)==null?void 0:o.warning)||""}};
  }

  * {
    box-sizing: border-box;
  }

  /* Reset */
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
    background: transparent;
  }

  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  ol,
  ul {
    list-style: none;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }

  :focus {
    outline: 0;
  }

  ins {
    text-decoration: none;
  }

  del {
    text-decoration: line-through;
  }

  table {
  }

  a {
    text-decoration: none;
  }

  a:hover {
    text-decoration: none;
  }

  a:focus {
    outline: 0;
  }

  strong, b {
    font-weight: 700;
  }

  i, em {
    font-style: italic;
  }

  .center {
    text-align: center;
  }

  html {
    font-size: ${e=>{var t,o,i,l;return((l=(i=(o=(t=e.theme)==null?void 0:t.typography)==null?void 0:o.sizes)==null?void 0:i.text)==null?void 0:l.base)||16}}px; // For responsive fonts, we'll use rem from now
  }

  body {
    font-weight: 400;
    font-family: var(--${g}-primary-font);

    --sb-track-color: #f5f5f5;
    --sb-thumb-color: #bbbbbb;
    --sb-size: 10px;

    scrollbar-color: var(--sb-thumb-color) 
                   var(--sb-track-color);
  }
  
  &::-webkit-scrollbar {
    width: var(--sb-size);
  }

  &::-webkit-scrollbar-track {
    background: var(--sb-track-color);
    border-radius: 0px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--sb-thumb-color);
    border-radius: 10px;
      border: 1px solid var(--sb-track-color);
  }
`;import yl from"styled-components";import qt from"react";import{ThemeProvider as Bo}from"styled-components";import{Fragment as xl,jsx as Ke,jsxs as hl}from"react/jsx-runtime";var Ho=e=>{var t,o,i,l,n,s,d,c,m,p,f,v;return{name:"dark",colors:{primary:{100:"#252542",200:"#3C3C52",300:"#3638CC",500:"#4C4FFF",700:"#8789FF",800:"#E4E4FF",900:"#F5F5FF",...((t=e.colors)==null?void 0:t.primary)||{}},text:{"000":"#ffffff",100:"#e6e6e6",300:"#d1d1d1",500:"#bdbdbd",700:"#a8a8a8",900:"#949494",...((o=e.colors)==null?void 0:o.text)||{}},background:{100:"#606060",300:"#464646",500:"#2d2d2d",600:"#202020",700:"#131313",800:"#0d0d0d",900:"#010101",...((i=e.colors)==null?void 0:i.background)||{}},error:((l=e.colors)==null?void 0:l.error)||"#E54657",success:((n=e.colors)==null?void 0:n.success)||"#30BB57",warning:((s=e.colors)==null?void 0:s.warning)||"#FFC657"},typography:{sizes:{text:{base:14,...(c=(d=e.typography)==null?void 0:d.sizes)==null?void 0:c.text}},fonts:{primary:((p=(m=e.typography)==null?void 0:m.fonts)==null?void 0:p.primary)||"'Lato', sans-serif",secondary:((v=(f=e.typography)==null?void 0:f.fonts)==null?void 0:v.secondary)||"'Lato', sans-serif"}}}},Go=e=>{var t,o,i,l,n,s,d,c,m,p,f,v;return{name:"light",colors:{primary:{100:"#F5F5FF",200:"#E4E4FF",300:"#8789FF",500:"#4C4FFF",700:"#3638CC",800:"#202041",900:"#1b1b35",...((t=e.colors)==null?void 0:t.primary)||{}},text:{"000":"#000000",100:"#202020",300:"#393939",500:"#535353",700:"#6c6c6c",900:"#868686",...((o=e.colors)==null?void 0:o.text)||{}},background:{100:"#acacac",300:"#c6c6c6",500:"#dfdfdf",600:"#ececec",700:"#f9f9f9",800:"#f1f1f1",900:"#ffffff",...((i=e.colors)==null?void 0:i.background)||{}},error:((l=e.colors)==null?void 0:l.error)||"#E54657",success:((n=e.colors)==null?void 0:n.success)||"#30BB57",warning:((s=e.colors)==null?void 0:s.warning)||"#FFC657"},typography:{sizes:{text:{base:14,...(c=(d=e.typography)==null?void 0:d.sizes)==null?void 0:c.text}},fonts:{primary:((p=(m=e.typography)==null?void 0:m.fonts)==null?void 0:p.primary)||"'Lato', sans-serif",secondary:((v=(f=e.typography)==null?void 0:f.fonts)==null?void 0:v.secondary)||"'Lato', sans-serif"}}}},r={primaryFont:`--${g}-primary-font`,secondaryFont:`--${g}-secondary-font`,primary100:`--${g}-primary-100`,primary200:`--${g}-primary-200`,primary300:`--${g}-primary-300`,primary500:`--${g}-primary-500`,primary700:`--${g}-primary-700`,primary800:`--${g}-primary-800`,primary900:`--${g}-primary-900`,background100:`--${g}-background-100`,background300:`--${g}-background-300`,background500:`--${g}-background-500`,background600:`--${g}-background-600`,background700:`--${g}-background-700`,background800:`--${g}-background-800`,background900:`--${g}-background-900`,text000:`--${g}-text-000`,text100:`--${g}-text-100`,text300:`--${g}-text-300`,text500:`--${g}-text-500`,text700:`--${g}-text-700`,text900:`--${g}-text-900`,error:`--${g}-error`,white:`--${g}-white`,black:`--${g}-black`},bl=({children:e,theme:t,overrides:o={}})=>{let i=t==="dark"?Ho(o):Go(o);return hl(Bo,{theme:i,children:[Ke(Ao,{}),e]})},gl=({children:e,theme:t,overrides:o={}})=>{var s,d,c,m,p,f,v,k,$,b,q,h,u,x,y,S,w,L,Y,B,H,j,ee,D,K,se,re,ce,te,qe,ie,Pe,Te,ke,_e,I,M,X,de,je,P,z,N,G,Q,ae,Ee;let i=t==="dark"?Ho(o):Go(o),l={[`--${g}-primary-font`]:((d=(s=i.typography)==null?void 0:s.fonts)==null?void 0:d.primary)||"",[`--${g}-secondary-font`]:((m=(c=i.typography)==null?void 0:c.fonts)==null?void 0:m.secondary)||"",[`--${g}-primary-100`]:((f=(p=i.colors)==null?void 0:p.primary)==null?void 0:f[100])||"",[`--${g}-primary-200`]:((k=(v=i.colors)==null?void 0:v.primary)==null?void 0:k[200])||"",[`--${g}-primary-300`]:((b=($=i.colors)==null?void 0:$.primary)==null?void 0:b[300])||"",[`--${g}-primary-500`]:((h=(q=i.colors)==null?void 0:q.primary)==null?void 0:h[500])||"",[`--${g}-primary-700`]:((x=(u=i.colors)==null?void 0:u.primary)==null?void 0:x[700])||"",[`--${g}-primary-800`]:((S=(y=i.colors)==null?void 0:y.primary)==null?void 0:S[800])||"",[`--${g}-primary-900`]:((L=(w=i.colors)==null?void 0:w.primary)==null?void 0:L[900])||"",[`--${g}-background-100`]:((B=(Y=i.colors)==null?void 0:Y.background)==null?void 0:B[100])||"",[`--${g}-background-300`]:((j=(H=i.colors)==null?void 0:H.background)==null?void 0:j[300])||"",[`--${g}-background-500`]:((D=(ee=i.colors)==null?void 0:ee.background)==null?void 0:D[500])||"",[`--${g}-background-600`]:((se=(K=i.colors)==null?void 0:K.background)==null?void 0:se[600])||"",[`--${g}-background-700`]:((ce=(re=i.colors)==null?void 0:re.background)==null?void 0:ce[700])||"",[`--${g}-background-800`]:((qe=(te=i.colors)==null?void 0:te.background)==null?void 0:qe[800])||"",[`--${g}-background-900`]:((Pe=(ie=i.colors)==null?void 0:ie.background)==null?void 0:Pe[900])||"",[`--${g}-text-000`]:((ke=(Te=i.colors)==null?void 0:Te.text)==null?void 0:ke["000"])||"",[`--${g}-text-100`]:((I=(_e=i.colors)==null?void 0:_e.text)==null?void 0:I[100])||"",[`--${g}-text-300`]:((X=(M=i.colors)==null?void 0:M.text)==null?void 0:X[300])||"",[`--${g}-text-500`]:((je=(de=i.colors)==null?void 0:de.text)==null?void 0:je[500])||"",[`--${g}-text-700`]:((z=(P=i.colors)==null?void 0:P.text)==null?void 0:z[700])||"",[`--${g}-text-900`]:((G=(N=i.colors)==null?void 0:N.text)==null?void 0:G[900])||"",[`--${g}-white`]:"#fff",[`--${g}-black`]:"#000",[`--${g}-error`]:((Q=i.colors)==null?void 0:Q.error)||"",[`--${g}-success`]:((ae=i.colors)==null?void 0:ae.success)||"",[`--${g}-warning`]:((Ee=i.colors)==null?void 0:Ee.warning)||""},n=qt.Children.map(e,pe=>typeof pe.type=="string"?qt.cloneElement(pe,{style:{...l,...pe.props.style}}):Ke("div",{style:{...l},children:qt.cloneElement(pe,pe.props)}));return Ke(xl,{children:Ke(Bo,{theme:i,children:n})})};var kt=`
		div.quill .ql-container,
		.nindo-input,
		.nindo-textarea,
		.nindo-select .${a("select__control")},
		.dropdown-container `,Wo=yl.div`
	background: var(${r.background600});
	color: var(${r.text300});
	font-size: 1rem;
	border-radius: 5px;
	margin-bottom: 15px;

	.nindo-accordion-content {
		${kt} {
			background-color: var(${r.background600});
		}

		.nindo-accordion-content {
			${kt} {
				background-color: var(${r.background500});
			}

			.nindo-accordion-content {
				${kt} {
					background-color: var(${r.background500});
				}
			}
		}
	}

	&:last-of-type {
		margin-bottom: 0;
	}

	> header {
		padding: 10px;
		font-size: 1.03rem;
		font-weight: 500;
		color: var(${r.text300});
		background: var(${r.background600});
		position: relative;
		transition: 0.2s;
		cursor: pointer;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-radius: 5px;
		gap: 5px;

		&.no-content {
			cursor: default;
		}

		&:hover {
			background-color: var(${r.background500});

			.${a("accordion-toggler")} {
				color: var(${r.text100});
			}
		}

		.${a("accordion-toggler")} {
			transition: 0.2s;
			color: var(${r.text500});
		}
	}

	> section {
		margin: 0;
		padding: 0;
		max-height: 0;
		transition: max-height 0.1s linear;
		overflow: hidden;
	}

	.${a("accordion-title")} {
		flex: 1;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		gap: 30px;

		img {
			height: 20px;
			width: 20px;
			object-fit: cover;
		}

		.${a("nindo-image-upload-image")} {
			img {
				height: 100%;
				width: 100%;
			}
		}

		span:not(.${a("items-manager-drag-handler")}) {
			max-width: 240px;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
	}

	.${a("accordion-content")} {
		/* border-top: 1px solid var(${r.background900}); */
		padding: 10px;
		position: relative;
	}

	&.active {
		> header {
			border-radius: 5px 5px 0 0;
			background: var(${r.background500});

			/* &:hover {
				background-color: var(${r.background300});
			} */

			.${a("accordion-toggler")} {
				transform: rotate(180deg);
			}
		}
	}

	&.visible {
		section {
			overflow: visible;
		}
	}

	&.secondary {
		background: var(${r.background500});
		margin-bottom: 10px;

		&:last-of-type {
			margin-bottom: 0;
		}

		> header {
			background: var(${r.background500});
			padding: 7px 10px;

			&:hover {
				background-color: var(${r.background300});
			}
		}

		&.active {
			> header {
				background: var(${r.background300});
			}
		}
	}
`;import{jsx as Qe,jsxs as Uo}from"react/jsx-runtime";var Ct=e=>{var u;let t=wt(null),{titleComponent:o,openedByDefault:i,onToggle:l,children:n,secondary:s,collapsedGroups:d,collapsable:c=!0}=e,[m,p]=St(!c||i||!1),[f,v]=St(m?(u=t==null?void 0:t.current)==null?void 0:u.scrollHeight:0),[k,$]=St(!c||i||!1),b=wt(),q={maxHeight:`${f}px`},h=wt();return Vo(()=>{if(!!c){if(l==null||l(m),!m){$(!1);return}c&&b.current.parentElement.querySelectorAll(".active.visible").forEach(y=>{var S;y!==b.current&&((S=y.querySelector("header"))==null||S.click())}),typeof window<"u"&&window.setTimeout(()=>$(!0),200)}},[m]),Vo(()=>{function x(y){if(!k||!m){v(0);return}h.current&&clearTimeout(h.current),h.current=setTimeout(()=>{n&&(t==null?void 0:t.current)&&m&&k?(v(t.current.scrollHeight),x()):v(0)},y?10:500)}return x(!0),()=>{h.current&&clearTimeout(h.current)}},[k,m,n,t]),Uo(Wo,{...e,className:Oo(e.className||"",{visible:k,active:m,secondary:s}),ref:b,children:[Uo("header",{className:Oo({"no-content":!n&&!e.onClick}),onClick:()=>{!c||p(!m)},children:[Qe("div",{className:a("accordion-title"),children:o}),c&&n&&Qe(vl,{className:a("accordion-toggler"),size:14})]}),(c||!c&&i)&&n&&Qe("section",{ref:t,style:q,children:Qe("div",{className:a("accordion-content"),children:m&&n})})]})};import{BsFillPersonFill as wl}from"@react-icons/all-files/bs/BsFillPersonFill";import ql,{css as kl}from"styled-components";var Yo=ql.div`
	${({size:e=50})=>kl`
		position: relative;
		width: ${e}px;
		height: ${e}px;
		border-radius: 50em;
		color: var(${r.text500});
		background-color: var(${r.background500});
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: ${e/1.8}px;
		text-transform: uppercase;
		overflow: hidden;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		span {
			font-size: 1.1rem;
		}
	`}
`;import{jsx as Je}from"react/jsx-runtime";var Sl=({imageUrl:e,name:t="",...o})=>{function i(){var m,p;let[n,s]=t.split(" "),d=Array.from(n)[0],c=Array.from(n)[1]||"";return s&&((m=Array.from(s))==null?void 0:m[0])&&(c=(p=Array.from(s))==null?void 0:p[0]),`${d}${c}`}function l(){return e?Je("img",{src:e,alt:t||e||"image"}):t?Je("span",{children:i()}):Je(wl,{})}return Je(Yo,{...o,children:l()})};import Cl,{css as $l}from"styled-components";var Xo=Cl.div`
  ${({size:e=18})=>$l`
    position: absolute;
		right: 0;
		top: 0;
		min-width: ${e}px;
		height: ${e}px;
		border-radius: 50em;
		color: var(${r.white});
		background-color: var(${r.primary500});
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: ${e/1.7}px;
		line-height: 1;
		padding: 0 3px;
		overflow: hidden;
    transform: translate(120%, -25%);

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			border-radius: 50em;
		}

		span {
			font-size: ${e/2}px;
		}
  `}
`;import{Fragment as Pl,jsx as $t}from"react/jsx-runtime";var Il=({children:e,count:t="",...o})=>{function i(){return e||(t?$t("span",{children:t}):$t(Pl,{}))}return $t(Xo,{...o,children:i()})};import Tl from"classnames";import et from"styled-components";var Fe=et.button`
	cursor: pointer;
	background-color: var(${r.primary500});
	border: none;
	color: white;
	border-radius: 5px;
	padding: 5px 15px;
	transition: 0.2s;
	font-weight: 500;
	font-size: 1rem;
	font-family: var(${r.primaryFont});
	line-height: 1.3rem;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 5px;

	svg {
		fill: currentColor;
	}

	a {
		color: inherit;

		&:hover {
			color: inherit;
		}
	}

	&:hover {
		background-color: var(${r.primary300});
		color: white;

		a {
			color: inherit;
		}
	}

	&:active {
		background-color: var(${r.primary100});
		color: white;
	}

	&:disabled {
		opacity: 0.3;
		pointer-events: none;
	}

	&.secondary {
		background-color: var(${r.background500});
		color: var(${r.text500});
		border-color: var(${r.background300});

		&:hover {
			background-color: var(${r.background300});
			color: var(${r.text300});
			border-color: var(${r.background100});
		}

		&:active {
			background-color: var(${r.background300});
			color: var(${r.text300});
			border-color: var(${r.background100});
		}
	}

	&.add {
		background-color: transparent;
		border: 2px dashed var(${r.background300});
		color: var(${r.text500});

		&:hover {
			background-color: transparent;
			border-color: var(${r.background100});
			color: var(${r.text300});
		}

		&:active {
			background-color: transparent;
			border-color: var(${r.background100});
			color: var(${r.text100});
		}
	}

	&.expand {
		background-color: var(${r.background500});
		color: var(${r.text500});
		border: none;

		&:hover {
			background-color: var(${r.background300});
			color: var(${r.text300});
		}

		&:active {
			background-color: var(${r.background300});
			color: var(${r.text300});
		}
	}

	&.transparent {
		background-color: transparent;
		border: none;
		color: var(${r.text500});

		&:hover {
			background-color: transparent;
			color: var(${r.text300});
		}

		&:active {
			background-color: transparent;
			border-color: var(${r.text100});
			color: var(${r.text100});
		}
	}

	&.amit {
		background-color: var(${r.primary100});
		color: var(${r.primary800});
		border: none;

		&:hover,
		&:active {
			color: var(${r.primary800});
			background-color: var(${r.primary200});
		}
	}
`,km=et(Fe)``,wm=et(Fe)``,Sm=et(Fe)``;import{jsx as _l}from"react/jsx-runtime";var A=({children:e,variant:t="primary",loading:o=!1,loadingComp:i="Loading...",...l})=>{let n=o||l.disabled,s=Tl(a("button"),{loading:o},t,l.className),d={disabled:n,className:s};function c(){return o?i:e}function m(){return _l(Fe,{...l,...d,children:c()})}return m()};import we from"classnames";import Ll from"styled-components";var Zo=Ll.div`
	border-radius: 10px;
	background-color: white;
	display: flex;

	&.column {
		max-width: 300px;
		flex-direction: column;
		.${a("card-media")} {
			width: 100%;
			object-fit: cover;
			max-height: 200px;
			border-radius: inherit;
			border-bottom-left-radius: 0;
			border-bottom-right-radius: 0;
		}
	}

	/* For flex row */
	&.row {
		max-width: 500px;
		flex-direction: row;
		.${a("card-media")} {
			min-height: 100%;
			object-fit: cover;
			max-width: 40%;
			border-radius: inherit;
			border-top-right-radius: 0;
			border-bottom-right-radius: 0;
		}
	}

	button {
		cursor: pointer;
		border: none;
		padding: 8px 16px;
		font-weight: 600;
		font-size: 14px;
		border-radius: 5px;
		transition: 0.2s;
		width: 100%;

		&:hover {
			opacity: 0.7;
		}
	}

	.${a("card-body")} {
		padding: 20px;
		display: flex;
		flex-direction: column;
		gap: 5px;

		small {
			color: #333;
			font-size: 12px;
			font-weight: 300;
		}

		.${a("card-title")} {
			color: #0c0f21;
			font-size: 18px;
			font-weight: 600;
		}

		.${a("card-subtitle")} {
			color: #949494;
			font-size: 14px;
			font-weight: 600;
		}

		p,
		.${a("card-description")} {
			color: #0c0f21;
			font-size: 14px;
			font-weight: 300;
		}
	}

	.${a("card-footer")} {
		padding: 0 20px 20px;
	}
`;import{jsx as Se}from"react/jsx-runtime";var zl=e=>Se(Zo,{...e,className:we(a("card"),e.className,{row:e.layout==="row",column:e.layout!=="row"}),children:e.children}),Nl=e=>Se("img",{...e,className:we(a("card-media"),e.className)}),Ml=e=>Se("div",{...e,className:we(a("card-body"),e.className),children:e.children}),Rl=e=>Se("h2",{...e,className:we(a("card-title"),e.className),children:e.children}),El=e=>Se("p",{...e,className:we(a("card-description"),e.className),children:e.children}),Fl=e=>Se("p",{...e,className:we(a("card-subtitle"),e.className),children:e.children}),Dl=e=>Se("div",{...e,className:we(a("card-footer"),e.className),children:e.children});import It from"classnames";import{v4 as Bl}from"uuid";import jo,{css as Al}from"styled-components";var Ko=jo.input`
	${()=>Al`
		position: relative;
		width: 25px;
		height: 25px;
		border: 2px solid var(${r.background500});
		border-radius: 2px;
		appearance: none;
		outline: 0;
		margin: 0;
		padding: 0;
		cursor: pointer;
		transition: 0.2s;

		&:hover {
			border: 2px solid var(${r.background300});
		}

		&::before {
			position: absolute;
			content: '';
			display: block;
			top: 50%;
			left: 50%;
			width: 30%;
			height: 65%;
			border-style: solid;
			border-color: #fff;
			border-width: 0 3px 3px 0;
			transform: translate(-50%, -60%) rotate(45deg);
			opacity: 0;
		}

		&:checked {
			color: #fff;
			border-color: var(${r.primary500});
			background: var(${r.primary500});

			&::before {
				opacity: 1;
			}

			~ label::before {
				clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
			}
		}

		&:disabled {
			color: var(${r.text900});
			border-color: var(${r.background800});
			background: var(${r.background800});

			~ label::before {
				clip-path: polygon(0 0, 0 0, 100% 0, 0 0);
			}

			&::before {
				content: '';
				position: absolute;
				display: block;
				top: 55%;
				left: 50%;
				width: 80%;
				border-style: solid;
				border-color: var(${r.background700});
				border-width: 0 0 3px;
				transform: translate(-50%, -100%) rotate(0);
				opacity: 1;
			}
		}
	`}
`,Qo=jo.div`
	display: flex;
	flex-wrap: wrap;
	gap: 20px;

	.${a("checkbox-group-option")} {
		display: inline-flex;
		align-items: center;
		justify-content: flex-start;
		gap: 5px;
		cursor: pointer;
	}
`;import{jsx as Pt,jsxs as Gl}from"react/jsx-runtime";var Jo=({...e})=>{let t={width:e.size||25,height:e.size||25};return Pt(Ko,{...e,type:"checkbox",className:It(a("checkbox"),e.className),onChange:o=>{var i;return(i=e.onChange)==null?void 0:i.call(e,o.target.checked)},style:{...e.style,...t}})},Hl=({options:e,onChange:t,multiple:o,...i})=>{let l=i.name||`checkbox-${Bl()}`,n=[];Array.isArray(i.value)?n=i.value:i.value&&(n=[i.value]);function s(d){let c;o?n.includes(d)?c=n.filter(m=>m!==d):c=[...n,d]:n.includes(d)||(c=d),t==null||t(c)}return Pt(Qo,{className:It(a("checkbox-group")),style:i.style,children:e.map(d=>{let c=n.includes(d.value);return Gl("span",{className:It(a("checkbox-group-option")),onClick:()=>s(d.value),children:[Pt(Jo,{...i,name:l,onChange:()=>{s(d.value)},checked:c}),d.label||d.value]},`checkbox-${l}-${d.value}`)})})};import{useEffect as Zl,useRef as jl,useState as Kl}from"react";import Ql from"lodash/debounce";import Jl from"classnames";import Wl,{css as Ol}from"styled-components";var er=Wl.textarea`
	${e=>Ol`
		resize: none;
		height: ${e.height}px;
		min-height: ${e.height}px;
		max-height: ${e.height}px;
		border: 1px solid var(${r.background300});
		background-color: transparent;
		color: var(${r.text500});
		outline: none;
		padding: 7px 10px;
		font-family: var(${r.primaryFont});
		transition: 0.2s;
		border-radius: 5px;
		line-height: 1.3;
		font-size: 1rem;
		flex: 1;

		&:focus {
			color: var(${r.text100});
			border-color: var(${r.primary500});
		}

		&:disabled {
			color: var(${r.text900});
			border-color: var(${r.text900});
		}

		::placeholder {
			color: var(${r.text700});
		}
	`}
`;import Vl from"validator/lib/isEmail";import Ul from"validator/lib/isURL";function tt(e){var i,l,n,s,d,c,m,p,f,v,k,$,b,q,h,u,x;if(!e.current)return;let t=(i=e.current)==null?void 0:i.value,o=((l=e.current)==null?void 0:l.type)||"text";if(!(!t.trim()||((n=e.current)==null?void 0:n.validity.valid))){if((d=(s=e.current)==null?void 0:s.validity)!=null&&d.tooShort)return"Text is too short";if((m=(c=e.current)==null?void 0:c.validity)!=null&&m.tooLong)return"Text is too long";if((f=(p=e.current)==null?void 0:p.validity)!=null&&f.rangeUnderflow)return"Value is too small";if((k=(v=e.current)==null?void 0:v.validity)!=null&&k.rangeOverflow)return"Value is too big";if((b=($=e.current)==null?void 0:$.validity)!=null&&b.typeMismatch)return"Invalid value";if((h=(q=e.current)==null?void 0:q.validity)!=null&&h.valueMissing)return"Field cannot remain empty";if(o==="email")return Vl(t)?void 0:"Invalid email";if(o==="url")return Ul(t||"")?void 0:"Invalid url";if(!((x=(u=e.current)==null?void 0:u.validity)!=null&&x.valid))return"Invalid input"}}import Yl from"styled-components";var tr=Yl.span`
  color: var(${r.error});
  font-size: 0.95rem;
  padding: 3px 5px 0;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  transform: translateY(100%);
`;import{jsx as Xl}from"react/jsx-runtime";var De=({text:e})=>Xl(tr,{className:a("form-input-error"),children:e});import{Fragment as en,jsx as or,jsxs as tn}from"react/jsx-runtime";var Tt=({showInvalidMessage:e=!0,...t})=>{let[o,i]=Kl(""),l=jl(),n=Ql(async d=>{i(tt(l)||"")},300),s=d=>{var c;(c=t.onChange)==null||c.call(t,d),n(d)};return Zl(()=>()=>{n.cancel()},[n,l]),tn(en,{children:[or(er,{ref:l,...t,onChange:e?s:t.onChange,placeholder:t.placeholder||"Enter text",height:t.height||80,className:Jl(a("textarea"),t.className)}),o&&or(De,{text:o})]})};import on,{css as rn}from"styled-components";var rr=on.div`
	${()=>rn`
		position: relative;

		textarea {
			width: 100%;
			height: 100%;
			max-height: 100%;
		}
	`}
`;import{jsx as ir}from"react/jsx-runtime";var an=({language:e,...t})=>ir(rr,{className:a("code-editor"),children:ir(Tt,{...t,value:t.value})});import ln,{css as nn}from"styled-components";var ar=ln.div`
	${({})=>nn`
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: stretch;

		> div {
			flex: 1;
		}
	`}
`;import{jsx as lr}from"react/jsx-runtime";var sn=({maxColors:e=4,...t})=>{function o(){return Array.from(new Set(t.colors.slice(0,e))).map((l,n)=>lr("div",{style:{backgroundColor:l}},l+n))}return lr(ar,{...t,children:o()})};import{FaUndoAlt as fn}from"@react-icons/all-files/fa/FaUndoAlt";import un,{Suspense as bn,useRef as gn,useState as hn}from"react";import*as me from"@radix-ui/react-popover";import sr from"classnames";import{useRef as dn}from"react";import{createGlobalStyle as cn}from"styled-components";var nr=cn`
  .${a("popover-content")} {
    z-index: 997;
  }

  div[data-radix-popper-content-wrapper] {
    z-index: 9999999 !important;
  }
`;import{Fragment as pn,jsx as Ae,jsxs as cr}from"react/jsx-runtime";var Be=e=>{let t=dn(null);return cr(pn,{children:[Ae(nr,{}),cr(me.Root,{open:e.open,onOpenChange:e.onOpenChange,children:[Ae(me.Trigger,{style:{background:"none",border:"none",padding:0,margin:0,...e.style},className:sr(a("popover-trigger"),e.className),onClick:o=>o.stopPropagation(),title:e.title||"",ref:t,asChild:!0,children:Ae("span",{children:e.children})}),Ae(me.Portal,{children:Ae(me.Content,{side:e.side,align:e.align,sideOffset:e.spacing||10,className:sr(a("popover-content")),onClick:()=>{var o;e.closeOnContentClick&&((o=t.current)==null||o.click())},children:e.contentElm})})]})]})};import dr,{css as mn}from"styled-components";var pr=dr.div`
	${()=>mn`
		position: relative;
		display: flex;
		align-items: center;
		gap: 10px;

		.selected-color {
			width: var(--size);
			height: var(--size);
			position: relative;
			border-radius: 3px;
			cursor: pointer;
			border: 1px solid var(${r.background300});
			overflow: hidden;

			&.none {
				&::before {
					content: '';
					position: absolute;
					left: 50%;
					top: 0;
					background: var(${r.background300});
					width: 1px;
					height: 100%;
					transform: rotate(45deg) scale(1.3);
				}
			}

			&::after {
				content: '';
				position: absolute;
				border-radius: 3px;
				left: 0;
				top: 0;
				background: linear-gradient(
					45deg,
					rgba(255, 255, 255, 0.1) 0%,
					rgba(255, 255, 255, 0.15) 30%,
					rgba(255, 255, 255, 0) 100%
				);
				width: 100%;
				height: 100%;
				opacity: 0;
				transition: 0.2s;
			}

			&:hover::after {
				opacity: 1;
			}
		}

		.undo {
			cursor: pointer;
			transition: 0.2s;
			font-size: 1.4rem;
			color: var(${r.text700});

			&:hover {
				color: var(${r.text500});
			}
		}
	`}
`,mr=dr.div`
	.sketch-picker {
		background: var(${r.background800}) !important;

		input {
			border: 1px solid var(${r.text700}) !important;
			box-shadow: none !important;
			background-color: transparent;
			color: var(${r.text500});
			outline: none;
			padding: 6px 10px;
			font-family: var(${r.primaryFont});
			transition: 0.2s;
			border-radius: 5px;
			line-height: 1;
			flex: 1;

			&:focus {
				color: var(${r.text100});
				border-color: var(${r.primary500});
			}

			::placeholder {
				color: var(${r.text700});
			}
		}

		label {
			color: var(${r.text500}) !important;
		}

		.flexbox-fix:last-child {
			border-top-color: var(${r.background500}) !important;
		}
	}
`;import{Fragment as yn,jsx as Ce,jsxs as vn}from"react/jsx-runtime";var xn=un.lazy(()=>import("react-color").then(e=>({default:e.SketchPicker}))),Le=e=>{let{onChange:t,position:o="left",showUndo:i=!0,disabled:l,enableTransparency:n=!0,defaultColor:s,selectedColor:d,colorFormat:c,debounce:m=0,size:p=35}=e,[f,v]=hn(!1),k=gn();function $(b,q){q==null||q.stopPropagation();let h="";if(b&&typeof b=="object"){let u=Math.round((b.rgb.a||1)*255).toString(16);u.length==1&&(u="0"+u),h=b.hex+u,c==="rgb"?h=`rgba(${b.rgb.r},${b.rgb.g},${b.rgb.b},${b.rgb.a})`:c==="hsl"&&(h=`hsla(${b.hsl.h},${b.hsl.s}%,${b.hsl.l}%,${b.hsl.a})`)}typeof b=="string"&&(h=b),t==null||t(h)}return vn(pr,{children:[i&&d&&Ce(fn,{size:20,className:"undo",title:"Restore to default",onClick:()=>$(s||"")}),Ce(Be,{open:f,contentElm:Ce(mr,{children:Ce(bn,{fallback:Ce(yn,{}),children:Ce(xn,{color:d,onChange:$,onChangeComplete:$,disableAlpha:!n})})}),onOpenChange:b=>{l||v(b)},side:o,children:Ce("div",{className:`selected-color ${!d||!d.length?"none":""}`,title:d?"Click to change":"Default color",style:{backgroundColor:d,"--size":`${p}px`},ref:k})})]})};import{FaMinus as zn}from"@react-icons/all-files/fa/FaMinus";import{FaPlus as Nn}from"@react-icons/all-files/fa/FaPlus";import{useEffect as Mn,useState as Rn}from"react";import Cn,{Suspense as $n}from"react";import{Fragment as kn,jsx as _t,jsxs as fr}from"react/jsx-runtime";var qn=(e,t,o)=>()=>fr(kn,{children:[_t("p",{style:{margin:0},children:_t("strong",{children:e})}),(t||o)&&fr("div",{style:{margin:0},children:[t,"\xA0",o]})]});function He(e){if(!e.message&&!e.title)return e.title;let t=qn(e.title,e.message,e.children);return _t(t,{})}var ot=class{toast;success(t){var o;(o=this.toast)==null||o.success(He(t),{autoClose:typeof t.autoDismiss=="number"?t.autoDismiss*1e3:!1,closeButton:!!t.autoDismiss,closeOnClick:!!t.autoDismiss,toastId:t.uid})}error(t){var o;(o=this.toast)==null||o.error(He(t),{autoClose:typeof t.autoDismiss=="number"?t.autoDismiss*1e3:!1,closeButton:!!t.autoDismiss,closeOnClick:!!t.autoDismiss,toastId:t.uid})}warning(t){var o;(o=this.toast)==null||o.warning(He(t),{autoClose:typeof t.autoDismiss=="number"?t.autoDismiss*1e3:!1,closeButton:!!t.autoDismiss,closeOnClick:!!t.autoDismiss,toastId:t.uid})}info(t){var o;(o=this.toast)==null||o.info(He(t),{autoClose:typeof t.autoDismiss=="number"?t.autoDismiss*1e3:!1,closeButton:!!t.autoDismiss,closeOnClick:!!t.autoDismiss,toastId:t.uid})}show(t){var o;(o=this.toast)==null||o.call(this,He(t),{autoClose:typeof t.autoDismiss=="number"?t.autoDismiss*1e3:!1,closeButton:!!t.autoDismiss,closeOnClick:!!t.autoDismiss,toastId:t.uid})}hide(t){var o;(o=this.toast)==null||o.dismiss(t)}removeAll(){var t;(t=this.toast)==null||t.dismiss()}};import wn,{css as Sn}from"styled-components";var ur=wn.div`
	${()=>Sn`
		--toastify-color-light: #fff;
		--toastify-color-dark: #121212;
		--toastify-color-info: #3498db;
		--toastify-color-success: #07bc0c;
		--toastify-color-warning: #f1c40f;
		--toastify-color-error: #e74c3c;
		--toastify-color-transparent: rgba(255, 255, 255, 0.7);
		--toastify-icon-color-info: var(--toastify-color-info);
		--toastify-icon-color-success: var(--toastify-color-success);
		--toastify-icon-color-warning: var(--toastify-color-warning);
		--toastify-icon-color-error: var(--toastify-color-error);
		--toastify-toast-background: #fff;
		--toastify-toast-min-height: 64px;
		--toastify-toast-max-height: 800px;
		--toastify-font-family: sans-serif;
		--toastify-z-index: 9999;
		--toastify-text-color-light: #757575;
		--toastify-text-color-dark: #fff;
		--toastify-toast-width: 420px;

		@media only screen and (max-width: 480px) {
			--toastify-toast-width: 300px;
		}

		//Used only for colored theme
		--toastify-text-color-info: #fff;
		--toastify-text-color-success: #fff;
		--toastify-text-color-warning: #fff;
		--toastify-text-color-error: #fff;

		--toastify-spinner-color: #616161;
		--toastify-spinner-color-empty-area: #e0e0e0;

		// Used when no type is provided
		// toast("**hello**")
		--toastify-color-progress-light: linear-gradient(
			to right,
			#4cd964,
			#5ac8fa,
			#007aff,
			#34aadc,
			#5856d6,
			#ff2d55
		);
		// Used when no type is provided
		--toastify-color-progress-dark: #bb86fc;
		--toastify-color-progress-info: var(--toastify-color-info);
		--toastify-color-progress-success: var(--toastify-color-success);
		--toastify-color-progress-warning: var(--toastify-color-warning);
		--toastify-color-progress-error: var(--toastify-color-error);

		// Default CSS
		.Toastify__toast-container {
			z-index: var(--toastify-z-index);
			-webkit-transform: translate3d(0, 0, var(--toastify-z-index) px);
			position: fixed;
			padding: 4px;
			width: var(--toastify-toast-width);
			box-sizing: border-box;
			color: #fff;
		}
		.Toastify__toast-container--top-left {
			top: 1em;
			left: 1em;
		}
		.Toastify__toast-container--top-center {
			top: 1em;
			left: 50%;
			transform: translateX(-50%);
		}
		.Toastify__toast-container--top-right {
			top: 1em;
			right: 1em;
		}
		.Toastify__toast-container--bottom-left {
			bottom: 1em;
			left: 1em;
		}
		.Toastify__toast-container--bottom-center {
			bottom: 1em;
			left: 50%;
			transform: translateX(-50%);
		}
		.Toastify__toast-container--bottom-right {
			bottom: 1em;
			right: 1em;
		}

		@media only screen and (max-width: 480px) {
			.Toastify__toast-container {
				width: 100vw;
				padding: 0;
				left: 0;
				margin: 0;
			}
			.Toastify__toast-container--top-left,
			.Toastify__toast-container--top-center,
			.Toastify__toast-container--top-right {
				top: 0;
				transform: translateX(0);
			}
			.Toastify__toast-container--bottom-left,
			.Toastify__toast-container--bottom-center,
			.Toastify__toast-container--bottom-right {
				bottom: 0;
				transform: translateX(0);
			}
			.Toastify__toast-container--rtl {
				right: 0;
				left: initial;
			}
		}
		.Toastify__toast {
			position: relative;
			min-height: var(--toastify-toast-min-height);
			box-sizing: border-box;
			margin-bottom: 1rem;
			padding: 8px;
			border-radius: 4px;
			box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1),
				0 2px 15px 0 rgba(0, 0, 0, 0.05);
			display: -ms-flexbox;
			display: flex;
			-ms-flex-pack: justify;
			justify-content: space-between;
			max-height: var(--toastify-toast-max-height);
			overflow: hidden;
			font-family: var(--toastify-font-family);
			cursor: default;
			direction: ltr;
			/* webkit only issue #791 */
			z-index: 0;
		}
		.Toastify__toast--rtl {
			direction: rtl;
		}
		.Toastify__toast--close-on-click {
			cursor: pointer;
		}
		.Toastify__toast-body {
			margin: auto 0;
			-ms-flex: 1 1 auto;
			flex: 1 1 auto;
			padding: 6px;
			display: -ms-flexbox;
			display: flex;
			-ms-flex-align: center;
			align-items: center;
		}
		.Toastify__toast-body > div:last-child {
			word-break: break-word;
			-ms-flex: 1;
			flex: 1;
		}
		.Toastify__toast-icon {
			-webkit-margin-end: 10px;
			margin-inline-end: 10px;
			width: 20px;
			-ms-flex-negative: 0;
			flex-shrink: 0;
			display: -ms-flexbox;
			display: flex;
		}

		.Toastify--animate {
			animation-fill-mode: both;
			animation-duration: 0.7s;
		}

		.Toastify--animate-icon {
			animation-fill-mode: both;
			animation-duration: 0.3s;
		}

		@media only screen and (max-width: 480px) {
			.Toastify__toast {
				margin-bottom: 0;
				border-radius: 0;
			}
		}
		.Toastify__toast-theme--dark {
			background: var(--toastify-color-dark);
			color: var(--toastify-text-color-dark);
		}
		.Toastify__toast-theme--light {
			background: var(--toastify-color-light);
			color: var(--toastify-text-color-light);
		}
		.Toastify__toast-theme--colored.Toastify__toast--default {
			background: var(--toastify-color-light);
			color: var(--toastify-text-color-light);
		}
		.Toastify__toast-theme--colored.Toastify__toast--info {
			color: var(--toastify-text-color-info);
			background: var(--toastify-color-info);
		}
		.Toastify__toast-theme--colored.Toastify__toast--success {
			color: var(--toastify-text-color-success);
			background: var(--toastify-color-success);
		}
		.Toastify__toast-theme--colored.Toastify__toast--warning {
			color: var(--toastify-text-color-warning);
			background: var(--toastify-color-warning);
		}
		.Toastify__toast-theme--colored.Toastify__toast--error {
			color: var(--toastify-text-color-error);
			background: var(--toastify-color-error);
		}

		.Toastify__progress-bar-theme--light {
			background: var(--toastify-color-progress-light);
		}
		.Toastify__progress-bar-theme--dark {
			background: var(--toastify-color-progress-dark);
		}
		.Toastify__progress-bar--info {
			background: var(--toastify-color-progress-info);
		}
		.Toastify__progress-bar--success {
			background: var(--toastify-color-progress-success);
		}
		.Toastify__progress-bar--warning {
			background: var(--toastify-color-progress-warning);
		}
		.Toastify__progress-bar--error {
			background: var(--toastify-color-progress-error);
		}
		.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,
		.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,
		.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,
		.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {
			background: var(--toastify-color-transparent);
		}

		.Toastify__close-button {
			color: #fff;
			background: transparent;
			outline: none;
			border: none;
			padding: 0;
			cursor: pointer;
			opacity: 0.7;
			transition: 0.3s ease;
			-ms-flex-item-align: start;
			align-self: flex-start;
		}
		.Toastify__close-button--light {
			color: #000;
			opacity: 0.3;
		}
		.Toastify__close-button > svg {
			fill: currentColor;
			height: 16px;
			width: 14px;
		}
		.Toastify__close-button:hover,
		.Toastify__close-button:focus {
			opacity: 1;
		}

		@keyframes Toastify__trackProgress {
			0% {
				transform: scaleX(1);
			}
			100% {
				transform: scaleX(0);
			}
		}
		.Toastify__progress-bar {
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 5px;
			z-index: var(--toastify-z-index);
			opacity: 0.7;
			transform-origin: left;
		}
		.Toastify__progress-bar--animated {
			animation: Toastify__trackProgress linear 1 forwards;
		}
		.Toastify__progress-bar--controlled {
			transition: transform 0.2s;
		}
		.Toastify__progress-bar--rtl {
			right: 0;
			left: initial;
			transform-origin: right;
		}

		.Toastify__spinner {
			width: 20px;
			height: 20px;
			box-sizing: border-box;
			border: 2px solid;
			border-radius: 100%;
			border-color: var(--toastify-spinner-color-empty-area);
			border-right-color: var(--toastify-spinner-color);
			animation: Toastify__spin 0.65s linear infinite;
		}

		@keyframes Toastify__bounceInRight {
			from,
			60%,
			75%,
			90%,
			to {
				animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
			}
			from {
				opacity: 0;
				transform: translate3d(3000px, 0, 0);
			}
			60% {
				opacity: 1;
				transform: translate3d(-25px, 0, 0);
			}
			75% {
				transform: translate3d(10px, 0, 0);
			}
			90% {
				transform: translate3d(-5px, 0, 0);
			}
			to {
				transform: none;
			}
		}
		@keyframes Toastify__bounceOutRight {
			20% {
				opacity: 1;
				transform: translate3d(-20px, 0, 0);
			}
			to {
				opacity: 0;
				transform: translate3d(2000px, 0, 0);
			}
		}
		@keyframes Toastify__bounceInLeft {
			from,
			60%,
			75%,
			90%,
			to {
				animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
			}
			0% {
				opacity: 0;
				transform: translate3d(-3000px, 0, 0);
			}
			60% {
				opacity: 1;
				transform: translate3d(25px, 0, 0);
			}
			75% {
				transform: translate3d(-10px, 0, 0);
			}
			90% {
				transform: translate3d(5px, 0, 0);
			}
			to {
				transform: none;
			}
		}
		@keyframes Toastify__bounceOutLeft {
			20% {
				opacity: 1;
				transform: translate3d(20px, 0, 0);
			}
			to {
				opacity: 0;
				transform: translate3d(-2000px, 0, 0);
			}
		}
		@keyframes Toastify__bounceInUp {
			from,
			60%,
			75%,
			90%,
			to {
				animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
			}
			from {
				opacity: 0;
				transform: translate3d(0, 3000px, 0);
			}
			60% {
				opacity: 1;
				transform: translate3d(0, -20px, 0);
			}
			75% {
				transform: translate3d(0, 10px, 0);
			}
			90% {
				transform: translate3d(0, -5px, 0);
			}
			to {
				transform: translate3d(0, 0, 0);
			}
		}
		@keyframes Toastify__bounceOutUp {
			20% {
				transform: translate3d(0, -10px, 0);
			}
			40%,
			45% {
				opacity: 1;
				transform: translate3d(0, 20px, 0);
			}
			to {
				opacity: 0;
				transform: translate3d(0, -2000px, 0);
			}
		}
		@keyframes Toastify__bounceInDown {
			from,
			60%,
			75%,
			90%,
			to {
				animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
			}
			0% {
				opacity: 0;
				transform: translate3d(0, -3000px, 0);
			}
			60% {
				opacity: 1;
				transform: translate3d(0, 25px, 0);
			}
			75% {
				transform: translate3d(0, -10px, 0);
			}
			90% {
				transform: translate3d(0, 5px, 0);
			}
			to {
				transform: none;
			}
		}
		@keyframes Toastify__bounceOutDown {
			20% {
				transform: translate3d(0, 10px, 0);
			}
			40%,
			45% {
				opacity: 1;
				transform: translate3d(0, -20px, 0);
			}
			to {
				opacity: 0;
				transform: translate3d(0, 2000px, 0);
			}
		}
		.Toastify__bounce-enter--top-left,
		.Toastify__bounce-enter--bottom-left {
			animation-name: Toastify__bounceInLeft;
		}
		.Toastify__bounce-enter--top-right,
		.Toastify__bounce-enter--bottom-right {
			animation-name: Toastify__bounceInRight;
		}
		.Toastify__bounce-enter--top-center {
			animation-name: Toastify__bounceInDown;
		}
		.Toastify__bounce-enter--bottom-center {
			animation-name: Toastify__bounceInUp;
		}

		.Toastify__bounce-exit--top-left,
		.Toastify__bounce-exit--bottom-left {
			animation-name: Toastify__bounceOutLeft;
		}
		.Toastify__bounce-exit--top-right,
		.Toastify__bounce-exit--bottom-right {
			animation-name: Toastify__bounceOutRight;
		}
		.Toastify__bounce-exit--top-center {
			animation-name: Toastify__bounceOutUp;
		}
		.Toastify__bounce-exit--bottom-center {
			animation-name: Toastify__bounceOutDown;
		}

		@keyframes Toastify__zoomIn {
			from {
				opacity: 0;
				transform: scale3d(0.3, 0.3, 0.3);
			}
			50% {
				opacity: 1;
			}
		}
		@keyframes Toastify__zoomOut {
			from {
				opacity: 1;
			}
			50% {
				opacity: 0;
				transform: scale3d(0.3, 0.3, 0.3);
			}
			to {
				opacity: 0;
			}
		}
		.Toastify__zoom-enter {
			animation-name: Toastify__zoomIn;
		}

		.Toastify__zoom-exit {
			animation-name: Toastify__zoomOut;
		}

		@keyframes Toastify__flipIn {
			from {
				transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
				animation-timing-function: ease-in;
				opacity: 0;
			}
			40% {
				transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
				animation-timing-function: ease-in;
			}
			60% {
				transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
				opacity: 1;
			}
			80% {
				transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
			}
			to {
				transform: perspective(400px);
			}
		}
		@keyframes Toastify__flipOut {
			from {
				transform: perspective(400px);
			}
			30% {
				transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
				opacity: 1;
			}
			to {
				transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
				opacity: 0;
			}
		}
		.Toastify__flip-enter {
			animation-name: Toastify__flipIn;
		}

		.Toastify__flip-exit {
			animation-name: Toastify__flipOut;
		}

		@keyframes Toastify__slideInRight {
			from {
				transform: translate3d(110%, 0, 0);
				visibility: visible;
			}
			to {
				transform: translate3d(0, 0, 0);
			}
		}
		@keyframes Toastify__slideInLeft {
			from {
				transform: translate3d(-110%, 0, 0);
				visibility: visible;
			}
			to {
				transform: translate3d(0, 0, 0);
			}
		}
		@keyframes Toastify__slideInUp {
			from {
				transform: translate3d(0, 110%, 0);
				visibility: visible;
			}
			to {
				transform: translate3d(0, 0, 0);
			}
		}
		@keyframes Toastify__slideInDown {
			from {
				transform: translate3d(0, -110%, 0);
				visibility: visible;
			}
			to {
				transform: translate3d(0, 0, 0);
			}
		}
		@keyframes Toastify__slideOutRight {
			from {
				transform: translate3d(0, 0, 0);
			}
			to {
				visibility: hidden;
				transform: translate3d(110%, 0, 0);
			}
		}
		@keyframes Toastify__slideOutLeft {
			from {
				transform: translate3d(0, 0, 0);
			}
			to {
				visibility: hidden;
				transform: translate3d(-110%, 0, 0);
			}
		}
		@keyframes Toastify__slideOutDown {
			from {
				transform: translate3d(0, 0, 0);
			}
			to {
				visibility: hidden;
				transform: translate3d(0, 500px, 0);
			}
		}
		@keyframes Toastify__slideOutUp {
			from {
				transform: translate3d(0, 0, 0);
			}
			to {
				visibility: hidden;
				transform: translate3d(0, -500px, 0);
			}
		}
		.Toastify__slide-enter--top-left,
		.Toastify__slide-enter--bottom-left {
			animation-name: Toastify__slideInLeft;
		}
		.Toastify__slide-enter--top-right,
		.Toastify__slide-enter--bottom-right {
			animation-name: Toastify__slideInRight;
		}
		.Toastify__slide-enter--top-center {
			animation-name: Toastify__slideInDown;
		}
		.Toastify__slide-enter--bottom-center {
			animation-name: Toastify__slideInUp;
		}

		.Toastify__slide-exit--top-left,
		.Toastify__slide-exit--bottom-left {
			animation-name: Toastify__slideOutLeft;
		}
		.Toastify__slide-exit--top-right,
		.Toastify__slide-exit--bottom-right {
			animation-name: Toastify__slideOutRight;
		}
		.Toastify__slide-exit--top-center {
			animation-name: Toastify__slideOutUp;
		}
		.Toastify__slide-exit--bottom-center {
			animation-name: Toastify__slideOutDown;
		}

		@keyframes Toastify__spin {
			from {
				transform: rotate(0deg);
			}
			to {
				transform: rotate(360deg);
			}
		}

		.premium-opener-trigger {
			font-weight: 700;
		}
	`}
`;import{Fragment as Tn,jsx as rt}from"react/jsx-runtime";var In=Cn.lazy(()=>import("react-toastify").then(e=>({default:e.ToastContainer}))),Pn=({position:e,closeButton:t,closeOnClick:o,draggable:i,limit:l})=>rt(ur,{children:rt($n,{fallback:rt(Tn,{}),children:rt(In,{position:e||"top-center",closeButton:t||!0,closeOnClick:o||!0,draggable:i||!1,limit:l||2,className:a("notifications")})})}),W=new ot;import("react-toastify").then(({toast:e})=>{W.toast=e});import _n,{css as Ln}from"styled-components";var br=_n.div`
	${()=>Ln`
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		gap: 10px;

		.${a("color-scheme-color")} {
			position: relative;

			.${a("color-scheme-remove-color")} {
				position: absolute;
				right: -8px;
				top: -7px;
				z-index: 1;
				padding: 0;
				margin: 0;
				border-radius: 50em;
				width: 18px;
				height: 18px;
				font-size: 0.8rem;
				border: none;
				display: flex;
				justify-content: center;
				align-items: center;
				opacity: 0;
				transition: 0.2s;
				cursor: pointer;
				background: var(${r.background500});
				color: var(${r.text300});

				&:hover {
					background: var(${r.background300});
					color: var(${r.text100});
				}
			}

			&:hover {
				.${a("color-scheme-remove-color")} {
					opacity: 1;
				}
			}
		}

		.${a("color-scheme-action-button")} {
			border: 1px dashed var(${r.background300});
			background: none;
			cursor: pointer;
			border-radius: 5px;
			color: var(${r.text500});
			font-size: 16px;
			height: 37px;
			width: 37px;
			min-width: 37px;
			transition: all 0.2s ease;
			display: flex;
			align-items: center;
			justify-content: center;

			&:hover {
				border-color: var(${r.background100});
				color: var(${r.text100});
			}
		}
	`}
`;import{jsx as Ge,jsxs as gr}from"react/jsx-runtime";var Lt=({colors:e,colorFormat:t,onChange:o,max:i=5})=>{let[l,n]=Rn([...e]);function s(){let p="0123456789ABCDEF",f="";for(let v=0;v<6;v++)f+=p[Math.floor(Math.random()*16)];return`#${f}`}function d(p,f){let v=[...l];v[p]=f,o==null||o(v)}function c(p){let f=[...l];f.splice(p,1),o==null||o(f)}function m(){if(l.length>i){W.removeAll(),W.error({title:`Maximum number of colors is ${i}`,autoDismiss:4.5});return}let p=[...l,s()];o==null||o(p)}return Mn(()=>{n(e)},[e]),gr(br,{children:[l.map((p,f)=>gr("div",{className:a("color-scheme-color"),children:[Ge(Le,{selectedColor:p||"",onChange:v=>d(f,v),colorFormat:t||"hex",debounce:0,enableTransparency:!0,showUndo:!1}),Ge("button",{className:a("color-scheme-remove-color"),onClick:()=>c(f),title:"Remove Color",children:Ge(zn,{size:10})})]},`color_scheme_${f}`)),l.length<i&&Ge("button",{onClick:m,className:a("color-scheme-action-button"),title:"Add Color",children:Ge(Nn,{})})]})};import{FaTimes as Gn}from"@react-icons/all-files/fa/FaTimes";import ze from"classnames";import{useEffect as kr,useState as wr}from"react";import{StyleSheetManager as Wn}from"styled-components";import En,{useEffect as hr}from"react";import Fn from"react-dom";import it,{css as Dn}from"styled-components";import{Fragment as Bn,jsx as Hn}from"react/jsx-runtime";var An=({className:e="",dynamicClassName:t,children:o})=>{if(typeof document>"u")return Hn(Bn,{});let i=a("popup-portal"),l=document.getElementById(i),[n]=En.useState(()=>{let d=document==null?void 0:document.createElement("div");return d.className=`${e||""} ${t||""}`,d});function s(d){return d.replace(/\.+$/,"")}return hr(()=>{if(!e)return;let d=s(`.${e.replace(/ /g,".")}`),c=l==null?void 0:l.querySelector(`#${i} ${d}`);c&&(c.className=`${e||""} ${t||""}`)},[t]),hr(()=>(l=document.getElementById(i),l||(l=document.createElement("div"),l.setAttribute("id",i),document.body.append(l)),l.appendChild(n),()=>{l.removeChild(n)}),[]),Fn.createPortal(o,n)},xr=it(An)`
	${({zIndex:e=990})=>Dn`
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: ${e};
		-webkit-font-smoothing: antialiased;

		* {
			box-sizing: border-box;
		}

		&.closed {
			display: none;
		}

		&.cn-embed-popup {
			.${a("popup-content-wrapper")} {
				background: none;
				background-color: transparent;
			}
		}

		.${a("popup-overlay")} {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			z-index: 995;
			background: rgba(0, 0, 0, 0.82);
			opacity: 0;
			transition: opacity 0.2s ease;
			display: block;

			&:has(.flip),
			&:has(.flip-newsletter),
			&:has(.tada) {
				perspective: 1300px;
			}

			&.faded-in {
				opacity: 1;
			}
		}

		.${a("popup-content-wrapper")} {
			z-index: 999;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: var(--popup-width, 100%);
			max-width: 95vw;
			max-height: 95vh;
			overflow: auto;
			border-radius: 10px;
			opacity: 0;
			transition: 0.2s;
			min-height: 100px;
			background: var(${r.background800});
			border: 1px solid var(${r.background500});
			color: var(${r.text100});
			-webkit-font-smoothing: antialiased;

			@media only screen and (max-width: 580px) {
				max-height: 80vh;
			}

			&.faded-in {
				opacity: 1;

				&.slide-bottom,
				&.slide-top,
				&.slide-left,
				&.slide-right {
					opacity: 1;
					top: 50%;
					left: 50%;
				}

				&.flip {
					opacity: 1;
					transform: translate(-50%, -50%) rotateX(0);
				}

				&.flip-newsletter {
					transform: translate(-50%, -50%) scale(1) rotate(0deg);
					opacity: 1;
				}

				&.scale-in {
					opacity: 1;
					transform: translate(-50%, -50%) scale(1);
				}
				&.scale-with-blur {
					opacity: 1;
					transform-origin: 50% 50%;
					transform: translate(-50%, -50%) scale(1, 1);
					filter: blur(0px);
				}

				&.slide-zoom-left,
				&.slide-zoom-right {
					opacity: 1;
					transform-origin: 0% 50%;
					transform: translate(-50%, -50%) scale(1);
				}
				&.slide-flip-right,
				&.slide-flip-left {
					opacity: 1;
					transform: translate(-50%, -50%);
				}
			}

			img {
				max-width: 100%;
			}

			&.slide-bottom {
				transition: all 0.7s;
				opacity: 0;
				top: -20%;
			}
			&.slide-top {
				transition: all 0.7s;
				opacity: 0;
				top: 120%;
			}
			&.slide-right {
				transition: all 0.7s;
				opacity: 0;
				left: -30%;
			}
			&.slide-left {
				transition: all 0.7s;
				opacity: 0;
				left: 120%;
			}

			&.tada {
				animation: tada-viewer 1s;
			}

			&.shake {
				animation: shake-viewer 1.2s;
			}

			&.pulse {
				animation: pulse-viewer 1.2s;
			}
			&.flicker {
				animation: flicker-viewer 1.3s;
			}
			&.bounce-top {
				animation: bounce-to-top-viewer 1.1s both;
				animation-timing-function: ease-in;
			}
			&.bounce-bottom {
				animation: bounce-to-bottom-viewer 1.1s both;
				animation-timing-function: ease-in;
			}
			&.bounce-right {
				animation: bounce-to-right-viewer 1.1s both;
				animation-timing-function: ease-in;
			}
			&.bounce-left {
				animation: bounce-to-left-viewer 1.1s both;
				animation-timing-function: ease-in;
			}
			&.scale-in {
				opacity: 0;
				transform: translate(-50%, -50%) scale(2);
				transition: all 0.7s;
			}
			&.scale-with-blur {
				opacity: 0;
				transform-origin: 50% 50%;
				transform: translate(-50%, -50%) scale(2, 2);
				filter: blur(90px);
				transition: all 0.7s;
			}
			&.flip {
				opacity: 0;
				transform-style: preserve-3d;
				transform: translate(-50%, -50%) rotateX(-70deg);
				transition: all 0.3s;
			}

			&.flip-newsletter {
				opacity: 0;
				transform: translate(-50%, -50%) scale(0) rotate(720deg);
				transition: all 0.3s;
			}

			&.slide-zoom-left {
				opacity: 0;
				transform: scale(0.2) translate(200%, 0%);
				transition: all 0.7s;
			}
			&.slide-zoom-right {
				opacity: 0;
				transform-origin: 0% 50%;
				transform: scale(0.2) translate(-200%, 0%);
				transition: all 0.7s;
			}
			&.slide-flip-left {
				transform-origin: 100% 50%;
				opacity: 0;
				transform: translate(-50%, -50%) rotateY(82deg);
				transition: all 0.7s;
			}
			&.slide-flip-right {
				transform-origin: 0 100%;
				opacity: 0;
				transform: translate(-50%, -50%) rotateY(82deg);
				transition: all 0.7s;
			}

			@keyframes tada-viewer {
				0% {
					opacity: 0;
					transform: translate(-50%, -50%) scaleX(1);
				}
				10%,
				20% {
					opacity: 0;
					transform: translate(-50%, -50%) scale3d(0.9, 0.9, 0.9) rotate(-3deg);
				}
				30%,
				50%,
				70%,
				90% {
					opacity: 1;
					transform: translate(-50%, -50%) scale3d(1.1, 1.1, 1.1) rotate(3deg);
				}
				40%,
				60%,
				80% {
					opacity: 1;
					transform: translate(-50%, -50%) scale3d(1.1, 1.1, 1.1) rotate(-3deg);
				}
				to {
					opacity: 1;
					transform: translate(-50%, -50%) scaleX(1);
				}
			}

			@keyframes shake-viewer {
				0% {
					opacity: 0;
				}
				0%,
				20% {
					transform: translateY(-50%) translateX(-56%);
				}

				25% {
					opacity: 1;
				}

				10%,
				30% {
					transform: translateY(-50%) translateX(-44%);
				}

				40%,
				60% {
					transform: translateY(-50%) translateX(-54%);
				}

				50%,
				70% {
					transform: translateY(-50%) translateX(-46%);
				}
				80% {
					transform: translateY(-50%) translateX(-52%);
				}
				90% {
					transform: translateY(-50%) translateX(-48%);
				}
				to {
					transform: translateY(-50%) translateX(-50%);
				}
			}

			@keyframes pulse-viewer {
				0% {
					opacity: 0;
				}
				10% {
					opacity: 0;
					transform: translate(-50%, -50%) scale(1.1);
				}

				13% {
					opacity: 1;
				}

				20% {
					opacity: 1;
					transform: translate(-50%, -50%) scale(1);
				}

				30% {
					opacity: 1;
					transform: translate(-50%, -50%) scale(1.1);
				}
			}

			@keyframes flicker-viewer {
				0%,
				10% {
					opacity: 0;
				}
				15% {
					opacity: 0.2;
				}

				25% {
					opacity: 0.8;
				}

				35% {
					opacity: 0.2;
				}
				45% {
					opacity: 0.8;
				}

				55% {
					opacity: 1;
				}
			}

			@keyframes bounce-to-bottom-viewer {
				0% {
					transform: translateX(-50%) translateY(calc(-50% - 500px));

					opacity: 0;
				}
				38% {
					transform: translateX(-50%) translateY(-50%);
					opacity: 1;
				}
				55% {
					transform: translateX(-50%) translateY(calc(-50% - 65px));
				}
				72% {
					transform: translateX(-50%) translateY(-50%);
				}
				81% {
					transform: translateX(-50%) translateY(calc(-50% - 28px));
				}
				90% {
					transform: translateX(-50%) translateY(-50%);
				}
				95% {
					transform: translateX(-50%) translateY(calc(-50% - 8px));
				}
				100% {
					transform: translateX(-50%) translateY(-50%);
				}
			}

			@keyframes bounce-to-left-viewer {
				0% {
					transform: translateY(-50%) translateX(calc(-50% + 600px));
					opacity: 0;
				}
				38% {
					transform: translateY(-50%) translateX(-50%);
					opacity: 1;
				}
				55% {
					transform: translateY(-50%) translateX(calc(-50% + 68px));
				}
				72% {
					transform: translateY(-50%) translateX(-50%);
				}
				81% {
					transform: translateY(-50%) translateX(calc(-50% + 32px));
				}
				90% {
					transform: translateY(-50%) translateX(-50%);
				}
				95% {
					transform: translateY(-50%) translateX(calc(-50% + 8px));
				}
				100% {
					transform: translateY(-50%) translateX(-50%);
				}
			}

			@keyframes bounce-to-right-viewer {
				0% {
					transform: translateY(-50%) translateX(calc(-50% - 600px));
					opacity: 0;
				}
				38% {
					transform: translateY(-50%) translateX(-50%);
					opacity: 1;
				}
				55% {
					transform: translateY(-50%) translateX(calc(-50% - 68px));
				}
				72% {
					transform: translateY(-50%) translateX(-50%);
				}
				81% {
					transform: translateY(-50%) translateX(calc(-50% - 28px));
				}
				90% {
					transform: translateY(-50%) translateX(-50%);
				}
				95% {
					transform: translateY(-50%) translateX(calc(-50% - 8px));
				}
				100% {
					transform: translateY(-50%) translateX(-50%);
				}
			}

			@keyframes bounce-to-top-viewer {
				0% {
					transform: translateX(-50%) translateY(calc(-50% + 500px));
					opacity: 0;
				}
				38% {
					transform: translateX(-50%) translateY(-50%);
					opacity: 1;
				}
				55% {
					transform: translateX(-50%) translateY(calc(-50% + 65px));
				}
				72% {
					transform: translateX(-50%) translateY(-50%);
				}
				81% {
					transform: translateX(-50%) translateY(calc(-50% + 28px));
				}
				90% {
					transform: translateX(-50%) translateY(-50%);
				}
				95% {
					transform: translateX(-50%) translateY(calc(-50% + 8px));
				}
				100% {
					transform: translateX(-50%) translateY(-50%);
				}
			}
		}

		.${a("close-popup")} {
			position: absolute;
			right: 5px;
			top: 10px;
			cursor: pointer;
			font-size: 18px;
			background: none;
			border: none;
			transition: 0.2s;
			z-index: 10;
			color: var(${r.text900});
			opacity: 1;

			&:hover {
				opacity: 0.8;
			}
		}
	`}
`,yr=it.h2`
	position: relative;
	font-weight: 600;
	font-size: 1.5rem;
	padding: 20px 0px;
	margin: 0 20px;
	border-bottom: 1px solid var(${r.background300});
`,vr=it.div`
	position: relative;
	font-size: 1rem;
	line-height: 1.5;
	padding: 20px;
`,qr=it.div`
	width: 100%;
	padding: 10px 20px 20px;
	position: relative;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 10px;
`;import{Fragment as On,jsx as fe,jsxs as Sr}from"react/jsx-runtime";var zt=e=>{let{className:t,animation:o,style:i,show:l,closeCallback:n,children:s,refCallback:d,openInBackground:c,width:m,closeButton:p=!0,overlayStyle:f,closeButtonStyle:v,closeButtonSize:k=20,disableCloseOnOverlayClick:$=!1}=e,[b,q]=wr(c&&!l?"closed":""),[h,u]=wr(!1),x=Object.assign({},i||{}),y=S=>{let{show:w,closeCallback:L}=e;w&&S.keyCode===27&&L(S)};return kr(()=>{if(!(typeof document>"u"))return document==null||document.addEventListener("keydown",y),()=>{document==null||document.removeEventListener("keydown",y)}},[]),kr(()=>{q(c&&!l?"closed":""),l?window.setTimeout(()=>{u(!0)},100):u(!1)},[l]),l||c?fe(Wn,{target:document.head,children:Sr(xr,{className:ze(a("popup"),t||""),dynamicClassName:b||"",zIndex:c?999:990,children:[fe("div",{style:f,className:ze(a("popup-overlay"),{"faded-in":h}),onClick:S=>{$||n(S)}}),Sr("div",{className:ze(a("popup-content-wrapper"),o||"",{"faded-in":h}),style:{"--popup-width":m,...x},ref:d,children:[s,p&&fe("button",{title:"Close",className:a("close-popup"),onClick:S=>n(S),style:v,children:fe(Gn,{size:k})})]})]})}):fe(On,{})},Nt=e=>fe(yr,{...e,className:ze(a("popup-title"),e.className),children:e.children}),Mt=e=>fe(vr,{...e,className:ze(a("popup-content"),e.className),children:e.children}),Rt=e=>fe(qr,{...e,className:ze(a("popup-buttons"),e.className),children:e.children});import Vn,{css as Un}from"styled-components";var Cr=Vn(zt)`
	${()=>Un`
		div.${a("popup-content-wrapper")} {
			width: 520px;
		}

		.${a("popup-title")} {
			padding-left: 10px;
			padding-right: 10px;
		}

		div.${a("popup-content")} {
			font-size: 16px;
			font-style: normal;
			font-weight: 400;
			line-height: 1.4;
			padding-left: 30px;
			padding-right: 30px;
		}

		div.${a("popup-buttons")} {
			justify-content: space-between;
			padding-left: 30px;
			padding-right: 30px;

			.${a("button")} {
				padding: 8px 20px;
				font-size: 14px;
				font-style: normal;
				font-weight: 500;
			}

			.transparent {
				padding-left: 0;
				padding-right: 0;
			}
		}
	`}
`;import{jsx as at,jsxs as $r}from"react/jsx-runtime";var Yn=({show:e=!1,closeCallback:t=()=>{},message:o="",title:i="Please Confirm",titleRenderer:l,messageRenderer:n,approveCallback:s,approveButtonText:d="Confirm",cancelButtonText:c="Cancel",approveButtonProps:m={},style:p})=>$r(Cr,{show:e,className:"confirmation-popup",closeCallback:t,children:[l||at(Nt,{children:i}),n||at(Mt,{children:o}),$r(Rt,{children:[at(A,{variant:"transparent",onClick:f=>t==null?void 0:t(f),children:c||"Cancel"}),at(A,{...m,onClick:f=>s==null?void 0:s(f),children:d||"Approve"})]})]});import jn from"classnames";import Xn,{css as Zn}from"styled-components";var Ir=Xn.section`
	${()=>Zn`
		position: relative;
		padding: 20px;
		border-bottom: 1px solid var(${r.background500});
		line-height: 1.5;
		
		&:last-of-type {
			border-bottom: none;
		}

		&.group {
			padding: 0 10px;
			margin-bottom: 0;
			border: 1px solid var(${r.background700});
			border-top: none;
			line-height: 1.5;

			p {
				line-height: 1.5;
			}

			&:first-of-type {
				margin-top: 10px;
			}

			.${a("context-section-title")} {
				margin: 0 0 0 -10px;
				padding: 6.5px 20px;
				border-radius: 0;
				background: var(${r.background600});
				font-size: 1rem;
				color: var(${r.text100});
				width: calc(100% + 20px);
			}

			> *:not(.${a("context-section-title")}) {
				padding: 0 10px;

				&:first-of-type {
					margin-top: 20px;
				}

				&:last-of-type {
					margin-bottom: 20px;
				}
			}
		}

		&:last-of-type {
			margin-bottom: 0;
		}
	`}
`;import{jsx as Qn}from"react/jsx-runtime";var Kn=e=>Qn(Ir,{...e,className:jn(a("context-section"),{group:e.group},e.className),children:e.children});import ts from"classnames";import Jn,{css as es}from"styled-components";var Pr=Jn.hgroup`
	${()=>es`
		position: relative;
		font-size: 1.2rem;
		color: var(${r.text000});
		margin: 0 0 20px;
		padding: 0;

		.${a("context-section-title-elm")} {
			position: relative;
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: inherit;
			color: inherit;
		}

		.${a("context-section-title-description")} {
			font-size: 0.9rem;
			color: var(${r.text100});
			line-height: 1.4;
			font-weight: 100;
			margin: 10px 0 20px;
		}
	`}
`;import{jsx as Tr,jsxs as os}from"react/jsx-runtime";var We=e=>os(Pr,{...e,className:ts(a("context-section-title"),e.className),children:[Tr("h4",{className:a("context-section-title-elm"),children:e.children}),e.description&&Tr("p",{className:a("context-section-title-description"),children:e.description})]});import as from"classnames";import rs,{css as is}from"styled-components";var _r=rs.div`
	${()=>is`
		position: relative;
		width: 100%;
		min-height: 100%;
		padding: 0;
		margin: 0;

		.${a("tabs")} { {
			position: sticky;
			top: 0;
			z-index: 10;
			background-color: var(${r.background700});
		}
	`}
`;import{jsx as ns}from"react/jsx-runtime";var ls=e=>ns(_r,{...e,className:as(a("context-wrapper"),e.className),children:e.children});import{MdContentCopy as ds}from"@react-icons/all-files/md/MdContentCopy";import zr from"classnames";import{useRef as Nr}from"react";import ss,{css as cs}from"styled-components";var Lr=ss.div`
	${()=>cs`
		position: relative;
		display: flex;
		align-items: center;
		gap: 10px;
		flex: 1;

		> *:not(.${a("copy-input-icon")}) {
			flex: 1;
		}

		.${a("copy-input-message")} {
			position: absolute;
			left: 50%;
			bottom: calc(100% - 10px);
			transform: translateX(-50%);
			padding: 2px 7px;
			border-radius: 5px;
			background-color: var(${r.background800});
			color: var(${r.text100});
			opacity: 0;
			transition: 0.2s;
			pointer-events: none;

			&::after {
				content: 'Copied';
			}
		}

		&.copied {
			.${a("copy-input-message")} {
				opacity: 1;
				bottom: calc(100% + 5px);
			}
		}

		.${a("copy-input-icon")} {
			color: var(${r.text500});
			background: none;
			font-size: 1.2rem;
			transition: 0.2s;
			cursor: pointer;

			&.floating {
				position: absolute;
				right: 7px;
				top: 7px;
				z-index: 1;
			}

			&:hover {
				color: var(${r.text100});
			}
		}

		&.copy-on-parent-click {
			transition: 0.2s;
			transition-delay: 0;
			cursor: pointer;

			.${a("copy-input-icon")} {
				&:hover {
					color: unset;
				}
				color: inherit;
				transition: none;
			}

			&:hover {
				color: var(${r.text100});
			}
		}
	`}
`;import{jsx as Et,jsxs as fs}from"react/jsx-runtime";var ps=({showIcon:e=!0,floatingIcon:t=!1,parentIsClickable:o=!1,isButton:i=!1,buttonProps:l,customCopyFunction:n,...s})=>{let[d]=ms(),c=Nr(null);function m(p){var f;p.stopPropagation(),d((c==null?void 0:c.current)||p.target,s.text,n),(f=s.onClick)==null||f.call(s,p)}return fs(Lr,{...s,ref:c,className:zr(a("copy-input"),s.className,{"copy-on-parent-click":o}),onClick:o?m:()=>{},children:[i?Et(A,{...l,onClick:o?()=>{}:m,children:s.children}):s.children,Et("div",{className:a("copy-input-message")}),e&&Et(ds,{className:zr(a("copy-input-icon"),{floating:t}),onClick:o?()=>{}:m})]})};function ms(e=1e3){let t=Nr();function o(n){n.classList.remove("copied"),window==null||window.clearTimeout(t.current),t.current=void 0}function i(n){var s;if(n){(s=n==null?void 0:n.classList)==null||s.add("copied"),t.current=window==null?void 0:window.setTimeout(o,e,n);return}}return[async(n,s,d)=>{var c;if(!(navigator!=null&&navigator.clipboard)){console.warn("Clipboard is not supported.");return}try{if(((c=n==null?void 0:n.classList)==null?void 0:c.contains("copied"))||t.current)return;d?d==null||d():await navigator.clipboard.writeText(s),i(n)}catch{if(d)d==null||d();else{let p=document.createElement("input");document.body.appendChild(p),p.value=s,p.select(),document.execCommand("copy"),p.remove()}i(n)}}]}import ys from"classnames";import Dr,{Suspense as vs}from"react";import gs from"classnames";import us,{css as bs}from"styled-components";var Mr=us.div`
  ${({id:e,size:t=80,color:o=""})=>{let i=o||`var(${r.primary500})`;return bs`
      /* position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%); */
      display: inline-block;
      width: ${t}px;
      height: ${t}px;
      position: relative;

      div {
        position: absolute;
        border: ${t/20}px solid ${i};
        opacity: 1;
        border-radius: 50%;
        animation: lds-ripple-${e} 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;

        &:nth-child(2) {
          animation-delay: -0.5s;
        }
      }

      @keyframes lds-ripple-${e} {
        0% {
          top: ${t/2}px;
          left: ${t/2}px;
          width: 0;
          height: 0;
          opacity: 1;
        }
        100% {
          top: 0px;
          left: 0px;
          width: ${t}px;
          height: ${t}px;
          opacity: 0;
        }
      }
    `}}
`;import{jsx as Rr,jsxs as hs}from"react/jsx-runtime";var J=e=>hs(Mr,{...e,className:gs(a("loader"),e.className),id:`loader-${Date.now()}`,children:[Rr("div",{}),Rr("div",{})]});import xs from"styled-components";var Er=xs.div`
	flex: 1;
	position: relative;

	// Slider CSS
	.rc-slider {
		position: relative;
		height: 14px;
		padding: 5px 0;
		width: 100%;
		border-radius: 6px;
		touch-action: none;
		box-sizing: border-box;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	}
	.rc-slider * {
		box-sizing: border-box;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	}
	.rc-slider-rail {
		position: absolute;
		width: 100%;
		background-color: #e9e9e9;
		height: 4px;
		border-radius: 6px;
	}
	.rc-slider-track {
		position: absolute;
		left: 0;
		height: 4px;
		border-radius: 6px;
		background-color: #abe2fb;
	}
	.rc-slider-handle {
		position: absolute;
		width: 14px;
		height: 14px;
		cursor: pointer;
		cursor: -webkit-grab;
		margin-top: -5px;
		cursor: grab;
		border-radius: 50%;
		border: solid 2px #96dbfa;
		background-color: #fff;
		touch-action: pan-x;
	}
	.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {
		border-color: #57c5f7;
		box-shadow: 0 0 0 5px #96dbfa;
	}
	.rc-slider-handle:focus {
		outline: none;
	}
	.rc-slider-handle-click-focused:focus {
		border-color: #96dbfa;
		box-shadow: unset;
	}
	.rc-slider-handle:hover {
		border-color: #57c5f7;
	}
	.rc-slider-handle:active {
		border-color: #57c5f7;
		box-shadow: 0 0 5px #57c5f7;
		cursor: -webkit-grabbing;
		cursor: grabbing;
	}
	.rc-slider-mark {
		position: absolute;
		top: 18px;
		left: 0;
		width: 100%;
		font-size: 12px;
	}
	.rc-slider-mark-text {
		position: absolute;
		display: inline-block;
		vertical-align: middle;
		text-align: center;
		cursor: pointer;
		color: #999;
	}
	.rc-slider-mark-text-active {
		color: #666;
	}
	.rc-slider-step {
		position: absolute;
		width: 100%;
		height: 4px;
		background: transparent;
	}
	.rc-slider-dot {
		position: absolute;
		bottom: -2px;
		margin-left: -4px;
		width: 8px;
		height: 8px;
		border: 2px solid #e9e9e9;
		background-color: #fff;
		cursor: pointer;
		border-radius: 50%;
		vertical-align: middle;
	}
	.rc-slider-dot-active {
		border-color: #96dbfa;
	}
	.rc-slider-dot-reverse {
		margin-right: -4px;
	}
	.rc-slider-disabled {
		background-color: #e9e9e9;
	}
	.rc-slider-disabled .rc-slider-track {
		background-color: #ccc;
	}
	.rc-slider-disabled .rc-slider-handle,
	.rc-slider-disabled .rc-slider-dot {
		border-color: #ccc;
		box-shadow: none;
		background-color: #fff;
		cursor: not-allowed;
	}
	.rc-slider-disabled .rc-slider-mark-text,
	.rc-slider-disabled .rc-slider-dot {
		cursor: not-allowed !important;
	}
	.rc-slider-vertical {
		width: 14px;
		height: 100%;
		padding: 0 5px;
	}
	.rc-slider-vertical .rc-slider-rail {
		height: 100%;
		width: 4px;
	}
	.rc-slider-vertical .rc-slider-track {
		left: 5px;
		bottom: 0;
		width: 4px;
	}
	.rc-slider-vertical .rc-slider-handle {
		margin-left: -5px;
		touch-action: pan-y;
	}
	.rc-slider-vertical .rc-slider-mark {
		top: 0;
		left: 18px;
		height: 100%;
	}
	.rc-slider-vertical .rc-slider-step {
		height: 100%;
		width: 4px;
	}
	.rc-slider-vertical .rc-slider-dot {
		left: 2px;
		margin-bottom: -4px;
	}
	.rc-slider-vertical .rc-slider-dot:first-child {
		margin-bottom: -4px;
	}
	.rc-slider-vertical .rc-slider-dot:last-child {
		margin-bottom: -4px;
	}
	.rc-slider-tooltip-zoom-down-enter,
	.rc-slider-tooltip-zoom-down-appear {
		animation-duration: 0.3s;
		animation-fill-mode: both;
		display: block !important;
		animation-play-state: paused;
	}
	.rc-slider-tooltip-zoom-down-leave {
		animation-duration: 0.3s;
		animation-fill-mode: both;
		display: block !important;
		animation-play-state: paused;
	}
	.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,
	.rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active {
		animation-name: rcSliderTooltipZoomDownIn;
		animation-play-state: running;
	}
	.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active {
		animation-name: rcSliderTooltipZoomDownOut;
		animation-play-state: running;
	}
	.rc-slider-tooltip-zoom-down-enter,
	.rc-slider-tooltip-zoom-down-appear {
		transform: scale(0, 0);
		animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
	}
	.rc-slider-tooltip-zoom-down-leave {
		animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
	}
	@keyframes rcSliderTooltipZoomDownIn {
		0% {
			opacity: 0;
			transform-origin: 50% 100%;
			transform: scale(0, 0);
		}
		100% {
			transform-origin: 50% 100%;
			transform: scale(1, 1);
		}
	}
	@keyframes rcSliderTooltipZoomDownOut {
		0% {
			transform-origin: 50% 100%;
			transform: scale(1, 1);
		}
		100% {
			opacity: 0;
			transform-origin: 50% 100%;
			transform: scale(0, 0);
		}
	}
	.rc-slider-tooltip {
		position: absolute;
		left: -9999px;
		top: -9999px;
		visibility: visible;
		box-sizing: border-box;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	}
	.rc-slider-tooltip * {
		box-sizing: border-box;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	}
	.rc-slider-tooltip-hidden {
		display: none;
	}
	.rc-slider-tooltip-placement-top {
		padding: 4px 0 8px 0;
	}
	.rc-slider-tooltip-inner {
		padding: 6px 2px;
		min-width: 24px;
		height: 24px;
		font-size: 12px;
		line-height: 1;
		color: #fff;
		text-align: center;
		text-decoration: none;
		background-color: #6c6c6c;
		border-radius: 6px;
		box-shadow: 0 0 4px #d9d9d9;
	}
	.rc-slider-tooltip-arrow {
		position: absolute;
		width: 0;
		height: 0;
		border-color: transparent;
		border-style: solid;
	}
	.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {
		bottom: 4px;
		left: 50%;
		margin-left: -4px;
		border-width: 4px 4px 0;
		border-top-color: #6c6c6c;
	}

	// Custom
	width: 100%;

	.${a("slider-tooltip")} {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translate(-50%, -100%);
		z-index: 9999;
		font-size: 0.8rem;
		line-height: 1.5;
		opacity: 0.9;
		user-select: none;
		visibility: hidden;
		opacity: 0;
		transition: all ease-in-out 150ms;

		&.active {
			visibility: visible;
			opacity: 1;
			top: -10px;
		}

		.${a("slider-tooltip-inner")} {
			display: block;
			text-align: center;
			color: var(${r.text100});
			background-color: var(${r.background500});
			text-decoration: none;
			border-radius: 5px;
			position: relative;
			font-weight: bold;
			user-select: none;
			padding: 5px 10px;
			font-size: 0.95rem;
			font-weight: 400;

			.${a("slider-tooltip-after")} {
				position: absolute;
				width: 0;
				height: 0;
				border-color: transparent;
				border-style: solid;
				border-width: 5px 5px 0;
				border-top-color: var(${r.background500});
				left: 50%;
				bottom: 0;
				transform: translate(-50%, 100%);
			}
		}
	}
`,ue={railStyle:{backgroundColor:`var(${r.background300})`},dotStyle:{borderColor:`var(${r.background300})`},activeDotStyle:{borderColor:`var(${r.background100})`},trackStyle:{backgroundColor:`var(${r.primary500})`},handleStyle:{borderColor:`var(${r.background700})`,backgroundColor:`var(${r.primary500})`,opacity:1,borderWidth:"1px",boxShadow:"none"},markStyle:{color:`var(${r.primary500})`},tooltipStyle:{}};import{jsx as be,jsxs as ks}from"react/jsx-runtime";var qs=Dr.lazy(()=>import("rc-slider").then(e=>({default:e.default}))),Fr=Dr.lazy(()=>import("rc-slider").then(e=>({default:e.Handle}))),Ft=e=>{let{min:t=0,max:o=100,step:i=1,disabled:l=!1,marks:n,dots:s,value:d=0,tooltipFormatter:c,disableTooltip:m=!1,styles:p,onChange:f}=e,v={...ue.railStyle,...(p==null?void 0:p.railStyle)||{}},k={...ue.dotStyle,...(p==null?void 0:p.dotStyle)||{}},$={...ue.activeDotStyle,...(p==null?void 0:p.activeDotStyle)||{}},b={...ue.tooltipStyle,...(p==null?void 0:p.tooltipStyle)||{}},q={...ue.handleStyle,...(p==null?void 0:p.handleStyle)||{}},h={...ue.trackStyle,...(p==null?void 0:p.trackStyle)||{}},u={};n&&Object.keys(n).forEach(S=>{u[S]={label:n[S],style:{...ue.markStyle,...(p==null?void 0:p.markStyle)||{}}}});function x(S){let{value:w,dragging:L,index:Y,...B}=S;return m?be(Fr,{value:w,...B}):be(Fr,{value:w,...B,children:be("div",{className:ys(a("slider-tooltip"),{active:L}),children:ks("span",{className:a("slider-tooltip-inner"),style:{...b},children:[c?c(w):w,be("span",{className:a("slider-tooltip-after"),style:{borderTopColor:b.backgroundColor||""}})]})})})}function y(S){f==null||f(S)}return be(Er,{className:a("slider"),children:be(vs,{fallback:be(J,{size:14}),children:be(qs,{min:t,max:o,step:i,disabled:l,dots:s,value:d,marks:u,railStyle:v,dotStyle:k,activeDotStyle:$,handleStyle:q,trackStyle:h,handle:x,onChange:y})})})};import{jsx as Dt,jsxs as ws}from"react/jsx-runtime";var Ar=()=>ws("svg",{width:"14",height:"20",viewBox:"0 0 14 20",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[Dt("rect",{x:"8",width:"20",height:"2",rx:"1",transform:"rotate(90 8 0)",fill:"currentColor"}),Dt("rect",{x:"12",y:"11",width:"6",height:"10",rx:"1",transform:"rotate(90 12 11)",fill:"currentColor"}),Dt("rect",{x:"14",y:"4",width:"6",height:"14",rx:"1",transform:"rotate(90 14 4)",fill:"currentColor"})]});import{jsx as At,jsxs as Ss}from"react/jsx-runtime";var Br=()=>Ss("svg",{width:"18",height:"20",viewBox:"0 0 18 20",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[At("rect",{x:"14",y:"11",width:"6",height:"10",rx:"1",transform:"rotate(90 14 11)",fill:"currentColor"}),At("rect",{x:"18",y:"4",width:"6",height:"14",rx:"1",transform:"rotate(90 18 4)",fill:"currentColor"}),At("rect",{x:"2",width:"20",height:"2",rx:"1",transform:"rotate(90 2 0)",fill:"currentColor"})]});import{jsx as Bt,jsxs as Cs}from"react/jsx-runtime";var Hr=()=>Cs("svg",{width:"18",height:"20",viewBox:"0 0 18 20",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[Bt("rect",{x:"18",width:"20",height:"2",rx:"1",transform:"rotate(90 18 0)",fill:"currentColor"}),Bt("rect",{x:"14",y:"11",width:"6",height:"10",rx:"1",transform:"rotate(90 14 11)",fill:"currentColor"}),Bt("rect",{x:"14",y:"4",width:"6",height:"14",rx:"1",transform:"rotate(90 14 4)",fill:"currentColor"})]});import{jsx as Gr,jsxs as $s}from"react/jsx-runtime";var Wr=()=>$s("svg",{width:"17",height:"17",viewBox:"0 0 17 17",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[Gr("path",{d:"M16 12L16 2C16 1.44772 15.5523 1 15 1L2 0.999999C1.44772 0.999999 1 1.44771 1 2L1 12",stroke:"#4D5265",strokeWidth:"2",strokeLinecap:"round"}),Gr("path",{d:"M1 16L16 16",stroke:"#5c5ef9",strokeWidth:"2",strokeLinecap:"round"})]});import{jsx as Or,jsxs as Is}from"react/jsx-runtime";var Vr=()=>Is("svg",{width:"17",height:"17",viewBox:"0 0 17 17",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[Or("path",{d:"M5 16L15 16C15.5523 16 16 15.5523 16 15L16 2C16 1.44771 15.5523 1 15 1L5 1",stroke:"#4D5265",strokeWidth:"2",strokeLinecap:"round"}),Or("path",{d:"M1 1L1 16",stroke:"#5c5ef9",strokeWidth:"2",strokeLinecap:"round"})]});import{jsx as Ur,jsxs as Ps}from"react/jsx-runtime";var Yr=()=>Ps("svg",{width:"17",height:"17",viewBox:"0 0 17 17",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[Ur("path",{d:"M12 1L2 1C1.44772 1 1 1.44771 1 2L0.999999 15C0.999999 15.5523 1.44771 16 2 16L12 16",stroke:"#4D5265",strokeWidth:"2",strokeLinecap:"round"}),Ur("path",{d:"M16 16L16 1",stroke:"#5c5ef9",strokeWidth:"2",strokeLinecap:"round"})]});import{jsx as Xr,jsxs as Ts}from"react/jsx-runtime";var Zr=()=>Ts("svg",{width:"17",height:"17",viewBox:"0 0 17 17",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[Xr("path",{d:"M1 5V15C1 15.5523 1.44772 16 2 16H15C15.5523 16 16 15.5523 16 15V5",stroke:"#4D5265",strokeWidth:"2",strokeLinecap:"round"}),Xr("path",{d:"M16 1L1 1",stroke:"#5c5ef9",strokeWidth:"2",strokeLinecap:"round"})]});import{jsx as jr}from"react/jsx-runtime";var Kr=()=>jr("svg",{width:"16",height:"13",viewBox:"0 0 16 13",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:jr("path",{d:"M5.964 7.404H2.628L2.076 9H0.312L3.324 0.611999H5.28L8.292 9H6.516L5.964 7.404ZM5.508 6.06L4.296 2.556L3.084 6.06H5.508ZM12.0218 2.244C12.5178 2.244 12.9538 2.344 13.3298 2.544C13.7058 2.736 14.0018 2.988 14.2178 3.3V2.352H15.9098V9.048C15.9098 9.664 15.7858 10.212 15.5378 10.692C15.2898 11.18 14.9178 11.564 14.4218 11.844C13.9258 12.132 13.3258 12.276 12.6218 12.276C11.6778 12.276 10.9018 12.056 10.2938 11.616C9.69384 11.176 9.35384 10.576 9.27384 9.816H10.9418C11.0298 10.12 11.2178 10.36 11.5058 10.536C11.8018 10.72 12.1578 10.812 12.5738 10.812C13.0618 10.812 13.4578 10.664 13.7618 10.368C14.0658 10.08 14.2178 9.64 14.2178 9.048V8.016C14.0018 8.328 13.7018 8.588 13.3178 8.796C12.9418 9.004 12.5098 9.108 12.0218 9.108C11.4618 9.108 10.9498 8.964 10.4858 8.676C10.0218 8.388 9.65384 7.984 9.38184 7.464C9.11784 6.936 8.98584 6.332 8.98584 5.652C8.98584 4.98 9.11784 4.384 9.38184 3.864C9.65384 3.344 10.0178 2.944 10.4738 2.664C10.9378 2.384 11.4538 2.244 12.0218 2.244ZM14.2178 5.676C14.2178 5.268 14.1378 4.92 13.9778 4.632C13.8178 4.336 13.6018 4.112 13.3298 3.96C13.0578 3.8 12.7658 3.72 12.4538 3.72C12.1418 3.72 11.8538 3.796 11.5898 3.948C11.3258 4.1 11.1098 4.324 10.9418 4.62C10.7818 4.908 10.7018 5.252 10.7018 5.652C10.7018 6.052 10.7818 6.404 10.9418 6.708C11.1098 7.004 11.3258 7.232 11.5898 7.392C11.8618 7.552 12.1498 7.632 12.4538 7.632C12.7658 7.632 13.0578 7.556 13.3298 7.404C13.6018 7.244 13.8178 7.02 13.9778 6.732C14.1378 6.436 14.2178 6.084 14.2178 5.676Z",fill:"currentColor"})});import{jsx as Qr,jsxs as _s}from"react/jsx-runtime";var Jr=()=>_s("svg",{width:"17",height:"17",viewBox:"0 0 17 17",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[Qr("rect",{x:"1",y:"16",width:"15",height:"15",rx:"2.5",transform:"rotate(-90 1 16)",stroke:"#4D5265",strokeWidth:"2"}),Qr("path",{d:"M1 8L1 13.5C1 14.8807 2.11929 16 3.5 16L9.5 16",stroke:"#5c5ef9",strokeWidth:"2",strokeLinecap:"round"})]});import{jsx as ei,jsxs as Ls}from"react/jsx-runtime";var ti=()=>Ls("svg",{width:"17",height:"17",viewBox:"0 0 17 17",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[ei("rect",{x:"16",y:"16",width:"15",height:"15",rx:"2.5",transform:"rotate(-180 16 16)",stroke:"#4D5265",strokeWidth:"2"}),ei("path",{d:"M8 16L13.5 16C14.8807 16 16 14.8807 16 13.5L16 7.5",stroke:"#5c5ef9",strokeWidth:"2",strokeLinecap:"round"})]});import{jsx as oi,jsxs as zs}from"react/jsx-runtime";var ri=()=>zs("svg",{width:"17",height:"17",viewBox:"0 0 17 17",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[oi("rect",{x:"1",y:"1",width:"15",height:"15",rx:"2.5",stroke:"#4D5265",strokeWidth:"2"}),oi("path",{d:"M9 1H3.5C2.11929 1 1 2.11929 1 3.5V9.5",stroke:"#5c5ef9",strokeWidth:"2",strokeLinecap:"round"})]});import{jsx as ii,jsxs as Ns}from"react/jsx-runtime";var ai=()=>Ns("svg",{width:"17",height:"17",viewBox:"0 0 17 17",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[ii("rect",{x:"16",y:"1",width:"15",height:"15",rx:"2.5",transform:"rotate(90 16 1)",stroke:"#4D5265",strokeWidth:"2"}),ii("path",{d:"M16 9L16 3.5C16 2.11929 14.8807 1 13.5 1L7.5 1",stroke:"#5c5ef9",strokeWidth:"2",strokeLinecap:"round"})]});import{jsx as Ht,jsxs as Ms}from"react/jsx-runtime";var li=()=>Ms("svg",{width:"17",height:"17",viewBox:"0 0 17 17",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[Ht("path",{d:"M9.72117 9.55937L8.89688 7.09471C8.83582 6.93823 8.77069 6.75498 8.70149 6.54495C8.63229 6.33082 8.56309 6.10021 8.49389 5.85312C8.43284 6.10432 8.36771 6.33699 8.29851 6.55113C8.22931 6.76527 8.16418 6.95058 8.10312 7.10707L7.28494 9.55937H9.72117ZM13 13H11.4003C11.2212 13 11.0767 12.9588 10.9668 12.8765C10.8569 12.79 10.7734 12.6809 10.7164 12.5491L10.1913 10.9801H6.80868L6.28358 12.5491C6.23881 12.6644 6.15739 12.7694 6.03935 12.8641C5.92537 12.9547 5.7829 13 5.61194 13H4L7.44369 4H9.55631L13 13Z",fill:"currentColor"}),Ht("path",{d:"M16 1V16",stroke:"#5c5ef9",strokeWidth:"2",strokeLinecap:"round"}),Ht("path",{d:"M1 1V16",stroke:"#5c5ef9",strokeWidth:"2",strokeLinecap:"round"})]});import{jsx as ni,jsxs as Rs}from"react/jsx-runtime";var si=()=>Rs("svg",{width:"14",height:"16",viewBox:"0 0 14 16",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[ni("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M10.2021 3.81754C11.1969 3.81754 11.8187 3.03158 11.8187 2.18947C11.8187 0.449123 8.39896 0 7.09326 0C3.92228 0 1.12435 1.90877 1.12435 4.94035C1.12435 5.33163 1.17245 5.68317 1.2612 6H7.21765C5.95082 5.66166 4.97927 5.32892 4.97927 4.54737C4.97927 3.64912 5.91192 3.14386 6.96891 3.14386C7.7904 3.14386 8.38577 3.34803 8.92099 3.53157C9.358 3.68143 9.75491 3.81754 10.2021 3.81754ZM12.9148 10H8.53809C8.91713 10.2509 9.14508 10.5682 9.14508 11.0035C9.14508 12.0702 8.27461 12.8561 6.65803 12.8561C5.81714 12.8561 5.03084 12.6097 4.30897 12.3835C3.69645 12.1915 3.13031 12.014 2.61658 12.014C1.62176 12.014 1 12.7439 1 13.586C1 15.607 4.97927 16 6.84456 16C10.1399 16 13 14.0351 13 10.9474C13 10.6063 12.9704 10.2913 12.9148 10Z",fill:"currentColor"}),ni("rect",{y:"7",width:"14",height:"2",rx:"1",fill:"currentColor"})]});import{jsx as Gt,jsxs as Es}from"react/jsx-runtime";var ci=()=>Es("svg",{width:"17",height:"17",viewBox:"0 0 17 17",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[Gt("path",{d:"M16 16L1 16",stroke:"#5c5ef9",strokeWidth:"2",strokeLinecap:"round"}),Gt("path",{d:"M16 1L1 0.999999",stroke:"#5c5ef9",strokeWidth:"2",strokeLinecap:"round"}),Gt("path",{d:"M9.72117 9.55937L8.89688 7.09471C8.83582 6.93823 8.77069 6.75498 8.70149 6.54495C8.63229 6.33082 8.56309 6.10021 8.49389 5.85312C8.43284 6.10432 8.36771 6.33699 8.29851 6.55113C8.22931 6.76527 8.16418 6.95058 8.10312 7.10707L7.28494 9.55937H9.72117ZM13 13H11.4003C11.2212 13 11.0767 12.9588 10.9668 12.8765C10.8569 12.79 10.7734 12.6809 10.7164 12.5491L10.1913 10.9801H6.80868L6.28358 12.5491C6.23881 12.6644 6.15739 12.7694 6.03935 12.8641C5.92537 12.9547 5.7829 13 5.61194 13H4L7.44369 4H9.55631L13 13Z",fill:"currentColor"})]});import{jsx as Wt,jsxs as Fs}from"react/jsx-runtime";var di=()=>Fs("svg",{width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[Wt("path",{d:"M10.7818 13.8168L7.7169 16.8824C7.7169 16.8824 7.7169 16.8824 7.71683 16.8824C7.71683 16.8824 7.71683 16.8825 7.71676 16.8825C6.44934 18.1502 4.38697 18.1503 3.11941 16.8825C2.50536 16.2683 2.16726 15.4518 2.16726 14.5833C2.16726 13.7149 2.50536 12.8985 3.1192 12.2843C3.11927 12.2843 3.11934 12.2842 3.11941 12.2841L6.18429 9.21858C6.60741 8.7953 6.60741 8.10902 6.18421 7.68581C5.76109 7.26261 5.07494 7.26261 4.65174 7.68581L1.58687 10.7513C1.58665 10.7516 1.58644 10.7519 1.58622 10.7521C0.563344 11.7755 0 13.1362 0 14.5833C0 16.0308 0.563561 17.3917 1.58694 18.4153C2.64327 19.4717 4.03068 20 5.41816 20C6.80564 20 8.19312 19.4717 9.2493 18.4153C9.24937 18.4153 9.24938 18.4151 9.24938 18.4151L12.3142 15.3496C12.7374 14.9264 12.7374 14.2401 12.3142 13.8168C11.8911 13.3936 11.205 13.3936 10.7818 13.8168Z"}),Wt("path",{d:"M20 5.41661C20 3.9691 19.4364 2.60823 18.413 1.58465C16.3005 -0.528254 12.8632 -0.528182 10.7508 1.58465C10.7507 1.5848 10.7506 1.58487 10.7505 1.58502L7.6858 4.65033C7.26261 5.07353 7.26261 5.75989 7.6858 6.1831C7.89746 6.39481 8.17472 6.50059 8.45205 6.50059C8.72931 6.50059 9.00672 6.39473 9.21824 6.1831L12.283 3.11778C12.283 3.11764 12.2832 3.11756 12.2833 3.11742C13.5507 1.84976 15.613 1.84969 16.8806 3.11742C17.4945 3.7316 17.8328 4.54816 17.8328 5.41661C17.8328 6.28498 17.4947 7.1014 16.8808 7.71557L16.8806 7.71579L13.8158 10.7813C13.3927 11.2045 13.3927 11.8908 13.8158 12.3141C14.0274 12.5257 14.3048 12.6316 14.582 12.6316C14.8594 12.6316 15.1367 12.5257 15.3483 12.3141L18.4131 9.24856C18.4133 9.24834 18.4135 9.24805 18.4137 9.24783C19.4366 8.2244 20 6.86375 20 5.41661Z"}),Wt("path",{d:"M6.11156 13.8884C6.32632 14.1032 6.6078 14.2106 6.88921 14.2106C7.17068 14.2106 7.45216 14.1032 7.66692 13.8884L13.8883 7.66699C14.3179 7.23755 14.3179 6.54115 13.8883 6.11163C13.4589 5.68219 12.7625 5.68219 12.333 6.11163L6.11156 12.333C5.68205 12.7626 5.68205 13.459 6.11156 13.8884Z"})]});import{jsx as pi}from"react/jsx-runtime";var mi=()=>pi("svg",{width:"16",height:"11",viewBox:"0 0 16 11",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:pi("path",{d:"M0.396 3.652C0.396 2.98 0.528 2.384 0.792 1.864C1.064 1.344 1.428 0.944 1.884 0.664C2.348 0.384 2.864 0.244 3.432 0.244C3.928 0.244 4.36 0.344 4.728 0.543999C5.104 0.744 5.404 0.996 5.628 1.3V0.352H7.32V7H5.628V6.028C5.412 6.34 5.112 6.6 4.728 6.808C4.352 7.008 3.916 7.108 3.42 7.108C2.86 7.108 2.348 6.964 1.884 6.676C1.428 6.388 1.064 5.984 0.792 5.464C0.528 4.936 0.396 4.332 0.396 3.652ZM5.628 3.676C5.628 3.268 5.548 2.92 5.388 2.632C5.228 2.336 5.012 2.112 4.74 1.96C4.468 1.8 4.176 1.72 3.864 1.72C3.552 1.72 3.264 1.796 3 1.948C2.736 2.1 2.52 2.324 2.352 2.62C2.192 2.908 2.112 3.252 2.112 3.652C2.112 4.052 2.192 4.404 2.352 4.708C2.52 5.004 2.736 5.232 3 5.392C3.272 5.552 3.56 5.632 3.864 5.632C4.176 5.632 4.468 5.556 4.74 5.404C5.012 5.244 5.228 5.02 5.388 4.732C5.548 4.436 5.628 4.084 5.628 3.676ZM11.5648 0.244C12.0608 0.244 12.4968 0.344 12.8728 0.543999C13.2488 0.736 13.5448 0.988 13.7608 1.3V0.352H15.4528V7.048C15.4528 7.664 15.3288 8.212 15.0808 8.692C14.8328 9.18 14.4608 9.564 13.9648 9.844C13.4688 10.132 12.8688 10.276 12.1648 10.276C11.2208 10.276 10.4448 10.056 9.83681 9.616C9.23681 9.176 8.89681 8.576 8.81681 7.816H10.4848C10.5728 8.12 10.7608 8.36 11.0488 8.536C11.3448 8.72 11.7008 8.812 12.1168 8.812C12.6048 8.812 13.0008 8.664 13.3048 8.368C13.6088 8.08 13.7608 7.64 13.7608 7.048V6.016C13.5448 6.328 13.2448 6.588 12.8608 6.796C12.4848 7.004 12.0528 7.108 11.5648 7.108C11.0048 7.108 10.4928 6.964 10.0288 6.676C9.56481 6.388 9.19681 5.984 8.92481 5.464C8.66081 4.936 8.52881 4.332 8.52881 3.652C8.52881 2.98 8.66081 2.384 8.92481 1.864C9.19681 1.344 9.56081 0.944 10.0168 0.664C10.4808 0.384 10.9968 0.244 11.5648 0.244ZM13.7608 3.676C13.7608 3.268 13.6808 2.92 13.5208 2.632C13.3608 2.336 13.1448 2.112 12.8728 1.96C12.6008 1.8 12.3088 1.72 11.9968 1.72C11.6848 1.72 11.3968 1.796 11.1328 1.948C10.8688 2.1 10.6528 2.324 10.4848 2.62C10.3248 2.908 10.2448 3.252 10.2448 3.652C10.2448 4.052 10.3248 4.404 10.4848 4.708C10.6528 5.004 10.8688 5.232 11.1328 5.392C11.4048 5.552 11.6928 5.632 11.9968 5.632C12.3088 5.632 12.6008 5.556 12.8728 5.404C13.1448 5.244 13.3608 5.02 13.5208 4.732C13.6808 4.436 13.7608 4.084 13.7608 3.676Z",fill:"currentColor"})});import{jsx as Ot,jsxs as Ds}from"react/jsx-runtime";var fi=()=>Ds("svg",{width:"17",height:"17",viewBox:"0 0 17 17",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[Ot("rect",{x:"16",y:"1",width:"15",height:"15",rx:"1",transform:"rotate(90 16 1)",stroke:"#4D5265",strokeWidth:"2"}),Ot("path",{d:"M12 12L5 12",stroke:"#5c5ef9",strokeWidth:"2",strokeLinecap:"round"}),Ot("path",{d:"M12 5L5 5",stroke:"#4D5265",strokeWidth:"2",strokeLinecap:"round"})]});import{jsx as Vt,jsxs as As}from"react/jsx-runtime";var ui=()=>As("svg",{width:"17",height:"17",viewBox:"0 0 17 17",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[Vt("rect",{x:"1",y:"1",width:"15",height:"15",rx:"1",stroke:"#4D5265",strokeWidth:"2"}),Vt("path",{d:"M12 5V12",stroke:"#4D5265",strokeWidth:"2",strokeLinecap:"round"}),Vt("path",{d:"M5 5V12",stroke:"#5c5ef9",strokeWidth:"2",strokeLinecap:"round"})]});import{jsx as Ut,jsxs as Bs}from"react/jsx-runtime";var bi=()=>Bs("svg",{width:"17",height:"17",viewBox:"0 0 17 17",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[Ut("rect",{x:"1",y:"1",width:"15",height:"15",rx:"1",stroke:"#4D5265",strokeWidth:"2"}),Ut("path",{d:"M12 5V12",stroke:"#5c5ef9",strokeWidth:"2",strokeLinecap:"round"}),Ut("path",{d:"M5 5V12",stroke:"#4D5265",strokeWidth:"2",strokeLinecap:"round"})]});import{jsx as Yt,jsxs as Hs}from"react/jsx-runtime";var gi=()=>Hs("svg",{width:"17",height:"17",viewBox:"0 0 17 17",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[Yt("rect",{x:"16",y:"1",width:"15",height:"15",rx:"1",transform:"rotate(90 16 1)",stroke:"#4D5265",strokeWidth:"2"}),Yt("path",{d:"M12 12L5 12",stroke:"#4D5265",strokeWidth:"2",strokeLinecap:"round"}),Yt("path",{d:"M12 5L5 5",stroke:"#5c5ef9",strokeWidth:"2",strokeLinecap:"round"})]});import{jsx as Xt,jsxs as Gs}from"react/jsx-runtime";var hi=()=>Gs("svg",{width:"17",height:"17",viewBox:"0 0 17 17",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[Xt("rect",{x:"5",y:"12",width:"7",height:"7",rx:"1",transform:"rotate(-90 5 12)",stroke:"#4D5265",strokeWidth:"2"}),Xt("path",{d:"M1 1L16 0.999999",stroke:"#4D5265",strokeWidth:"2",strokeLinecap:"round"}),Xt("path",{d:"M1 16L16 16",stroke:"#5c5ef9",strokeWidth:"2",strokeLinecap:"round"})]});import{jsx as Zt,jsxs as Ws}from"react/jsx-runtime";var xi=()=>Ws("svg",{width:"17",height:"17",viewBox:"0 0 17 17",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[Zt("rect",{x:"5",y:"5",width:"7",height:"7",rx:"1",stroke:"#4D5265",strokeWidth:"2"}),Zt("path",{d:"M16 1V16",stroke:"#4D5265",strokeWidth:"2",strokeLinecap:"round"}),Zt("path",{d:"M1 1V16",stroke:"#5c5ef9",strokeWidth:"2",strokeLinecap:"round"})]});import{jsx as jt,jsxs as Os}from"react/jsx-runtime";var yi=()=>Os("svg",{width:"17",height:"17",viewBox:"0 0 17 17",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jt("rect",{x:"5",y:"5",width:"7",height:"7",rx:"1",stroke:"#4D5265",strokeWidth:"2"}),jt("path",{d:"M16 1V16",stroke:"#5c5ef9",strokeWidth:"2",strokeLinecap:"round"}),jt("path",{d:"M1 1V16",stroke:"#4D5265",strokeWidth:"2",strokeLinecap:"round"})]});import{jsx as Kt,jsxs as Vs}from"react/jsx-runtime";var vi=()=>Vs("svg",{width:"17",height:"17",viewBox:"0 0 17 17",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[Kt("rect",{x:"12",y:"5",width:"7",height:"7",rx:"1",transform:"rotate(90 12 5)",stroke:"#4D5265",strokeWidth:"2"}),Kt("path",{d:"M16 16L1 16",stroke:"#4D5265",strokeWidth:"2",strokeLinecap:"round"}),Kt("path",{d:"M16 1L1 0.999999",stroke:"#5c5ef9",strokeWidth:"2",strokeLinecap:"round"})]});import{jsx as Qt,jsxs as Us}from"react/jsx-runtime";var qi=()=>Us("svg",{width:"14",height:"14",viewBox:"0 0 14 14",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[Qt("rect",{x:"2",width:"10",height:"3",rx:"1.5",fill:"currentColor"}),Qt("rect",{y:"5.5",width:"14",height:"3",rx:"1.5",fill:"currentColor"}),Qt("rect",{x:"4",y:"11",width:"6",height:"3",rx:"1.5",fill:"currentColor"})]});import{jsx as Jt,jsxs as Ys}from"react/jsx-runtime";var ki=()=>Ys("svg",{width:"14",height:"14",viewBox:"0 0 14 14",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[Jt("rect",{width:"10",height:"3",rx:"1.5",fill:"currentColor"}),Jt("rect",{y:"5.5",width:"14",height:"3",rx:"1.5",fill:"currentColor"}),Jt("rect",{y:"11",width:"6",height:"3",rx:"1.5",fill:"currentColor"})]});import{jsx as eo,jsxs as Xs}from"react/jsx-runtime";var wi=()=>Xs("svg",{width:"14",height:"14",viewBox:"0 0 14 14",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[eo("rect",{x:"4",width:"10",height:"3",rx:"1.5",fill:"currentColor"}),eo("rect",{y:"5.5",width:"14",height:"3",rx:"1.5",fill:"currentColor"}),eo("rect",{x:"8",y:"11",width:"6",height:"3",rx:"1.5",fill:"currentColor"})]});import{jsx as Si,jsxs as Zs}from"react/jsx-runtime";var Ci=()=>Zs("svg",{width:"14",height:"16",viewBox:"0 0 14 16",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[Si("rect",{y:"14",width:"14",height:"2",rx:"1",fill:"currentColor"}),Si("path",{d:"M2.68355 0V0.00108108C1.75659 0.00108108 1 0.668616 1 1.48648V6.70649V6.71114C1.00637 8.351 1.76604 9.75729 2.92612 10.6656C4.0811 11.5699 5.55622 11.9952 7.00862 12C8.46115 12.0047 9.94261 11.5878 11.0985 10.6798C12.2595 9.76774 13.0065 8.35078 13 6.70086V1.4861C13 0.668238 12.2434 0.000702703 11.3164 0.000702703C10.3894 0.000702703 9.63285 0.668238 9.63285 1.4861V6.70616C9.63284 6.70779 9.63284 6.70941 9.63285 6.71103C9.63653 7.62501 9.32503 8.09481 8.85926 8.46072C8.40471 8.8178 7.72492 9.0313 7.02122 9.02901C6.31777 9.02674 5.62626 8.80738 5.16101 8.44312C4.68505 8.07047 4.37083 7.59663 4.36717 6.70154V1.48583C4.36717 0.667968 3.61051 0.000432433 2.68355 0.000432433V0Z",fill:"currentColor"})]});import{jsx as Oe,jsxs as js}from"react/jsx-runtime";var $i=()=>js("svg",{width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[Oe("path",{d:"M10.7818 13.8168L7.7169 16.8824C7.7169 16.8824 7.7169 16.8824 7.71683 16.8824C7.71683 16.8824 7.71683 16.8825 7.71676 16.8825C6.44934 18.1502 4.38697 18.1503 3.11941 16.8825C2.50536 16.2683 2.16726 15.4518 2.16726 14.5833C2.16726 13.7149 2.50536 12.8985 3.1192 12.2843C3.11927 12.2843 3.11934 12.2842 3.11941 12.2841L6.18429 9.21858C6.60741 8.7953 6.60741 8.10902 6.18421 7.68581C5.76109 7.26261 5.07494 7.26261 4.65174 7.68581L1.58687 10.7513C1.58665 10.7516 1.58644 10.7519 1.58622 10.7521C0.563344 11.7755 0 13.1362 0 14.5833C0 16.0308 0.563561 17.3917 1.58694 18.4153C2.64327 19.4717 4.03068 20 5.41816 20C6.80564 20 8.19312 19.4717 9.2493 18.4153C9.24937 18.4153 9.24938 18.4151 9.24938 18.4151L12.3142 15.3496C12.7374 14.9264 12.7374 14.2401 12.3142 13.8168C11.8911 13.3936 11.205 13.3936 10.7818 13.8168Z"}),Oe("path",{d:"M20 5.41661C20 3.9691 19.4364 2.60823 18.413 1.58465C16.3005 -0.528254 12.8632 -0.528182 10.7508 1.58465C10.7507 1.5848 10.7506 1.58487 10.7505 1.58502L7.6858 4.65033C7.26261 5.07353 7.26261 5.75989 7.6858 6.1831C7.89746 6.39481 8.17472 6.50059 8.45205 6.50059C8.72931 6.50059 9.00672 6.39473 9.21824 6.1831L12.283 3.11778C12.283 3.11764 12.2832 3.11756 12.2833 3.11742C13.5507 1.84976 15.613 1.84969 16.8806 3.11742C17.4945 3.7316 17.8328 4.54816 17.8328 5.41661C17.8328 6.28498 17.4947 7.1014 16.8808 7.71557L16.8806 7.71579L13.8158 10.7813C13.3927 11.2045 13.3927 11.8908 13.8158 12.3141C14.0274 12.5257 14.3048 12.6316 14.582 12.6316C14.8594 12.6316 15.1367 12.5257 15.3483 12.3141L18.4131 9.24856C18.4133 9.24834 18.4135 9.24805 18.4137 9.24783C19.4366 8.2244 20 6.86375 20 5.41661Z"}),Oe("path",{d:"M13.8884 6.11163C14.3179 6.54115 14.3179 7.23755 13.8884 7.66699L12.3331 9.22235L10.7777 7.66697L12.3331 6.11163C12.7626 5.68219 13.459 5.68219 13.8884 6.11163Z"}),Oe("path",{d:"M6.88933 14.2106C6.60792 14.2106 6.32644 14.1032 6.11169 13.8884C5.68217 13.459 5.68217 12.7626 6.11169 12.333L8.44471 10L10.0001 11.5554L7.66704 13.8884C7.45229 14.1032 7.17081 14.2106 6.88933 14.2106Z"}),Oe("path",{d:"M3.11169 1.11169C2.89693 1.32644 2.78952 1.60792 2.78952 1.88933C2.78952 2.17081 2.89693 2.45228 3.11169 2.66704L17.3331 16.8885C17.7626 17.318 18.459 17.318 18.8885 16.8885C19.3179 16.459 19.3179 15.7626 18.8885 15.3331L4.66712 1.11169C4.23754 0.682172 3.54113 0.682172 3.11169 1.11169Z"})]});import{jsx as Ii}from"react/jsx-runtime";var Pi=()=>Ii("svg",{width:"18",height:"10",viewBox:"0 0 18 10",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:Ii("path",{d:"M5.964 7.404H2.628L2.076 9H0.312L3.324 0.611999H5.28L8.292 9H6.516L5.964 7.404ZM5.508 6.06L4.296 2.556L3.084 6.06H5.508ZM15.2498 3.144C15.0578 2.792 14.7938 2.524 14.4578 2.34C14.1218 2.156 13.7298 2.064 13.2818 2.064C12.7858 2.064 12.3458 2.176 11.9618 2.4C11.5778 2.624 11.2778 2.944 11.0618 3.36C10.8458 3.776 10.7378 4.256 10.7378 4.8C10.7378 5.36 10.8458 5.848 11.0618 6.264C11.2858 6.68 11.5938 7 11.9858 7.224C12.3778 7.448 12.8338 7.56 13.3538 7.56C13.9938 7.56 14.5178 7.392 14.9258 7.056C15.3338 6.712 15.6018 6.236 15.7298 5.628H12.8498V4.344H17.3858V5.808C17.2738 6.392 17.0338 6.932 16.6658 7.428C16.2978 7.924 15.8218 8.324 15.2378 8.628C14.6618 8.924 14.0138 9.072 13.2938 9.072C12.4858 9.072 11.7538 8.892 11.0978 8.532C10.4498 8.164 9.93784 7.656 9.56184 7.008C9.19384 6.36 9.00984 5.624 9.00984 4.8C9.00984 3.976 9.19384 3.24 9.56184 2.592C9.93784 1.936 10.4498 1.428 11.0978 1.068C11.7538 0.7 12.4818 0.516 13.2818 0.516C14.2258 0.516 15.0458 0.748 15.7418 1.212C16.4378 1.668 16.9178 2.312 17.1818 3.144H15.2498Z",fill:"currentColor"})});var T={AlignCenter:Ar,AlignLeft:Br,AlignRight:Hr,BorderBottom:Wr,BorderLeft:Vr,BorderRight:Yr,BorderTop:Zr,CornerBottomLeft:Jr,CornerBottomRight:ti,CornerTopLeft:ri,CornerTopRight:ai,LetterSpacing:li,LineAcross:si,LineHeight:ci,Link:di,MarginBottom:fi,MarginLeft:ui,MarginRight:bi,MarginTop:gi,PaddingBottom:hi,PaddingLeft:xi,PaddingRight:yi,PaddingTop:vi,TextAlignCenter:qi,TextAlignLeft:ki,TextAlignRight:wi,Underline:Ci,Unlink:$i,Uppercase:Pi,Lowercase:mi,Capitalize:Kr};import{Fragment as Ve,jsx as _}from"react/jsx-runtime";function Ti(e){if(!e)return[void 0,void 0];if(typeof e=="number")return[e,void 0];let t=/^([+-]?\d*\.?\d+)([a-zA-Z%]*)$/,o=e.match(t);if(o){let i=parseFloat(o[1]),l=o[2]||"";return[i,l]}return[void 0,void 0]}var to=[{id:"typography",name:"typography",displayName:"Typography",cssProperties:["fontFamily","color","fontSize","textAlign","fontWeight","fontStyle","lineHeight","letterSpacing","textDecorationLine","textDecorationStyle","textDecorationThickness","textDecorationColor","textTransform"]},{id:"flex-box",name:"flex-box",displayName:"Flex Box",cssProperties:["justifyContent","alignItems","gap"]},{id:"background",name:"background",displayName:"Background",cssProperties:["backgroundColor","backgroundImage","backgroundSize","backgroundRepeat","backgroundPosition"]},{id:"borders",name:"borders",displayName:"Borders",cssProperties:["borderColor","borderStyle","borderWidth","borderRadius"]},{id:"spacing",name:"spacing",displayName:"Spacing",cssProperties:["margin","padding"]},{id:"shadow",name:"shadow",displayName:"Shadow",cssProperties:["boxShadow"]},{id:"size",name:"size",displayName:"Size",cssProperties:["width","height","minWidth","minHeight","maxWidth","maxHeight"]}],ge={height:{min:0,max:5e3,unit:"px"},width:{min:0,max:5e3,unit:"px"},minHeight:{min:0,max:5e3,unit:"px"},minWidth:{min:0,max:5e3,unit:"px"},maxHeight:{min:0,max:5e3,unit:"px"},maxWidth:{min:0,max:5e3,unit:"px"},gap:{min:0,max:5e3,unit:"px"},letterSpacing:{min:-10,max:10,step:.01,unit:"em"},lineHeight:{min:-100,max:100,step:.1,unit:"em"},margin:{min:0,max:1e3,unit:"px"},marginBottom:{min:0,max:1e3,unit:"px"},marginLeft:{min:0,max:1e3,unit:"px"},marginRight:{min:0,max:1e3,unit:"px"},marginTop:{min:0,max:1e3,unit:"px"},padding:{min:0,max:1e3,unit:"px"},paddingBottom:{min:0,max:1e3,unit:"px"},paddingLeft:{min:0,max:1e3,unit:"px"},paddingRight:{min:0,max:1e3,unit:"px"},paddingTop:{min:0,max:1e3,unit:"px"},borderWidth:{min:0,max:20,unit:"px"},borderTopWidth:{min:0,max:20,unit:"px"},borderRightWidth:{min:0,max:20,unit:"px"},borderLeftWidth:{min:0,max:20,unit:"px"},borderBottomWidth:{min:0,max:20,unit:"px"},borderRadius:{min:0,max:5e3,unit:"px"},fontSize:{min:0,max:200,unit:"px"},textDecorationThickness:{min:0,max:10}},oo=["width","height","minWidth","minHeight","maxWidth","maxHeight"],ro={backgroundRepeat:[{value:"",label:"Default"},{value:"no-repeat",label:"No Repeat"},{value:"repeat",label:"Repeat"},{value:"repeat-x",label:"Repeat X"},{value:"repeat-y",label:"Repeat Y"}],backgroundSize:[{value:"",label:"Default"},{value:"auto",label:"Auto"},{value:"cover",label:"Cover"},{value:"contain",label:"Contain"}],objectFit:[{value:"",label:"Default"},{value:"auto",label:"Auto"},{value:"cover",label:"Cover"},{value:"contain",label:"Contain"}],backgroundPosition:[{value:"",label:_(Ve,{children:"/"})},{value:"center left",label:_(T.AlignLeft,{})},{value:"center center",label:_(T.AlignCenter,{})},{value:"center right",label:_(T.AlignRight,{})}],objectPosition:[{value:"",label:_(Ve,{children:"/"})},{value:"center left",label:_(T.AlignLeft,{})},{value:"center center",label:_(T.AlignCenter,{})},{value:"center right",label:_(T.AlignRight,{})}],fontStyle:[{value:"",label:"Default"},{value:"normal",label:"Normal"},{value:"italic",label:"Italic"},{value:"oblique",label:"Oblique"}],borderStyle:[{value:"",label:"Default"},{value:"none",label:"None"},{value:"solid",label:"Solid"},{value:"dashed",label:"Dashed"},{value:"dotted",label:"Dotted"}],textTransform:[{value:"none",label:_(Ve,{})},{value:"uppercase",label:_(T.Uppercase,{})},{value:"lowercase",label:_(T.Lowercase,{})},{value:"capitalize",label:_(T.Capitalize,{})}],textAlign:[{value:"",label:_(Ve,{children:"/"})},{value:"left",label:_(T.TextAlignLeft,{})},{value:"center",label:_(T.TextAlignCenter,{})},{value:"right",label:_(T.TextAlignRight,{})}],textDecorationLine:[{value:"none",label:_(Ve,{children:"/"})},{value:"underline",label:_(T.Underline,{})},{value:"line-through",label:_(T.LineAcross,{})}],textDecorationStyle:[{value:"solid",label:"Solid"},{value:"double",label:"Double"},{value:"dotted",label:"Dotted"},{value:"dashed",label:"Dashed"},{value:"wavy",label:"Wavy"}],padding:[{value:"paddingTop",label:_(T.PaddingTop,{})},{value:"paddingRight",label:_(T.PaddingRight,{})},{value:"paddingBottom",label:_(T.PaddingBottom,{})},{value:"paddingLeft",label:_(T.PaddingLeft,{})}],margin:[{value:"marginTop",label:_(T.MarginTop,{})},{value:"marginRight",label:_(T.MarginRight,{})},{value:"marginBottom",label:_(T.MarginBottom,{})},{value:"marginLeft",label:_(T.MarginLeft,{})}],borderWidth:[{value:"borderTopWidth",label:_(T.BorderTop,{})},{value:"borderRightWidth",label:_(T.BorderRight,{})},{value:"borderBottomWidth",label:_(T.BorderBottom,{})},{value:"borderLeftWidth",label:_(T.BorderLeft,{})}],borderRadius:[{value:"borderTopLeftRadius",label:_(T.CornerTopLeft,{})},{value:"borderTopRightRadius",label:_(T.CornerTopRight,{})},{value:"borderBottomRightRadius",label:_(T.CornerBottomRight,{})},{value:"borderBottomLeftRadius",label:_(T.CornerBottomLeft,{})}],justifyContent:[{value:"flex-start",label:"Flex Start"},{value:"center",label:"Center"},{value:"flex-end",label:"Flex End"},{value:"space-between",label:"Space Between"},{value:"space-around",label:"Space Around"}],alignItems:[{value:"flex-start",label:"Flex Start"},{value:"center",label:"Center"},{value:"flex-end",label:"Flex End"},{value:"space-between",label:"Space Between"},{value:"space-around",label:"Space Around"}]},_i=e=>{let t=[];return!e||typeof e!="string"&&e.length===0?(to.forEach(o=>{t.push(o)}),t):typeof e=="string"?(to.forEach(o=>{o.name===e&&t.push(o)}),t):(e.forEach(o=>{to.forEach(i=>{if(typeof o=="string"){i.name===o&&t.push(i);return}i.name===o.name&&t.push({...i,...o})})}),t)};function lt(e,t=0){let o=100/(e.length-1),i=e.map((l,n)=>`${l} ${n*o}%`);return`linear-gradient(${t}deg, ${i.join(", ")})`}function io(e){let t=/(\d+)deg/,o=e.match(t),i=o?parseInt(o[1]):0,l=/(#(?:[0-9a-fA-F]{3}){1,2}|rgba?\((?:\d{1,3},\s?){2,3}(?:\d{1,3}(?:,\s?\d(?:\.\d+)?)?)?\))/g,s=e.match(l)||[];return{degree:i,colors:s}}import{Fragment as Ks,jsx as Li,jsxs as zi}from"react/jsx-runtime";var ao=({cssProps:e={},onChange:t,degreeControl:o=!0,defaultDegree:i=0})=>{let l=[],n=i||0;if(e.backgroundImage&&e.backgroundImage.startsWith("linear-gradient")){let{colors:s,degree:d}=io(e.backgroundImage);l=s,n=d}else e.backgroundColor&&l.push(e.backgroundColor);return zi(Ks,{children:[Li(Lt,{colors:l,onChange:s=>{var c;let d={...e,backgroundColor:s[0]};s.length>1?d.backgroundImage=lt(s,n):(c=e.backgroundImage)!=null&&c.startsWith("linear-gradient")&&(d.backgroundImage=void 0),t(d,!0)},max:3}),o&&l.length>1&&zi("div",{style:{width:"100%",display:"flex",alignItems:"center",justifyContent:"flex-end",gap:10},children:["Turn",Li(Ft,{value:n,onChange:s=>t({backgroundImage:lt(l,s)},!0),step:1,min:0,max:360}),"degrees"]})]})};import{FaChevronDown as Vc}from"@react-icons/all-files/fa/FaChevronDown";import{FaChevronUp as Uc}from"@react-icons/all-files/fa/FaChevronUp";import{FaHistory as Yc}from"@react-icons/all-files/fa/FaHistory";import{useState as fo}from"react";import ec from"classnames";import Qs,{css as Js}from"styled-components";var Ni=Qs.div`
  ${e=>Js`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: ${e.align||"flex-end"};
    flex-wrap: wrap;
    gap: 10px;
    font-size: 1rem;
    flex: 1; // In form row
  `}
`;import{jsx as tc}from"react/jsx-runtime";var O=e=>tc(Ni,{...e,className:ec(a("form-input"),e.className),children:e.children});import{FaCrown as ic}from"@react-icons/all-files/fa/FaCrown";import ac from"classnames";import oc,{css as rc}from"styled-components";var Mi=oc.label`
  ${()=>rc`
    font-size: 0.9rem;
    line-height: inherit;
    color: var(${r.text300});
    padding: 0 2px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;
    flex: 0;
    letter-spacing: 0.015em;

    > svg {
      font-size: 0.95rem;
      margin-top: -1px;
    }
  `}
`;import{jsx as lc,jsxs as nc}from"react/jsx-runtime";var he=e=>nc(Mi,{...e,className:ac(a("form-label"),e.className),children:[e.isPremium&&lc(ic,{}),e.children]});import dc from"classnames";import sc,{css as cc}from"styled-components";var Ri=sc.div`
	${({flow:e="column"})=>cc`
		display: flex;
		flex-direction: ${e||"column"};
		align-items: 'flex-start';
		color: var(${r.text300});
		font-size: 0.8rem;
		line-height: 1.3;
		gap: 7px;
		margin-bottom: 20px;
		position: relative;

		&:last-of-type {
			margin-bottom: 0;
		}

		> label:first-child {
			flex-basis: ${e==="row"?"140px":"100%"};
			min-width: ${e==="row"?"140px":"100%"};
		}
	`}
`;import{jsx as pc}from"react/jsx-runtime";var oe=e=>pc(Ri,{...e,className:dc(a("form-row"),e.className),children:e.children});import uc from"classnames";import bc from"lodash/debounce";import{useEffect as gc,useRef as hc,useState as xc}from"react";import mc,{css as fc}from"styled-components";var Ei=mc.input`
	${()=>fc`
		border: 1px solid var(${r.background300});
		background-color: transparent;
		color: var(${r.text500});
		outline: none;
		padding: 7px 10px;
		font-family: var(${r.primaryFont});
		transition: 0.2s;
		border-radius: 5px;
		line-height: 1;
		font-size: 1rem;
		flex: 1;

		&.small {
			max-width: 80px;
		}

		&:focus {
			color: var(${r.text100});
			border-color: var(${r.primary500});
		}

		&:disabled {
			color: var(${r.text900});
			border-color: var(${r.text900});
		}

		::placeholder {
			color: var(${r.text700});
		}
	`}
`;import{Fragment as vc,jsx as lo,jsxs as qc}from"react/jsx-runtime";var V=({showInvalidMessage:e=!0,...t})=>{let[o,i]=xc(""),l=hc(null),n=bc(async c=>{i(tt(l)||"")},300),s=c=>{var m;(m=t.onChange)==null||m.call(t,c),n(c)};gc(()=>()=>{n.cancel()},[n,l]),t.type==="number"&&typeof t.value=="string"&&(t.value=t.value.replace(/[^0-9.]/g,""));let d=t.placeholder||"Enter text";return t.type==="number"&&t.placeholder===void 0&&(d="Auto"),qc(vc,{children:[lo(Ei,{ref:l,...t,onChange:e?s:t.onChange,placeholder:d,className:uc(a("input"),t.className,t.inputSize)}),o&&lo(De,{text:o})]})},yc=e=>{var i;let t=(i=e.value)!=null?i:"";t&&typeof t=="string"&&(t=parseFloat(t));let o=l=>{e.onChange(isNaN(l.target.valueAsNumber)?void 0:l.target.valueAsNumber)};return lo(V,{className:e.inputSize||"small",min:0,max:1e6,placeholder:"Auto",...e,value:t,onChange:o,type:"number"})};import{BiDuplicate as Cc}from"@react-icons/all-files/bi/BiDuplicate";import{FaGripVertical as Hi}from"@react-icons/all-files/fa/FaGripVertical";import{FaPlus as $c}from"@react-icons/all-files/fa/FaPlus";import{FaTrash as Ic}from"@react-icons/all-files/fa/FaTrash";import nt from"classnames";import Gi,{Suspense as Wi,useRef as Pc,useState as Tc}from"react";import{v4 as Ai}from"uuid";import{SortableElement as _c}from"react-sortable-hoc";import kc,{createGlobalStyle as wc,css as Sc}from"styled-components";var Fi=kc.div`
	${()=>Sc`
		display: flex;
		flex-direction: column;
		justify-content: center;
		gap: 20px;

		.${a("accordion-title")} {
			justify-content: space-between;
		}

		.${a("items-manager-item-title")} {
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			gap: 10px;

			span:not(.${a("items-manager-drag-handler")}) {
				max-width: 218px !important;
			}
		}

		.${a("items-manager-item-actions")} {
			display: flex;
			align-items: center;
			justify-content: flex-end;
			gap: 5px;

			> * {
				cursor: pointer;
			}

			.${a("items-manager-item-action")} {
				display: flex;
				align-items: center;
				justify-content: center;
				line-height: 1;

				svg {
					transition: 0.2s;
					color: var(${r.text500});

					&:hover {
						color: var(${r.text100});
					}
				}
			}

			* > {
				transition: 0.2s;
				color: var(${r.text500});

				&:hover {
					color: var(${r.text100});
				}
			}
		}

		.${a("items-manager-drag-handler")} {
			cursor: move;
			opacity: 0.3;
			font-size: 1rem;
			line-height: 1;
			transition: 0.2s;

			&.disabled {
				opacity: 0.1;
				cursor: not-allowed;
			}
		}

		&.header-mode {
			> section > .${a("items-manager-item")} {
				background: none;
				margin-bottom: 0;
				border-bottom: 1px solid var(${r.background500});
				padding: 10px 0;
				border-radius: 0;

				&:last-child {
					border-bottom: none;
				}

				> header {
					border-radius: 0;
					background-color: transparent;
					padding: 0 20px;

					hgroup {
						margin: 0;
						color: var(${r.text500});
						transition: 0.2s;
					}

					&:hover {
						hgroup {
							color: var(${r.text300});
						}
					}
				}

				> section > .${a("accordion-content")} {
					padding: 20px 20px 10px;
				}

				.${a("button")}.transparent {
					padding: 0;
				}
			}
		}
	`}
`,Di=wc`
  .${a("floating-item")} {
		z-index: 50;
		opacity: 0.5;
		color: var(${r.text100});

		.${a("accordion-title")} {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		.${a("items-manager-item-title")} {
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			gap: 5px;
		}

		.${a("items-manager-item-actions")} {
			display: flex;
			align-items: center;
			justify-content: flex-end;
			gap: 5px;

			> * {
				cursor: pointer;
			}
		}
	}
`;import{Fragment as Bi,jsx as R,jsxs as Ne}from"react/jsx-runtime";var Lc=Gi.lazy(()=>import("react-sortable-hoc").then(e=>({default:e.SortableContainer(({items:t,renderItem:o})=>R("section",{children:t==null?void 0:t.map((i,l)=>R(Wi,{fallback:R(J,{size:14}),children:R(Nc,{index:l,sortIndex:l,data:i,renderItem:o})},`item-${i.id}-${l}`))}))}))),zc=Gi.lazy(()=>import("react-sortable-hoc").then(e=>({default:e.SortableHandle(()=>R("span",{className:a("items-manager-drag-handler"),title:"Move",children:R(Hi,{size:14})}))}))),no=({items:e,newItemGenerator:t,itemRenderer:o,titleRenderer:i,searchFilter:l,onUpdate:n,onItemToggle:s,onItemMouseEnter:d,onItemMouseLeave:c,onItemClick:m,maxItems:p=1,minItems:f=1,extraActionsComp:v,extraActionsRenderer:k,collapsable:$=!0,searchable:b=!0,sortable:q=!0,addable:h=!0,removable:u=!0,duplicatable:x=!1,addItemText:y="Add Item",itemsText:S="items",newItemPlacement:w="last",onError:L,headerMode:Y=!1,secondary:B=!1,openedByDefault:H=!1,style:j,itemClassName:ee,itemStyle:D,idGenerator:K})=>{let[se,re]=Tc(""),ce=se.toLowerCase().trim(),te=e==null?void 0:e.filter(Pe),qe=Pc(null);function ie(P,z,N){W.removeAll(),L!=null&&L(P,z)||W.warning({title:z,message:N,autoDismiss:4})}function Pe(P){return!!(!b||!l||!ce||l(P,ce))}function Te(P,z){P.preventDefault(),P.stopPropagation();let N=e==null?void 0:e.filter(G=>G.id!==z);if(typeof f<"u"&&(N==null?void 0:N.length)<f){ie("min",`Sorry, but the minimum number of ${S} is ${f}.`);return}re(""),n==null||n(N)}function ke(P,z){P.preventDefault(),P.stopPropagation();let N=e.findIndex(ae=>ae.id===z),G=(K==null?void 0:K(e[N]))||Ai(),Q=[...e,{...e[N],id:G}];if(p&&Q.length>p){ie("max","You reached the maximum",`Your current premium plan doesn't allow you to add more than ${p} ${S}. Upgrade your account now!`);return}re(""),n==null||n(Q)}function _e(P,z,N){let G=z<0?P.length+z:z;if(G>=0&&G<P.length){let Q=N<0?P.length+N:N,[ae]=P.splice(z,1);P.splice(Q,0,ae)}}function I(P,z,N){let G=[...P];return _e(G,z,N),G}function M({oldIndex:P,newIndex:z}){let N=I(e,P,z);n==null||n(N)}function X(){if(p&&(e==null?void 0:e.length)+1>p){ie("max","You reached the maximum",`Your current premium plan doesn't allow you to add more than ${p} ${S}. Upgrade your account now!`);return}re("");let P={id:Ai(),...(t==null?void 0:t())||{}},z=w==="last"?[...e,P]:[P,...e];n==null||n(z),window.setTimeout(()=>{var ae,Ee,pe,Fo;let N=w==="first"?0:z.length-1,G=null;(Ee=(ae=qe.current)==null?void 0:ae.childNodes)==null||Ee.forEach(Do=>{Do.nodeName==="SECTION"&&(G=Do)});let Q=(Fo=(pe=G==null?void 0:G.childNodes)==null?void 0:pe[N])==null?void 0:Fo.querySelector("header");Q==null||Q.click()},50)}function de(){return q?ce?R("span",{className:`${a("items-manager-drag-handler")} disabled`,title:"Not available in search mode",children:R(Hi,{size:14})}):R(zc,{}):R(Bi,{})}function je(P,z){return R(Ct,{onMouseEnter:()=>{d==null||d(P,z)},onMouseLeave:()=>{c==null||c(P,z)},className:nt(a("items-manager-item"),ee==null?void 0:ee(P)),openedByDefault:H,collapsable:$,style:D==null?void 0:D(P),secondary:B,titleComponent:Ne(Bi,{children:[Ne("div",{className:a("items-manager-item-title"),children:[de(),i(P,z)]}),Ne("div",{className:a("items-manager-item-actions"),children:[v&&v,k==null?void 0:k(P,z),x&&R("span",{className:nt(a("items-manager-item-action"),"delete"),onClick:N=>ke(N,P.id),title:"Duplicate",children:R(Cc,{color:r.text300,size:18})}),u&&R("span",{className:nt(a("items-manager-item-action"),"delete"),title:"Delete",onClick:N=>Te(N,P.id),children:R(Ic,{size:15,title:"Delete"})})]})]}),onToggle:N=>{s==null||s(P,N,z||0)},onClick:m?()=>m(P):void 0,children:o&&o(P,z)},`item_setting_${P.id}`)}return Ne(Fi,{className:nt(a("items-manager"),{"header-mode":Y}),ref:qe,style:j,children:[R(Di,{}),b&&R(oe,{className:a("context-nav"),children:R(V,{type:"text",placeholder:"Search...",value:se,onChange:P=>re(P.target.value||"")})}),(te==null?void 0:te.length)===0?Ne("p",{className:a("items-manager-message"),children:["No ",S," found."]}):R(Wi,{fallback:R(J,{}),children:R(Lc,{items:te,renderItem:je,onSortEnd:M,axis:"y",lockAxis:"y",helperClass:a("floating-item"),useDragHandle:!0})}),h&&Ne(A,{variant:"add",onClick:()=>X(),title:y,children:[R($c,{}),y]})]})},Nc=_c(({data:e,renderItem:t,sortIndex:o,index:i})=>t(e,o||i));import{Suspense as Oi,lazy as Vi}from"react";import Mc,{css as Rc}from"styled-components";function Ec(e){return`
		/* Base styles for react-select */
		[aria-live=polite], #react-select-2-live-region {
			display: none;
		}
			
		.${e}__control {
			background-color: white;
			border-color: hsl(0, 0%, 80%);
			border-radius: 4px;
			border-style: solid;
			border-width: 1px;
			box-shadow: none;
			cursor: default;
			display: flex;
			justify-content: space-between;
			min-height: 38px;
			outline: 0 !important;
			position: relative;
			transition: all 100ms;
			box-sizing: border-box;
  		touch-action: manipulation;  /* Ensures proper touch behavior in browser simulators */
		}

		.${e}__control--is-disabled {
			background-color: hsl(0, 0%, 95%);
		}

		.${e}__control--is-focused {
			border-color: hsl(0, 0%, 70%);
			box-shadow: 0 0 0 1px hsl(0, 0%, 70%);
		}

		.${e}__value-container {
			display: flex;
			align-items: center;
			flex: 1 1;
			padding: 2px 8px;
			position: relative;
			overflow: hidden;
			box-sizing: border-box;
		}

		.${e}__single-value {
			color: hsl(0, 0%, 20%);
			margin-left: 2px;
			margin-right: 2px;
			max-width: calc(100% - 8px);
			overflow: hidden;
			position: absolute;
			text-overflow: ellipsis;
			white-space: nowrap;
			top: 50%;
			transform: translateY(-50%);
			box-sizing: border-box;
		}

		.${e}__indicator {
			color: hsl(0, 0%, 40%);
			display: flex;
			padding: 8px;
			transition: color 150ms;
			box-sizing: border-box;
		}

		.${e}__indicator:hover {
			color: hsl(0, 0%, 20%);
		}

		.${e}__dropdown-indicator {
			padding: 0 8px;
			box-sizing: border-box;
		}

		.${e}__menu {
			background-color: white;
			box-shadow: 0 4px 11px rgba(0, 0, 0, 0.1);
			margin-bottom: 8px;
			margin-top: 8px;
			position: absolute;
			width: 100%;
			z-index: 1;
			box-sizing: border-box;
		}

		.${e}__menu-list {
			max-height: 300px;
			overflow-y: auto;
			padding: 8px 0;
			position: relative;
			box-sizing: border-box;
		}

		.${e}__option {
			padding: 8px 12px;
			box-sizing: border-box;
			cursor: default;
			display: block;
		}

		.${e}__option--is-focused {
			background-color: hsl(0, 0%, 90%);
		}

		.${e}__option--is-selected {
			background-color: hsl(0, 0%, 80%);
		}

		.${e}__option--is-disabled {
			color: hsl(0, 0%, 40%);
			background-color: hsl(0, 0%, 95%);
		}

		.${e}__multi-value {
			background-color: hsl(0, 0%, 90%);
			border-radius: 2px;
			display: flex;
			margin: 2px;
			min-width: 0;
			box-sizing: border-box;
		}

		.${e}__multi-value__label {
			color: hsl(0, 0%, 20%);
			padding: 3px 6px;
			box-sizing: border-box;
		}

		.${e}__multi-value__remove {
			align-items: center;
			background-color: hsl(0, 0%, 80%);
			border-radius: 2px;
			display: flex;
			padding-left: 2px;
			padding-right: 2px;
			cursor: pointer;
			box-sizing: border-box;
		}

		.${e}__multi-value__remove:hover {
			background-color: hsl(0, 0%, 70%);
			color: hsl(0, 0%, 40%);
		}

		.${e}__clear-indicator {
			padding: 0 8px;
			box-sizing: border-box;
		}

		.${e}__clear-indicator:hover {
			color: hsl(0, 0%, 20%);
		}

		.${e}__loading-indicator {
			padding-left: 8px;
			padding-right: 8px;
			box-sizing: border-box;
		}

		.${e}__loading-message {
			padding: 8px 12px;
			color: hsl(0, 0%, 40%);
			box-sizing: border-box;
		}

		.${e}__no-options-message {
			padding: 8px 12px;
			color: hsl(0, 0%, 40%);
			box-sizing: border-box;
		}

		.${e}__menu-notice--no-options {
			padding: 8px 12px;
			color: hsl(0, 0%, 40%);
			box-sizing: border-box;
		}

		.${e}__menu-notice--loading {
			padding: 8px 12px;
			color: hsl(0, 0%, 40%);
			box-sizing: border-box;
		}
	`}var so=Mc.div`
	${()=>Rc`
		flex: 1;

		.${a("select")} {
			// Default styles
			${Ec(a("select"))}

			&.${a("select--is-disabled")} {
				.${a("select__control")} {
					color: var(${r.text900});
					border-color: var(${r.background800});
				}

				.${a("select__dropdown-indicator")} {
					color: var(${r.text900});
				}

				.${a("select__input-container")} {
					color: var(${r.text900});
				}

				.${a("select__single-value")} {
					color: var(${r.text900});
				}
			}

			.${a("select__control")} {
				border-radius: 5px;
				border: none;
				cursor: pointer;
				font-size: 1rem;
				min-height: 0;
				color: var(${r.text500});
				border: 1px solid var(${r.background300});
				background-color: transparent;
				box-shadow: none;

				&.${a("select__control--is-focused")} {
					color: var(${r.text300});
					border: 1px solid var(${r.primary500});
				}

				/* &.${a("select__control--menu-is-open")} {
        } */
			}

			.${a("select__indicator")} {
				padding: 0 8px;
			}

			.${a("select__indicator-separator")} {
				display: none;
			}

			.${a("select__menu")} {
				font-size: 1rem;
				/* color: var(${r.text500}); */
				z-index: 2;
			}

			.${a("select__option--is-disabled")} {
				opacity: 0.5;
			}

			.${a("select__input")} {
				input {
					transition: none;
					color: var(${r.text500});
				}
			}

			.${a("select__value-container")} {
				padding: 5px 10px;
			}

			.${a("select__single-value")} {
				color: var(${r.text500});
				padding: 0;
				margin: 0;
				display: flex;
				align-items: center;
				justify-content: flex-start;
				gap: 5px;
			}

			.${a("select__placeholder")} {
				margin: 0;
				padding: 0;
				color: var(${r.text700});
			}

			.${a("select__dropdown-indicator")} {
				color: var(${r.text500});

				&:hover {
					color: var(${r.text300});
				}
			}

			.${a("select__input-container")} {
				padding: 0;
				margin: 0;
				color: var(${r.text500});

				&:focus {
					color: var(${r.text100});
				}
			}

			.${a("select__menu")} {
				color: var(${r.text500});
				background-color: var(${r.background800});
				box-shadow: none;
			}

			.${a("select__menu-notice")} {
				color: inherit;
			}

			.${a("select__option")} {
				cursor: pointer;
				display: flex;
				align-items: center;
				justify-content: flex-start;
				gap: 5px;

				&.${a("select__option--is-focused")} {
					color: var(${r.text300});
					background-color: var(${r.background600});
				}

				&.${a("select__option--is-selected")} {
					color: var(${r.text100});
					background-color: var(${r.background500});
				}
			}
		}
	`}
`;import{Fragment as Ui,jsx as xe}from"react/jsx-runtime";var Fc=Vi(()=>import("react-select")),Dc=Vi(()=>import("react-select/async")),Ue=({value:e,...t})=>{let o=e;return typeof e!="object"&&typeof e<"u"&&(o=(t.options||[]).find(i=>i.value===e)),xe(so,{className:a("select"),onTouchEndCapture:i=>i.stopPropagation(),children:xe(Oi,{fallback:xe(Ui,{}),children:xe(Fc,{...t,className:a("select"),classNamePrefix:a("select"),value:o,onChange:(i,l)=>{var n;(n=t.onChange)==null||n.call(t,i.value,l)}})})})},co=e=>xe(so,{className:a("select"),children:xe(Oi,{fallback:xe(Ui,{}),children:xe(Dc,{...e,className:a("select"),classNamePrefix:a("select"),onChange:(t,o)=>{var i;(i=e.onChange)==null||i.call(e,t.value,o)}})})});import{v4 as Hc}from"uuid";import Ac,{css as Bc}from"styled-components";var Yi=Ac.div`
	${()=>Bc`
		display: flex;
		align-items: center;
		justify-content: flex-start;
		gap: 5px;
		flex-wrap: wrap;
		flex: 1;

		input[type='checkbox'] {
			display: none;

			&:checked {
				+ label {
					border-color: var(${r.primary500});
					color: var(${r.primary500});
				}
			}

			&:disabled {
				+ label {
					color: var(${r.text900});
					border-color: var(${r.text900});
				}
			}
		}

		label {
			outline: 0;
			position: relative;
			cursor: pointer;
			user-select: none;
			border-radius: 5px;
			padding: 5px 10px;
			line-height: 1;
			font-size: 1rem;
			transition: 0.2s;
			border: 1px solid var(${r.background300});
			color: var(${r.text500});
			display: flex;
			align-items: center;
			justify-content: center;

			img {
				max-width: 100%;
				max-height: 100%;
			}

			&:hover {
				border-color: var(${r.background100});
				color: var(${r.text100});
			}
		}
	`}
`;import{Fragment as Gc,jsx as st,jsxs as Wc}from"react/jsx-runtime";var po=e=>{let{value:t=[],options:o=[],onChange:i,allowMultiple:l=!0,size:n,disabled:s=!1,buttonStyle:d={},style:c={}}=e;n&&(d.width=`${n}px`,d.height=`${n}px`,d.padding="0px");function m(p){let f=t||[],v=f.indexOf(p),k=[];if(v<0){l?k=[...f,p]:k=[p],i(k?[...k]:[]);return}k=[...t],k.splice(v,1),i(k?[...k]:[])}return o!=null&&o.length?st(Yi,{className:a("toggle-group"),style:c,children:o.map(p=>{let f=`option_${Hc()}`,v=(t||[]).includes(p.value);return Wc("span",{children:[st("input",{type:"checkbox",id:f,onChange:()=>{m(p.value)},checked:v,disabled:p.disabled||s}),st("label",{htmlFor:f,title:p.tooltip||(v?"Remove":"Add"),style:d,children:p.label||p.value})]},f)})}):st(Gc,{children:"Missing options."})};import mo,{css as Oc}from"styled-components";var Xi=mo.div`
	${()=>Oc`
		.${a("items-manager-item")} {
			&.active,
			&:hover {
				.${a("css-props-editor-restore-button")} {
					display: flex;
				}
			}
		}

		.${a("items-manager-item-title")} {
			.${a("context-section-title-elm")} {
				color: var(${r.text300});
				transition: 0.2s;
			}

			&:hover {
				.${a("context-section-title-elm")} {
					color: var(${r.text100});
				}
			}
		}

		.${a("css-props-editor-restore-button")} {
			font-size: 1.2rem;
			margin-right: 5px;
			display: none;
		}

		.with-unlink {
			margin-bottom: 70px;
		}

		.${a("css-props-editor-unlink-container")} {
			position: absolute;
			left: 0;
			top: 100%;
			width: 100%;
			justify-content: space-between;
			margin-top: 15px;

			> div {
				display: flex;
				gap: 5px;
				align-items: center;
				justify-content: center;
			}

			.small {
				max-width: 55px;
				padding-right: 5px;
			}
		}

		input[type='number'].with-unit::-webkit-outer-spin-button,
		input[type='number'].with-unit::-webkit-inner-spin-button {
			display: none;
		}

		.unit-selector-popover {
			position: absolute;
			right: 4px;
			top: 50%;
			transform: translateY(-50%);
		}
	`}
`,Zi=mo.span`
	background-color: var(${r.background500});
	border-radius: 5px;
	color: var(${r.text500});
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	line-height: 1;
	height: 24px;
	aspect-ratio: 1;
	padding: 4px 0;
	cursor: pointer;
	transition: 0.2s;

	&:hover {
		color: var(${r.text100});
		background-color: var(${r.background300});
	}
`,ji=mo.div`
	display: flex;
	gap: 5px;
	flex-direction: column;
	padding: 5px 0;
	width: 24px;
	font-size: 12px;
	color: var(${r.text700});
	background-color: var(${r.background700});
	border-radius: 5px;
	text-align: center;

	button {
		padding: 0;
	}
`;import{Fragment as ct,jsx as C,jsxs as U}from"react/jsx-runtime";var Xc=e=>{let{value:t={},onChange:o,availablePropertiesGroups:i,fonts:l=[],getFontDetails:n,imageUploadElm:s}=e,d=_i(i),[c,m]=fo(!1);function p(h,u){let x={...t,...h};u&&Object.keys(x).forEach(y=>{(x[y]===void 0||x[y]===""||x[y]===null)&&delete x[y]}),o(x)}function f(h){return C(We,{children:h.displayName})}function v(h,u){var x;return h==="fontFamily"?l:h==="fontWeight"?[{label:"Default",value:""},...(((x=n==null?void 0:n(u))==null?void 0:x.weights)||[]).map(y=>({label:`${y}`,value:`${y}`}))]:ro[h]||[]}function k(h=[]){return h.map(u=>Zc({cssPropName:u,currentValue:t[u],value:t,onChange:p,customInput:u==="backgroundImage"?s:void 0,options:v(u,t.fontFamily||"")}))}function $(){return U(A,{style:{width:"100%",marginTop:20,marginBottom:20},variant:"expand",onClick:h=>{h.preventDefault(),m(!c)},children:[" ",c?C(Uc,{}):C(Vc,{}),c?"Hide ":"Show "," more options"]})}function b(h){let u=h.cssProperties||[];if(h.name==="background"||h.name==="typography"||h.name==="size"){let x=h.name==="typography"?4:2;if(u.length>x){let y=u.slice(0,x),S=u.slice(x);return U(ct,{children:[k(y),$(),C("div",{style:{display:c?"block":"none"},children:k(S)})]})}}return k(u)}function q(h){return C(Yc,{title:"Restore to default",className:a("css-props-editor-restore-button"),onClick:u=>{u.stopPropagation();let x={...t};(h.cssProperties||[]).forEach(y=>{x[y]=void 0}),o(x)}})}return C(Xi,{className:a("css-props-editor"),children:C(no,{items:d.map(h=>({...h,id:h.id||h.name})),titleRenderer:f,itemRenderer:b,extraActionsRenderer:q,headerMode:!0,addable:!1,sortable:!1,removable:!1,searchable:!1,duplicatable:!1})})},Zc=({cssPropName:e,currentValue:t,value:o,customInput:i,onChange:l,options:n})=>{let s=ro[e]||[],[d,c]=fo(s.some(q=>!!(o!=null&&o[q==null?void 0:q.value]))),[m,p]=fo(!1),f=e.replace(/([A-Z])/g," $1"),v=f.charAt(0).toUpperCase()+f.slice(1);function k(){var q,h;return oo.includes(e)?"":(q=ge[e])!=null&&q.unit?` (${(h=ge[e])==null?void 0:h.unit})`:""}function $(){var q;switch(e){case"backgroundColor":return C(O,{children:C(ao,{cssProps:o,onChange:l})});case"borderColor":case"color":case"textDecorationColor":return C(O,{children:C(Le,{onChange:u=>{let x={[e]:u};e==="borderColor"&&(x[e]?(o.borderWidth||(x.borderWidth=1),o.borderStyle||(x.borderStyle="solid")):(x.borderStyle=void 0,x.borderWidth=void 0)),l(x,!0)},selectedColor:t,position:"bottom",showUndo:!0,debounce:0})});case"backgroundImage":let h=t||"";return t!=null&&t.startsWith("linear-gradient")&&(h=""),C(O,{children:i||C(V,{type:"url",maxLength:400,placeholder:"Enter image URL",value:h.replace("url(","").replace(")",""),onChange:u=>l({[e]:`url(${u.target.value})`})})});case"backgroundPosition":case"objectPosition":case"textAlign":case"textTransform":case"textDecorationLine":return C(O,{children:C(po,{style:{justifyContent:"flex-end"},options:n,onChange:u=>{l({[e]:String(u[0])},!0)},allowMultiple:!1,value:t?[t]:[],size:30})});case"backgroundRepeat":case"backgroundSize":case"objectFit":case"borderStyle":case"fontWeight":case"fontStyle":case"fontFamily":case"textDecorationStyle":case"justifyContent":case"alignItems":return C(O,{children:C(Ue,{isSearchable:e==="fontFamily",value:n.filter(u=>u.value===t)[0]||n[0],options:n,onChange:u=>{let x={[e]:u};e==="borderStyle"&&(x[e]?(o.borderWidth||(x.borderWidth=1),o.borderColor||(x.borderColor="#000000")):(x.borderColor=void 0,x.borderWidth=void 0)),l(x,!0)}})});case"margin":case"padding":case"borderWidth":case"borderRadius":{let u=parseFloat(t);return U(ct,{children:[U(O,{children:[C(V,{type:"number",value:u,onChange:x=>{var S;let y={[e]:isNaN(x.target.valueAsNumber)?void 0:`${x.target.valueAsNumber}${((S=ge[e])==null?void 0:S.unit)||"px"}`};e==="borderWidth"&&(y[e]?(o.borderStyle||(y.borderStyle="solid"),o.borderColor||(y.borderColor="#000000")):(y.borderStyle=void 0,y.borderColor=void 0)),l(y,!0)},placeholder:"Auto",className:"small",step:((q=ge[e])==null?void 0:q.step)||1,disabled:d}),C(A,{variant:"transparent",onClick:()=>{c(!d);let x={[e]:""};s.forEach(y=>{x[y.value]=""}),l(x,!0)},children:d?C(T.Unlink,{}):C(T.Link,{})})]}),d&&C(O,{className:a("css-props-editor-unlink-container"),children:s.map(x=>{var y;return U("div",{children:[x.label,C(V,{type:"number",value:parseFloat(o[x.value]||"0"),onChange:S=>{var w;return l({[e]:void 0,[x.value]:isNaN(S.target.valueAsNumber)?void 0:`${S.target.value}${((w=ge[e])==null?void 0:w.unit)||"px"}`},!0)},placeholder:"Auto",className:"small",step:((y=ge[e])==null?void 0:y.step)||1})]},`${e}-${x.value}`)})})]})}case"letterSpacing":case"lineHeight":case"height":case"width":case"minHeight":case"minWidth":case"maxHeight":case"maxWidth":case"fontSize":case"textDecorationThickness":case"gap":{let[u,x]=Ti(t),y=oo.includes(e),S=C(ct,{});return y&&(S=C(Be,{open:m,onOpenChange:w=>p(w),align:"center",className:"unit-selector-popover",contentElm:U(ji,{children:[C(A,{variant:"transparent",onClick:w=>{w.preventDefault(),l({[e]:void 0},!0),p(!1)},children:"px"}),C(A,{variant:"transparent",onClick:w=>{w.preventDefault(),l({[e]:"100%"},!0),p(!1)},children:"%"})]}),children:C(Zi,{title:"Click to Select a Unit",children:x||"px"})})),U(O,{children:[e==="lineHeight"&&C(T.LineHeight,{}),e==="letterSpacing"&&C(T.LetterSpacing,{}),C(V,{type:"number",value:u||"",onChange:w=>{var L;return l({[e]:isNaN(w.target.valueAsNumber)?void 0:`${w.target.valueAsNumber}${x||((L=ge[e])==null?void 0:L.unit)||"px"}`},!0)},placeholder:"Auto",className:`small ${y?"with-unit":""}`}),S]})}default:return C(O,{children:C(V,{type:"text",value:t||"",onChange:u=>l({[e]:u.target.value},!0),placeholder:"Enter text...",className:"small"})})}}function b(){let q=o==null?void 0:o.boxShadow,[h="0px",u="0px",x="0px",y="0px",S=""]=(q==null?void 0:q.split(" "))||[];return U(ct,{children:[U(oe,{flow:"row",children:[C(he,{children:"Color"}),C(O,{children:C(Le,{onChange:w=>{l({boxShadow:`${h} ${u} ${x} ${y} ${w}`})},colorFormat:"rgb",enableTransparency:!0,selectedColor:S,position:"bottom",showUndo:!0,debounce:0})})]}),U(oe,{flow:"row",children:[C(he,{children:"X Offset"}),C(O,{children:C(V,{type:"number",value:parseFloat(h)||0,onChange:w=>l({boxShadow:`${w.target.valueAsNumber||0}px ${u} ${x} ${y} ${S}`}),placeholder:"0",className:"small",step:1})})]}),U(oe,{flow:"row",children:[C(he,{children:"Y Offset"}),C(O,{children:C(V,{type:"number",value:parseFloat(u)||0,onChange:w=>l({boxShadow:`${h} ${w.target.valueAsNumber||0}px ${x} ${y} ${S}`}),placeholder:"0",className:"small",step:1})})]}),U(oe,{flow:"row",children:[C(he,{children:"Blur"}),C(O,{children:C(V,{type:"number",value:parseFloat(x)||0,onChange:w=>l({boxShadow:`${h} ${u} ${w.target.valueAsNumber||0}px ${y} ${S}`}),placeholder:"0",className:"small",step:1})})]}),U(oe,{flow:"row",children:[C(he,{children:"Spread"}),C(O,{children:C(V,{type:"number",value:parseFloat(y)||0,onChange:w=>l({boxShadow:`${h} ${u} ${x} ${w.target.valueAsNumber}px ${S}`}),placeholder:"0",className:"small",step:1})})]})]})}return e==="boxShadow"?b():U(oe,{flow:"row",className:d?"with-unlink":"",children:[U(he,{children:[v,k()]}),$()]},e)};import{FaChevronLeft as dt}from"@react-icons/all-files/fa/FaChevronLeft";import{FaChevronRight as pt}from"@react-icons/all-files/fa/FaChevronRight";import{FaRegCalendarAlt as Ki}from"@react-icons/all-files/fa/FaRegCalendarAlt";import{FaRegClock as Qi}from"@react-icons/all-files/fa/FaRegClock";import Ye from"classnames";import Qc,{Suspense as Ji,useEffect as ea,useRef as ta}from"react";import jc,{createGlobalStyle as Kc}from"styled-components";var uo=jc.div`
	position: relative;
	width: 100%;

	input {
		border: 1px solid var(${r.text700});
		background-color: transparent;
		color: var(${r.text500});
		outline: none;
		padding: 7px 50px 7px 10px;
		font-family: var(${r.primaryFont});
		transition: 0.2s;
		border-radius: 5px;
		line-height: 1;
		font-size: 1rem;
		width: 100%;
		cursor: pointer;

		&:focus {
			color: var(${r.text100});
			border-color: var(${r.primary500});
		}

		&:disabled {
			color: var(${r.text900});
			border-color: var(${r.text900});
		}

		::placeholder {
			color: var(${r.text700});
		}
	}

	.${a("date-picker-icon")} {
		position: absolute;
		right: 7px;
		font-size: 1.1rem;
		top: 50%;
		transform: translateY(-50%);
		color: var(${r.text500});
		cursor: pointer;
	}

	.${a("date-picker-clear-button")} {
		position: absolute;
		right: 25px;
		font-size: 1.1rem;
		top: 50%;
		transform: translateY(-50%);
		color: var(${r.text500});
		cursor: pointer;
		background-color: transparent;
		border: none;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 20px;

		&:before {
			content: 'x';
		}
	}

	span[role='alert'] {
		display: none;
	}
`,bo=Kc`
	${({vars:e={}})=>`
			.react-datepicker-popper {
				z-index: 999;

				&.custom-vars {
					${Object.keys(e).map(o=>`${o.startsWith("--")?o:"--"+o}: ${e[o]};`).join(`
`)}

					.${a("date-picker")} {
						border: 1px solid var(${r.text500});
					}
				}
			}
			
			.${a("date-picker")} {
				background: var(${r.background800});
				color: var(${r.text500});
				width: 220px;
				padding: 10px;
				border-radius: 10px;
				
				.react-datepicker__header {
					display: flex;
					flex-direction: column;
					gap: 10px;
					align-items: center;
					position: relative;
					padding-top: 10px;
				}

				.react-datepicker__aria-live {
					display: none;
				}
				
				.react-datepicker__navigation {
					background: none;
					border: none;
					position: absolute;
					top: 27px;
					font-size: 1.1rem;
					color: var(${r.text300});
					z-index: 2;
					cursor: pointer;
					transition: 0.2s;

					&:hover {
						color: var(${r.text100});
					}

					&.react-datepicker__navigation--previous {
						left: 15px;
					}

					&.react-datepicker__navigation--next {
						right: 15px;
					}
				}

				.react-datepicker__current-month {
					color: var(${r.text500});
					font-size: 1rem;
					height: 30px;
					display: flex;
					align-items: center;
				}

				.react-datepicker__day-names {
					display: flex;
					justify-content: space-evenly;
					width: 100%;
					gap: 0;
					text-transform: uppercase;
					font-size: 0.8rem;
					color: var(${r.text500});
					text-align: center;

					> * {
						flex: 1;
					}
				}

				.react-datepicker__month {
					margin-top: 10px;
					display: flex;
					flex-direction: column;
					gap: 0;
				}

				.react-datepicker__week {
					display: flex;
					justify-content: space-evenly;
					width: 100%;
					gap: 0;
					font-size: 0.9rem;
					color: var(${r.text300});
					text-align: center;
				}
				
				.react-datepicker__day {
					flex: 1;
					padding: 7px;
					cursor: pointer;
					border-radius: 5px;
					transition: 0.2s;
					position: relative;

					&:hover {
						color: var(${r.text100});
						background-color: var(${r.text700});
					}

					&.react-datepicker__day--in-selecting-range {
						box-shadow: 0 0 0 1px var(${r.text700});
					}

					&.react-datepicker__day--outside-month, &.react-datepicker__day--disabled {
						opacity: 0.5;
					}

					&.react-datepicker__day--selected, &.react-datepicker__day--in-range {
						color: var(${r.primary500});
						background-color: transparent;
						
						&::after {
							content: '';
							height: 2px;
							background-color: var(${r.primary500});
							width: 100%;
							position: absolute;
							left: 0;
							bottom: -1px;
						}
					}
				}

				// Time picker
				&.react-datepicker--time-only {
					width: 120px;
					text-align: center;
				}

				.react-datepicker__month-container { 
					& + .react-datepicker__time-container {
						position: absolute;
						left: 100%;
						top: 0;
						padding-left: 0;
						background: var(${r.background800});
						height: 100%;
						border-radius: 10px;
						margin-left: -15px;
						width: 90px;

						.react-datepicker__time {
							max-height: 90%;
							margin-top: 15px;
							text-align: center;
						}
					}
				}

				.react-datepicker__time-container {
					.react-datepicker__header {
						display: none;
					}
				}

				.react-datepicker__time {
					max-height: 100px;
					overflow: auto;
				}

				.react-datepicker__time-list {
					display: flex;
					flex-direction: column;
					gap: 5px;
				}

				.react-datepicker__time-list-item {
					cursor: pointer;
					transition: 0.2s;
					
					&:hover {
						color: var(${r.text100});
					}

					&.react-datepicker__time-list-item--selected {
						color: var(${r.primary500});
					}

					&.react-datepicker__time-list-item--disabled {
						display: none;
					}
				}
			}
		`}
`;import{Fragment as ra,jsx as E,jsxs as ia}from"react/jsx-runtime";var oa=Qc.lazy(()=>import("react-datepicker")),Jc=e=>{if(typeof document>"u")return E(ra,{});let t=ta(null),o=a("date-picker-portal"),i=document.getElementById(o);return ea(()=>{i=document.getElementById(o),i||(i=document.createElement("div"),i.setAttribute("id",o),document.body.append(i))},[]),ia(uo,{className:Ye(a("date-picker-wrapper"),e.className),ref:t,children:[E(bo,{vars:e.customCSSVars}),E(Ji,{fallback:E(J,{size:14}),children:E(oa,{placeholderText:"Enter date...",...e,calendarClassName:`${a("date-picker")} ${e.className||""}`,popperClassName:Ye({"custom-vars":!!e.customCSSVars}),clearButtonClassName:a("date-picker-clear-button"),previousMonthButtonLabel:E(dt,{}),nextMonthButtonLabel:E(pt,{}),previousYearButtonLabel:E(dt,{}),nextYearButtonLabel:E(pt,{}),portalId:e.withPortal!==!1?o:void 0})}),e.showTimeSelectOnly?E(Qi,{className:a("date-picker-icon"),onClick:()=>{var l,n,s;(s=(n=(l=t.current)==null?void 0:l.querySelector)==null?void 0:n.call(l,'input[type="text"]'))==null||s.focus()}}):E(Ki,{className:a("date-picker-icon"),onClick:()=>{var l,n,s;(s=(n=(l=t.current)==null?void 0:l.querySelector)==null?void 0:n.call(l,'input[type="text"]'))==null||s.focus()}})]})},ed=e=>{if(typeof document>"u")return E(ra,{});let t=ta(null),o=a("date-picker-portal"),i=document.getElementById(o);ea(()=>{i=document.getElementById(o),i||(i=document.createElement("div"),i.setAttribute("id",o),document.body.append(i))},[]);let[l,n]=Array.isArray(e.selected)?e.selected:[];return ia(uo,{className:Ye(a("date-picker-wrapper"),e.className),ref:t,children:[E(bo,{vars:e.customCSSVars}),E(Ji,{fallback:E(J,{size:14}),children:E(oa,{placeholderText:"Enter dates...",...e,onChange:e.onChange,selected:void 0,selectsRange:!0,isClearable:!0,startDate:l?new Date(l):void 0,endDate:n?new Date(n):void 0,calendarClassName:Ye(a("date-picker"),e.className),previousMonthButtonLabel:E(dt,{}),nextMonthButtonLabel:E(pt,{}),previousYearButtonLabel:E(dt,{}),nextYearButtonLabel:E(pt,{}),clearButtonClassName:a("date-picker-clear-button"),portalId:e.withPortal!==!1?o:void 0,popperClassName:Ye({"custom-vars":!!e.customCSSVars})})}),e.showTimeSelectOnly?E(Qi,{className:a("date-picker-icon"),onClick:()=>{var s,d,c;(c=(d=(s=t.current)==null?void 0:s.querySelector)==null?void 0:d.call(s,'input[type="text"]'))==null||c.focus()}}):E(Ki,{className:a("date-picker-icon"),onClick:()=>{var s,d,c;(c=(d=(s=t.current)==null?void 0:s.querySelector)==null?void 0:d.call(s,'input[type="text"]'))==null||c.focus()}})]})};import{FaChevronLeft as nd}from"@react-icons/all-files/fa/FaChevronLeft";import{FaTimes as sd}from"@react-icons/all-files/fa/FaTimes";import go from"classnames";import{useEffect as sa,useState as cd}from"react";import{StyleSheetManager as dd}from"styled-components";import td,{useEffect as od}from"react";import rd from"react-dom";import aa from"styled-components";import{Fragment as ad,jsx as ld}from"react/jsx-runtime";var id=({className:e="",children:t})=>{if(typeof document>"u")return ld(ad,{});let o=a("drawer-portal"),i=document.getElementById(o),[l]=td.useState(()=>{let n=document==null?void 0:document.createElement("div");return n.className=`${e||""}`,n});return od(()=>(i=document.getElementById(o),i||(i=document.createElement("div"),i.setAttribute("id",o),document.body.append(i)),i.appendChild(l),()=>{i.removeChild(l)}),[]),rd.createPortal(t,l)},la=aa(id)`
	* {
		box-sizing: border-box;
	}

	.${a("drawer-overlay")} {
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: 995;
		background: rgba(0, 0, 0, 0.85);
		opacity: 0;
		transition: opacity 0.2s ease;
		pointer-events: none;

		&.faded-in {
			opacity: 1;
			pointer-events: all;
		}
	}

	&.left {
		.${a("drawer-content")} {
			left: var(--drawer-distance);
			transform: translateX(calc(-100% - var(--drawer-distance)));
		}
	}

	&.right {
		.${a("drawer-content")} {
			right: var(--drawer-distance);
			transform: translateX(calc(100% + var(--drawer-distance)));
		}
	}

	.${a("drawer-content")} {
		z-index: 999;
		position: fixed;
		top: 0;
		height: 100%;
		max-width: 100%;
		width: var(--drawer-size);
		overflow: hidden;
		overflow-y: scroll;
		transition: all 0.2s ease;
		background: var(${r.background700});
		color: var(${r.text500});
		pointer-events: none;

		--sb-track-color: var(${r.background700});
		--sb-thumb-color: var(${r.background300});
		--sb-size: 9px;

		scrollbar-color: var(--sb-thumb-color) var(--sb-track-color);
		scrollbar-width: thin;

		&::-webkit-scrollbar {
			width: var(--sb-size);
			background-color: var(--sb-track-color);
		}

		&::-webkit-scrollbar-track {
			background: var(--sb-track-color);
			border-radius: 10px;
		}

		&::-webkit-scrollbar-thumb {
			background: var(--sb-thumb-color);
			border-radius: 10px;
			margin-right: 1px;
		}

		&.faded-in {
			transform: translateX(0);
			pointer-events: all;
		}

		.${a("drawer-close-button")} {
			position: absolute;
			right: 10px;
			top: 10px;
			cursor: pointer;
			font-size: 22px;
			background: none;
			border: none;
			transition: 0.2s;
			z-index: 10;
			color: var(${r.text500});

			&:hover {
				color: var(${r.text100});
			}
		}
	}
`,na=aa.div`
	display: flex;
	justify-content: center;
	gap: 10px;
	align-items: center;
	margin: 20px 0;
	position: relative;

	button {
		position: absolute;
		left: 0;
	}

	.nindo-context-section-title {
		margin: 0;
		max-width: 50%;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.css-props-editor-title {
		span {
			width: 100%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}
`;import{Fragment as md,jsx as ye,jsxs as mt}from"react/jsx-runtime";var pd=({show:e,position:t="right",showCloseButton:o=!0,closeCallback:i,overlay:l=!0,backgroundMode:n=!1,showBackButton:s=!1,title:d,...c})=>{let[m,p]=cd(!1),f=k=>{k.preventDefault(),i()},v=k=>{e&&k.keyCode===27&&f(k)};return sa(()=>{if(!(typeof document>"u"))return document==null||document.addEventListener("keydown",v),()=>{document==null||document.removeEventListener("keydown",v)}},[]),sa(()=>{e?window.setTimeout(()=>{if(typeof window>"u"){p(!0);return}p(!0)},100):p(!1)},[e]),n||e?ye(dd,{target:document.head,children:mt(la,{...c,className:go(a("drawer"),c.className,t),children:[l&&ye("div",{className:go(a("drawer-overlay"),{"faded-in":m}),onClick:k=>f(k)}),mt("div",{...c,className:go(a("drawer-content"),{"faded-in":m}),style:{...c.style||{},"--drawer-size":`${c.size}px`,"--drawer-distance":`${c.distance}px`},children:[s&&mt(na,{children:[mt(A,{variant:"transparent",className:"close-css-props-editor",onClick:k=>f(k),children:[ye(nd,{}),ye("span",{children:"Back"})]}),d&&ye(We,{className:"css-props-editor-title",children:d})]}),c.children,o&&ye("button",{title:"Close",className:a("drawer-close-button"),onClick:k=>f(k),children:ye(sd,{size:18})})]})]})}):ye(md,{})};import{FaUpload as bd}from"@react-icons/all-files/fa/FaUpload";import gd from"classnames";import{useRef as hd}from"react";import fd,{css as ud}from"styled-components";var ca=fd.span`
  ${()=>ud`
		display: inline-flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;

		> svg {
			color: var(${r.text500});
			font-size: 1.1rem;
			transition: 0.2s;
		}

		&:hover {
			> svg {
				color: var(${r.text100});
			}
		}
  `}
`;var F=new Map;F.set("image","image/*");F.set("csv","text/csv");F.set("pdf","application/pdf");F.set("audio","audio/*");F.set("video","video/*");F.set("json","application/json");F.set("zip","application/zip");F.set("xml","application/xml");F.set("docx","application/vnd.openxmlformats-officedocument.wordprocessingml.document");F.set("doc","application/msword");F.set("xls","application/vnd.ms-excel");F.set("xlsx","application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");F.set("ppt","application/vnd.ms-powerpoint");F.set("pptx","application/vnd.openxmlformats-officedocument.presentationml.presentation");F.set("txt","text/plain");F.set("html","text/html");F.set("css","text/css");F.set("js","text/javascript");F.set("","");import{Fragment as vd,jsx as ho,jsxs as yd}from"react/jsx-runtime";var xd=e=>{let{children:t,acceptType:o="",upload:i,errorCallback:l,uploadStartCallback:n,successCallback:s,sizeLimitInMB:d=5,disabled:c,disabledCallback:m,allowMultiple:p=!1,maxUploads:f,fileSizeLimitExceedCallback:v}=e,k=F.get(o),$=hd(null);function b(y){W.removeAll(),W.error({title:y,autoDismiss:4.5})}function q(y){W.removeAll(),W.info({title:"Uploading file...",dismissible:"none"})}function h(){if(!!$.current){if(c){m==null||m();return}$.current.click()}}async function u(y,S=0){if(S>=y.length)return;let w=y[S];try{if(o==="image"){if(w.type.indexOf("image/")<0)throw new Error("Only png, jpg, and gif formats are allowed.")}else if(k&&!w.type.includes(k.replace("*","")))throw new Error("Unsupported file type.");let L=w.size/1e3/1e3;if(d&&L>d){v==null||v(),W.removeAll();return}let{success:Y,message:B="",url:H="",data:j}=await(i==null?void 0:i(w))||{success:!1,message:"Missing upload function prop."};if(W.removeAll(),Y)if(H)s(H,j,w);else throw new Error("Missing URL in upload callback.");else throw new Error(B)}catch(L){W.removeAll(),(l||b)(L.message||"Could not upload file. Please contact the support team.",w)}finally{await u(y,S+1)}}async function x(y){let w=y.target.files;if(!w||w.length===0)return;if(typeof f=="number"&&w.length>f){W.removeAll(),(l||b)(`You can only upload ${f} files at a time.`,w[0]);return}let L=Array.from(w);(n||q)(L),await u(w)}return ho(vd,{children:yd(ca,{...e,className:gd(a("file-upload"),e.className),onClick:h,children:[ho("input",{type:"file",name:"file",style:{display:"none"},ref:$,onChange:x,accept:k,multiple:p}),t||ho(bd,{title:"Upload file"})]})})};import wd from"classnames";import qd,{css as kd}from"styled-components";var da=qd.p`
	${()=>kd`
		line-height: 1.4;

		.${a("form-description")} {
			color: var(${r.text500});
			font-size: 0.85rem;
		}
	`}
`;import{jsx as Cd}from"react/jsx-runtime";var Sd=({size:e="small",color:t="",...o})=>{let i="0.93rem",l={};if(typeof e=="number")i=`${e}px`;else switch(e){case"small":i="0.86rem";break;case"medium":i="0.93rem";break;case"large":i="1rem";break;default:break}return t&&(l={color:t}),Cd(da,{...o,style:{...o.style,...l,fontSize:i},className:wd(a("form-description"),o.className),children:(o==null?void 0:o.children)||""})};import{RiArticleLine as Pd}from"@react-icons/all-files/ri/RiArticleLine";import $d,{css as Id}from"styled-components";var pa=$d.div`
	${e=>Id`
		display: flex;
		flex-direction: column;
		align-items: stretch;
		gap: 20px;
		font-size: 12px;

		a {
			display: flex;
			gap: 10px;
			align-items: flex-start;
			padding: 10px 15px;
			border-radius: 5px;
			color: var(${r.text300});
			background-color: var(${r.background700});
			box-shadow: inset 0 0 0 1px var(${r.background300});
			transition: 0.2s;
			line-height: 1.4;

			svg {
				font-size: 32px;
				color: var(${r.text500});
				transition: 0.2s;
			}

			&:hover {
				box-shadow: inset 0 0 0 1px var(${r.primary100});
				text-decoration: none;
				color: var(${r.text300});

				svg {
					color: var(${r.text100});
				}
			}
		}
	`}
`;import{jsx as xo,jsxs as _d}from"react/jsx-runtime";var Td=({articles:e,iconStyle:t={},...o})=>xo(pa,{articles:[],...o,children:e.map(i=>_d("a",{href:i.link,target:"_blank",rel:"noreferrer",children:[xo(Pd,{style:t}),xo("span",{dangerouslySetInnerHTML:{__html:i.text.replace(/\n/g,"<br />")}})]},i.link))});import{FaMinus as Nd}from"@react-icons/all-files/fa/FaMinus";import{FaRegImages as fa}from"@react-icons/all-files/fa/FaRegImages";import Md from"classnames";import Ld,{css as zd}from"styled-components";var ma=Ld.div`
	${({size:e=void 0})=>{let t=(e==null?void 0:e.width)||100,o=(e==null?void 0:e.height)||100;return typeof t=="number"&&(t=`${t}px`),typeof o=="number"&&(o=`${o}px`),zd`
			position: relative;
			width: ${t};
			height: ${o};
			border-radius: 5px;
			color: var(${r.text500});
			background-color: transparent;
			border: 2px dashed var(${r.background300});
			display: flex;
			align-items: center;
			justify-content: center;

			.${a("image-upload-remove-button")} {
				position: absolute;
				right: -8px;
				top: -7px;
				z-index: 1;
				padding: 0;
				margin: 0;
				border-radius: 50em;
				width: 18px;
				height: 18px;
				font-size: 0.8rem;
				border: none;
				display: flex;
				justify-content: center;
				align-items: center;
				opacity: 0;
				transition: 0.2s;
				cursor: pointer;
				background: var(${r.background500});
				color: var(${r.text300});

				&:hover {
					background: var(${r.background300});
					color: var(${r.text100});
				}
			}

			.${a("image-upload-label")} {
				position: absolute;
				left: 0;
				bottom: 0;
				padding: 5px 10px;
				font-size: 12px;
				color: var(${r.white});
				background-color: var(${r.primary500});
				border-radius: inherit;
				border-top-left-radius: 0;
				border-bottom-right-radius: 0;
			}

			.${a("image-upload-hover")} {
				border-radius: 5px;
				background-color: var(${r.background800});
				position: absolute;
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
				color: var(${r.text100});
				opacity: 0;
				transition: 0.2s;
				z-index: 1;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				font-size: ${parseInt(String(o))/2}px;
			}

			&:hover {
				.${a("image-upload-hover")} {
					opacity: 0.9;
				}

				.${a("image-upload-remove-button")} {
					opacity: 1;
				}
			}

			img.${a("image-upload-image")} {
				width: 100%;
				height: 100%;
				object-fit: cover;
				border-radius: 5px;
			}

			> svg {
				font-size: ${parseInt(String(o))/2}px;
			}
		`}}
`;import{jsx as $e,jsxs as Ed}from"react/jsx-runtime";var Rd=({imageUrl:e,onClick:t,onRemove:o,filePlaceholder:i,label:l,children:n,...s})=>{function d(){return n||(e?$e("img",{className:a("image-upload-image"),src:e,alt:"Upload Image"}):i||$e(fa,{}))}return Ed(ma,{...s,className:Md(a("image-upload"),s.className),children:[d(),l&&$e("div",{className:a("image-upload-label"),children:l}),$e("span",{className:a("image-upload-hover"),onClick:t,title:"Upload Image",children:i||$e(fa,{})}),o&&e&&$e("span",{className:a("image-upload-remove-button"),onClick:c=>{c.stopPropagation(),o(c)},title:"Remove",children:$e(Nd,{})})]})};import ba from"classnames";import Ad,{useEffect as Bd,useState as Hd}from"react";import Fd,{css as Dd}from"styled-components";var ua=Fd.nav`
  ${e=>Dd`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
    line-height: 1.4;
    font-size: 1.2rem;

    .${a("list-item")} {
      background: none;
      border: none;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: ${e.align||"flex-start"};
      gap: 15px;
      color: var(${r.text500});
      cursor: pointer;
      width: 100%;
      font-weight: 400;
      font-family: var(${r.primaryFont});
      transition: 0.2s;
      margin: 0;
      padding: 0;
      font-size: inherit;
      line-height: inherit;

      &:hover {
        color: var(${r.text100});
      }

      &.active {
        color: var(${r.primary500});
      }

      img {
        max-width: 30px;
        max-height: 30px;
        margin-top: -3px;
      }

      > svg {
        font-size: 1.4rem;
        margin-top: 1px;
      }
    }

    .${a("list-sublist")} {
      position: relative;
      padding: 0 0 10px;

      .${a("list-sublist-title")} {
        font-size: 0.9rem;
        margin-bottom: 20px;
      }

      .${a("list-item")} {
        margin-left: 10px;
      }
    }
  `}
`;import{Fragment as Wd,jsx as yo,jsxs as vo}from"react/jsx-runtime";var Gd=({activeKey:e,onButtonClick:t,buttonStyles:o,...i})=>{var c;let[l,n]=Hd(e||((c=i.items[0])==null?void 0:c.key)||"");function s(m){return m.key?vo("button",{className:ba(a("list-item"),{active:l===m.key||""}),onClick:p=>{t==null||t(p,m)},style:o,children:[m.icon&&m.icon,m.title&&m.title]},`menu-${m.key}`):yo(Wd,{})}function d(m){var p;return vo("div",{className:a("list-sublist"),children:[(m==null?void 0:m.title)&&yo("div",{className:a("list-sublist-title"),children:m==null?void 0:m.title}),(p=m==null?void 0:m.items)==null?void 0:p.map(s)]})}return Bd(()=>{typeof e<"u"&&n(e)},[e]),yo(ua,{...i,className:ba(a("list"),i.className),children:i.items.map(m=>{var p,f;return vo(Ad.Fragment,{children:[m.key&&s(m),((f=(p=m.submenu)==null?void 0:p.items)==null?void 0:f.length)&&d(m.submenu)]},`list-${m.key}`)})})};import{FaCheck as Ip}from"@react-icons/all-files/fa/FaCheck";import za from"classnames";import $a,{useEffect as Vd,useState as Ud}from"react";import{jsx as Yd}from"react/jsx-runtime";import{useEffect as ga,useRef as Kd,useState as qo}from"react";import{useEffect as Qd,useRef as Jd}from"react";import{useCallback as tp,useEffect as ha,useMemo as op,useRef as rp}from"react";import{useCallback as ap,useEffect as xa,useMemo as ya,useRef as ko,useState as ft}from"react";import{jsx as va,jsxs as sp}from"react/jsx-runtime";import{useRef as cp}from"react";import{jsx as qa,jsxs as dp}from"react/jsx-runtime";import{jsx as ka}from"react/jsx-runtime";import{Fragment as up,jsx as wo}from"react/jsx-runtime";import{jsx as Ie,jsxs as So}from"react/jsx-runtime";import{jsx as wa}from"react/jsx-runtime";import{jsx as Sa}from"react/jsx-runtime";import{jsx as Co}from"react/jsx-runtime";import{jsx as le,jsxs as Ca}from"react/jsx-runtime";import{jsx as $o}from"react/jsx-runtime";function Od(e,{insertAt:t}={}){if(!e||typeof document>"u")return;let o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("style");i.type="text/css",t==="top"&&o.firstChild?o.insertBefore(i,o.firstChild):o.appendChild(i),i.styleSheet?i.styleSheet.cssText=e:i.appendChild(document.createTextNode(e))}Od(`.rmsc{--rmsc-main: #4285f4;--rmsc-hover: #f1f3f5;--rmsc-selected: #e2e6ea;--rmsc-border: #ccc;--rmsc-gray: #aaa;--rmsc-bg: #fff;--rmsc-p: 10px;--rmsc-radius: 4px;--rmsc-h: 38px}.rmsc *{box-sizing:border-box;transition:all .2s ease}.rmsc .gray{color:var(--rmsc-gray)}.rmsc .dropdown-content{position:absolute;z-index:1;top:100%;width:100%;padding-top:8px}.rmsc .dropdown-content .panel-content{overflow:hidden;border-radius:var(--rmsc-radius);background:var(--rmsc-bg);box-shadow:0 0 0 1px #0000001a,0 4px 11px #0000001a}.rmsc .dropdown-container{position:relative;outline:0;background-color:var(--rmsc-bg);border:1px solid var(--rmsc-border);border-radius:var(--rmsc-radius)}.rmsc .dropdown-container[aria-disabled=true]:focus-within{box-shadow:var(--rmsc-gray) 0 0 0 1px;border-color:var(--rmsc-gray)}.rmsc .dropdown-container:focus-within{box-shadow:var(--rmsc-main) 0 0 0 1px;border-color:var(--rmsc-main)}.rmsc .dropdown-heading{position:relative;padding:0 var(--rmsc-p);display:flex;align-items:center;width:100%;height:var(--rmsc-h);cursor:default;outline:0}.rmsc .dropdown-heading .dropdown-heading-value{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1}.rmsc .clear-selected-button{cursor:pointer;background:none;border:0;padding:0;display:flex}.rmsc .options{max-height:260px;overflow-y:auto;margin:0;padding-left:0}.rmsc .options li{list-style:none;margin:0}.rmsc .select-item{box-sizing:border-box;cursor:pointer;display:block;padding:var(--rmsc-p);outline-offset:-1px;outline-color:var(--rmsc-primary)}.rmsc .select-item:hover{background:var(--rmsc-hover)}.rmsc .select-item.selected{background:var(--rmsc-selected)}.rmsc .no-options{padding:var(--rmsc-p);text-align:center;color:var(--rmsc-gray)}.rmsc .search{width:100%;position:relative;border-bottom:1px solid var(--rmsc-border)}.rmsc .search input{background:none;height:var(--rmsc-h);padding:0 var(--rmsc-p);width:100%;outline:0;border:0;font-size:1em}.rmsc .search input:focus{background:var(--rmsc-hover)}.rmsc .search-clear-button{cursor:pointer;position:absolute;top:0;right:0;bottom:0;background:none;border:0;padding:0 calc(var(--rmsc-p) / 2)}.rmsc .search-clear-button [hidden]{display:none}.rmsc .item-renderer{display:flex;align-items:baseline}.rmsc .item-renderer input{margin:0 5px 0 0}.rmsc .item-renderer.disabled{opacity:.5}.rmsc .spinner{animation:rotate 2s linear infinite}.rmsc .spinner .path{stroke:var(--rmsc-border);stroke-width:4px;stroke-linecap:round;animation:dash 1.5s ease-in-out infinite}@keyframes rotate{to{transform:rotate(360deg)}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}
`);var Xd={allItemsAreSelected:"All items are selected.",clearSearch:"Clear Search",clearSelected:"Clear Selected",noOptions:"No options",search:"Search",selectAll:"Select All",selectAllFiltered:"Select All (Filtered)",selectSomeItems:"Select...",create:"Create"},Zd={value:[],hasSelectAll:!0,className:"multi-select",debounceDuration:200,options:[]},Ia=$a.createContext({}),jd=({props:e,children:t})=>{let[o,i]=Ud(e.options),l=n=>{var s;return((s=e.overrideStrings)==null?void 0:s[n])||Xd[n]};return Vd(()=>{i(e.options)},[e.options]),Yd(Ia.Provider,{value:{t:l,...Zd,...e,options:o,setOptions:i},children:t})},bt=()=>$a.useContext(Ia);function ep(e,t){let o=Jd(!1);Qd(()=>{o.current?e():o.current=!0},t)}var ip={when:!0,eventTypes:["keydown"]};function ut(e,t,o){let i=op(()=>Array.isArray(e)?e:[e],[e]),l=Object.assign({},ip,o),{when:n,eventTypes:s}=l,d=rp(t),{target:c}=l;ha(()=>{d.current=t});let m=tp(p=>{i.some(f=>p.key===f||p.code===f)&&d.current(p)},[i]);ha(()=>{if(n&&typeof window<"u"){let p=c?c.current:window;return s.forEach(f=>{p&&p.addEventListener(f,m)}),()=>{s.forEach(f=>{p&&p.removeEventListener(f,m)})}}},[n,s,i,c,t])}var Z={ARROW_DOWN:"ArrowDown",ARROW_UP:"ArrowUp",ENTER:"Enter",ESCAPE:"Escape",SPACE:"Space"},lp=(e,t)=>{let o;return function(...i){clearTimeout(o),o=setTimeout(()=>{e.apply(null,i)},t)}};function np(e,t){return t?e.filter(({label:o,value:i})=>o!=null&&i!=null&&o.toLowerCase().includes(t.toLowerCase())):e}var Pa=()=>sp("svg",{width:"24",height:"24",fill:"none",stroke:"currentColor",strokeWidth:"2",className:"dropdown-search-clear-icon gray",children:[va("line",{x1:"18",y1:"6",x2:"6",y2:"18"}),va("line",{x1:"6",y1:"6",x2:"18",y2:"18"})]}),pp=({checked:e,option:t,onClick:o,disabled:i})=>dp("div",{className:`item-renderer ${i?"disabled":""}`,children:[qa("input",{type:"checkbox",onChange:o,checked:e,tabIndex:-1,disabled:i}),qa("span",{children:t.label})]}),mp=pp,fp=({itemRenderer:e=mp,option:t,checked:o,tabIndex:i,disabled:l,onSelectionChanged:n,onClick:s})=>{let d=cp(),c=f=>{m(),f.preventDefault()},m=()=>{l||n(!o)},p=f=>{m(),s(f)};return ut([Z.ENTER,Z.SPACE],c,{target:d}),ka("label",{className:`select-item ${o?"selected":""}`,role:"option","aria-selected":o,tabIndex:i,ref:d,children:ka(e,{option:t,checked:o,onClick:p,disabled:l})})},Ta=fp,bp=({options:e,onClick:t,skipIndex:o})=>{let{disabled:i,value:l,onChange:n,ItemRenderer:s}=bt(),d=(c,m)=>{i||n(m?[...l,c]:l.filter(p=>p.value!==c.value))};return wo(up,{children:e.map((c,m)=>{let p=m+o;return wo("li",{children:wo(Ta,{tabIndex:p,option:c,onSelectionChanged:f=>d(c,f),checked:!!l.find(f=>f.value===c.value),onClick:f=>t(f,p),itemRenderer:s,disabled:c.disabled||i})},(c==null?void 0:c.key)||m)})})},gp=bp,hp=()=>{let{t:e,onChange:t,options:o,setOptions:i,value:l,filterOptions:n,ItemRenderer:s,disabled:d,disableSearch:c,hasSelectAll:m,ClearIcon:p,debounceDuration:f,isCreatable:v,onCreateOption:k}=bt(),$=ko(),b=ko(),[q,h]=ft(""),[u,x]=ft(o),[y,S]=ft(""),[w,L]=ft(0),Y=ap(lp(I=>S(I),f),[]),B=ya(()=>{let I=0;return c||(I+=1),m&&(I+=1),I},[c,m]),H={label:e(q?"selectAllFiltered":"selectAll"),value:""},j=I=>{let M=u.filter(X=>!X.disabled).map(X=>X.value);if(I){let X=[...l.map(de=>de.value),...M];return(n?u:o).filter(de=>X.includes(de.value))}return l.filter(X=>!M.includes(X.value))},ee=I=>{let M=j(I);t(M)},D=I=>{Y(I.target.value),h(I.target.value),L(0)},K=()=>{var I;S(""),h(""),(I=b==null?void 0:b.current)==null||I.focus()},se=I=>L(I),re=I=>{switch(I.code){case Z.ARROW_UP:ie(-1);break;case Z.ARROW_DOWN:ie(1);break;default:return}I.stopPropagation(),I.preventDefault()};ut([Z.ARROW_DOWN,Z.ARROW_UP],re,{target:$});let ce=()=>{L(0)},te=async()=>{let I={label:q,value:q,__isNew__:!0};k&&(I=await k(q)),i([I,...o]),K(),t([...l,I])},qe=async()=>n?await n(o,y):np(o,y),ie=I=>{let M=w+I;M=Math.max(0,M),M=Math.min(M,o.length+Math.max(B-1,0)),L(M)};xa(()=>{var I,M;(M=(I=$==null?void 0:$.current)==null?void 0:I.querySelector(`[tabIndex='${w}']`))==null||M.focus()},[w]);let[Pe,Te]=ya(()=>{let I=u.filter(M=>!M.disabled);return[I.every(M=>l.findIndex(X=>X.value===M.value)!==-1),I.length!==0]},[u,l]);xa(()=>{qe().then(x)},[y,o]);let ke=ko();ut([Z.ENTER],te,{target:ke});let _e=v&&q&&!u.some(I=>(I==null?void 0:I.value)===q);return So("div",{className:"select-panel",role:"listbox",ref:$,children:[!c&&So("div",{className:"search",children:[Ie("input",{placeholder:e("search"),type:"text","aria-describedby":e("search"),onChange:D,onFocus:ce,value:q,ref:b,tabIndex:0}),Ie("button",{type:"button",className:"search-clear-button",hidden:!q,onClick:K,"aria-label":e("clearSearch"),children:p||Ie(Pa,{})})]}),So("ul",{className:"options",children:[m&&Te&&Ie(Ta,{tabIndex:B===1?0:1,checked:Pe,option:H,onSelectionChanged:ee,onClick:()=>se(1),itemRenderer:s,disabled:d}),u.length?Ie(gp,{skipIndex:B,options:u,onClick:(I,M)=>se(M)}):_e?Ie("li",{onClick:te,className:"select-item creatable",tabIndex:1,ref:ke,children:`${e("create")} "${q}"`}):Ie("li",{className:"no-options",children:e("noOptions")})]})]})},xp=hp,yp=({expanded:e})=>wa("svg",{width:"24",height:"24",fill:"none",stroke:"currentColor",strokeWidth:"2",className:"dropdown-heading-dropdown-arrow gray",children:wa("path",{d:e?"M18 15 12 9 6 15":"M6 9L12 15 18 9"})}),vp=()=>{let{t:e,value:t,options:o,valueRenderer:i}=bt(),l=t.length===0,n=t.length===o.length,s=i&&i(t,o);return l?Sa("span",{className:"gray",children:s||e("selectSomeItems")}):Sa("span",{children:s||(n?e("allItemsAreSelected"):(()=>t.map(d=>d.label).join(", "))())})},qp=({size:e=24})=>Co("span",{style:{width:e,marginRight:"0.2rem"},children:Co("svg",{width:e,height:e,className:"spinner",viewBox:"0 0 50 50",style:{display:"inline",verticalAlign:"middle"},children:Co("circle",{cx:"25",cy:"25",r:"20",fill:"none",className:"path"})})}),kp=()=>{let{t:e,onMenuToggle:t,ArrowRenderer:o,shouldToggleOnHover:i,isLoading:l,disabled:n,onChange:s,labelledBy:d,value:c,isOpen:m,defaultIsOpen:p,ClearSelectedIcon:f,closeOnChangedValue:v}=bt();ga(()=>{v&&q(!1)},[c]);let[k,$]=qo(!0),[b,q]=qo(p),[h,u]=qo(!1),x=o||yp,y=Kd();ep(()=>{t&&t(b)},[b]),ga(()=>{p===void 0&&typeof m=="boolean"&&($(!1),q(m))},[m]);let S=D=>{var K;["text","button"].includes(D.target.type)&&[Z.SPACE,Z.ENTER].includes(D.code)||(k&&(D.code===Z.ESCAPE?(q(!1),(K=y==null?void 0:y.current)==null||K.focus()):q(!0)),D.preventDefault())};ut([Z.ENTER,Z.ARROW_DOWN,Z.SPACE,Z.ESCAPE],S,{target:y});let w=D=>{k&&i&&q(D)},L=()=>!h&&u(!0),Y=D=>{!D.currentTarget.contains(D.relatedTarget)&&k&&(u(!1),q(!1))},B=()=>w(!0),H=()=>w(!1),j=()=>{k&&q(l||n?!1:!b)},ee=D=>{D.stopPropagation(),s([]),k&&q(!1)};return Ca("div",{tabIndex:0,className:"dropdown-container","aria-labelledby":d,"aria-expanded":b,"aria-readonly":!0,"aria-disabled":n,ref:y,onFocus:L,onBlur:Y,onMouseEnter:B,onMouseLeave:H,children:[Ca("div",{className:"dropdown-heading",onClick:j,children:[le("div",{className:"dropdown-heading-value",children:le(vp,{})}),l&&le(qp,{}),c.length>0&&f!==null&&le("button",{type:"button",className:"clear-selected-button",onClick:ee,disabled:n,"aria-label":e("clearSelected"),children:f||le(Pa,{})}),le(x,{expanded:b})]}),b&&le("div",{className:"dropdown-content",children:le("div",{className:"panel-content",children:le(xp,{})})})]})},wp=kp,Sp=e=>$o(jd,{props:e,children:$o("div",{className:`rmsc ${e.className||"multi-select"}`,children:$o(wp,{})})}),_a=Sp;import Cp,{css as $p}from"styled-components";var La=Cp.div`
	width: 100%;
	${()=>$p`
		.${a("multi-select")} {
			--rmsc-h: 31px;
			--rmsc-hover: var(${r.background800});
			--rmsc-selected: var(${r.background800});
			--rmsc-border: var(${r.text700});
			--rmsc-bg: var(${r.background700});
			--rmsc-gray: var(${r.text500});
			z-index: 20;

			span {
				color: var(${r.text500});
			}
		}

		.${a("multi-select-item")} {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			gap: 10px;

			/* Fixes unclicable areas */
			margin: -10px -10px;
			padding: 10px 10px ;
			
			> span {
				width: 12px;
				line-height: 1;
				margin-top: 1px;
			}
		}
	`}
`;import{Fragment as Tp,jsx as Xe,jsxs as _p}from"react/jsx-runtime";var Pp=({value:e,...t})=>Xe(La,{children:Xe(_a,{className:za(a("multi-select"),t.className),...t,value:e,ItemRenderer:({checked:o,option:i,onClick:l,disabled:n})=>_p("div",{className:za(a("multi-select-item"),{[a("multi-select-item--selected")]:o,[a("multi-select-item--disabled")]:n}),onClick:()=>l(i),children:[Xe("span",{children:o?Xe(Ip,{}):Xe(Tp,{})}),i.label]})})});import{FaChevronLeft as zp}from"@react-icons/all-files/fa/FaChevronLeft";import{FaChevronRight as Np}from"@react-icons/all-files/fa/FaChevronRight";import gt from"classnames";import{useMemo as Mp}from"react";import Lp from"styled-components";var Na=Lp.div`
	display: flex;
	list-style-type: none;
	justify-content: center;
	width: 100%;
	flex-wrap: wrap;
	margin: 0;
	padding: 0;

	.pagination-item {
		height: 32px;
		text-align: center;
		margin: auto 4px;
		color: #000;
		display: flex;
		box-sizing: border-box;
		align-items: center;
		letter-spacing: 0.01071em;
		border-radius: 16px;
		line-height: 1.43;
		font-size: 13px;
		min-width: 32px;
		justify-content: center;

		&.dots:hover {
			background-color: transparent;
			cursor: default;
		}

		&:hover {
			cursor: pointer;
		}

		.arrow {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			color: var(--arrow-color, #000);

			> svg {
				color: inherit;
				font-size: inherit;
			}
		}

		&.disabled {
			pointer-events: none;

			.arrow {
				color: var(--arrow-color, #000);
				opacity: 0.5;
			}

			&:hover {
				background-color: transparent;
				cursor: default;
			}
		}
	}
`;import{Fragment as Ep,jsx as ne,jsxs as Fp}from"react/jsx-runtime";var Rp=({onPageChange:e,totalCount:t=1,siblingCount:o=1,currentPage:i=1,pageSize:l=10,className:n="",styles:s={},showArrows:d=!0,showDots:c=!0,showNumbers:m=!0})=>{var q,h;let p="...",f=(u,x)=>{let y=x-u+1;return Array.from({length:y},(S,w)=>w+u)},v=Mp(()=>{let u=Math.ceil(t/l);if(o+5>=u)return f(1,u);let y=Math.max(i-o,1),S=Math.min(i+o,u),w=y>2,L=S<u-2,Y=1,B=u;if(!w&&L){let H=3+2*o;return[...f(1,H),p,u]}if(w&&!L){let H=3+2*o,j=f(u-H+1,u);return[Y,p,...j]}if(w&&L){let H=f(y,S);return[Y,p,...H,p,B]}},[t,l,o,i]),k=()=>{i<Math.ceil(t/l)&&e(i+1)},$=()=>{i>1&&e(i-1)},b=v==null?void 0:v[v.length-1];return Fp(Na,{className:gt("pagination-container",{[n]:n}),style:s.container,children:[d&&ne("span",{className:gt("pagination-item",{disabled:i===1}),onClick:$,style:{...s.arrow,"--arrow-color":(q=s.arrow)==null?void 0:q.color},children:ne("span",{className:"arrow left",children:ne(zp,{})})}),m&&(v==null?void 0:v.map((u,x)=>u===p?c?ne("li",{className:"pagination-item dots",style:{...s.button,cursor:"default",opacity:.9,pointerEvents:"none"},children:"\u2026"},`dots-${x}`):ne(Ep,{}):ne("li",{className:gt("pagination-item",{selected:u===i}),onClick:()=>e(Number(u)),style:{...s.button,...u===i?s.activeButton:{}},children:u},u))),d&&ne("li",{className:gt("pagination-item",{disabled:i===b}),onClick:k,style:{...s.arrow,"--arrow-color":(h=s.arrow)==null?void 0:h.color},children:ne("span",{className:"arrow right",children:ne(Np,{})})})]})};import{useEffect as Dp,useState as Ap}from"react";var Bp=({pageSize:e=10,items:t=[],dynamic:o})=>{let[i,l]=Ap({page:1}),{page:n}=i,s=(n-1)*e,d=o?t:t.slice(s,s+e);return Dp(()=>{l({...i,page:1})},[e]),{pageSize:e,page:i.page,setPage:c=>l({...i,page:c}),items:d}};import Fa from"classnames";import{useEffect as Hp,useState as Gp}from"react";import Ma from"styled-components";var Ra=Ma.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-template-rows: repeat(3, 1fr);
	min-width: 120px;
	max-width: 120px;
	height: 80px;
	background-color: var(${r.background900});
	border: 2px solid var(${r.background700});
	border-radius: 5px;
	gap: 3px;
`,Ea=Ma.button`
	border: none;
	background-color: var(${r.background600});
	transition: 0.3s;
	cursor: pointer;

	&:nth-of-type(1) {
		border-radius: 3px 0 0;
	}
	&:nth-of-type(3) {
		border-radius: 0 3px 0 0;
	}
	&:nth-of-type(7) {
		border-radius: 0 0 0 3px;
	}
	&:nth-of-type(9) {
		border-radius: 0 0 3px 0;
	}

	&:hover {
		opacity: 0.8;
	}

	&.disabled {
		background-color: var(${r.background800});
		cursor: not-allowed;
	}

	&.selected {
		background-color: var(${r.background300});
		background-image: repeating-linear-gradient(
			45deg,
			var(${r.primary500}),
			var(${r.primary500}) 3px,
			var(${r.background700}) 3px,
			var(${r.background700}) 6px
		);
	}
`;import{jsx as Da}from"react/jsx-runtime";var Wp=e=>{let[t,o]=Gp();Hp(()=>{e.value&&o(e.value)},[e.value]);let i=["top-left","top-center","top-right","middle-left","middle-center","middle-right","bottom-left","bottom-center","bottom-right"];return Da(Ra,{...e,className:Fa("position"),children:i.map(l=>Da(Ea,{title:l,className:Fa({selected:t===l,disabled:(e.disabledPositions||[]).includes(l)}),onClick:n=>{var d;if(n.preventDefault(),(e.disabledPositions||[]).includes(l))return;let s=l===t&&e.allowStatic?"static":l;(d=e==null?void 0:e.onChange)==null||d.call(e,s),o(s)}},l))})};import Io from"classnames";import{v4 as Vp}from"uuid";import Aa,{css as Op}from"styled-components";var Ba=Aa.input`
	${()=>Op`
		position: relative;
		width: 25px;
		height: 25px;
		border: 2px solid var(${r.background500});
		border-radius: 50em;
		appearance: none;
		outline: 0;
		margin: 0;
		padding: 0;
		cursor: pointer;
		transition: 0.2s;

		&:hover {
			border-color: var(${r.background300});
		}

		&::before {
			position: absolute;
			content: '';
			display: block;
			top: 50%;
			left: 50%;
			width: 85%;
			height: 85%;
			transform: translate(-50%, -50%);
			opacity: 0;
			border-radius: 50em;
			background-color: var(${r.primary500});
		}

		&:checked {
			color: #fff;
			border-color: var(${r.primary500});

			&::before {
				opacity: 1;
			}
		}

		&:disabled {
			color: var(${r.text900});
			border-color: var(${r.background800});

			&:checked::before {
				opacity: 1;
				background-color: var(${r.background700});
			}
		}
	`}
`,Ha=Aa.div`
	display: flex;
	flex-wrap: wrap;
	gap: 20px;

	.${a("radio-group-option")} {
		display: inline-flex;
		align-items: flex-start;
		justify-content: flex-start;
		gap: 5px;
		cursor: pointer;
	}
`;import{jsx as Po,jsxs as Yp}from"react/jsx-runtime";var Ga=({...e})=>{let t={width:e.size||25,height:e.size||25};return Po(Ba,{...e,type:"radio",className:Io(a("radio"),e.className),onChange:o=>{var i;return(i=e.onChange)==null?void 0:i.call(e,o.target.checked)},style:{...e.style,...t}})},Up=({options:e,onChange:t,...o})=>{let i=o.name||`radio-${Vp()}`;return Po(Ha,{className:Io(a("radio-group")),children:e.map(l=>{let n=o.value===l.value;return Yp("span",{className:Io(a("radio-group-option")),onClick:()=>t==null?void 0:t(n?void 0:l.value),children:[Po(Ga,{...o,name:i,onChange:s=>{s&&(t==null||t(l.value))},checked:n}),l.label||l.value]},`radio-${i}-${l.value}`)})})};import Jp from"lodash/isPlainObject";import{Suspense as e0,useEffect as Ya,useState as Xa}from"react";var To=["size","font-size","bold","italic","underline","strike","list","bullet","color","text-align","align","link"],_o={toolbar:{container:[[{size:[!1,"8px","10px","12px","16px","18px","24px","36px"]},{color:[]},"bold","italic","underline","strike",{list:"ordered"},{list:"bullet"},{align:["","left","center","right"]},"link"]]}},Lo=e=>{},zo=["size","font-size","bold","italic","underline","strike","list","bullet","color","text-align","align","link","image","width","height"],Ze={toolbar:{container:[[{size:[!1,"8px","10px","12px","14px","16px","18px","20px","24px","36px"]},{color:[]},"bold","italic","underline","strike",{list:"ordered"},{list:"bullet"},{align:["","left","center","right"]},"link","image"]],handlers:{image:function(){let e=this.quill.getSelection();Lo=o=>{this.quill.insertEmbed(e.index,"image",o)};let t=document.querySelector(`.${a("rich-editor-wrapper")} .${a("rich-editor-image-upload-button")}`);!t||t.click()}}},imageResize:{modules:["Resize","DisplaySize","Toolbar"]}};import{FaRegImages as Xp}from"@react-icons/all-files/fa/FaRegImages";import Zp from"react";import*as Wa from"react-dom/server";import Oa,{css as jp}from"styled-components";import{jsx as Qp}from"react/jsx-runtime";var Kp=Zp.lazy(()=>import("react-quill").then(async e=>{let t=await import("quill-image-resize-module-react");e.default.Quill.register("modules/imageResize",t.default);let o,i,l,n;return o=e.default.Quill.import("ui/icons"),o.image=Wa.renderToString(Qp(Xp,{className:"upload-image-icon"})),o.align.left=o.align[""],i=e.default.Quill.import("attributors/style/align"),i.whitelist=["","left","center","right"],e.default.Quill.register(i,!0),l=e.default.Quill.import("attributors/style/size"),l.whitelist=["8px","10px","12px","14px","16px","18px","20px","24px","36px"],e.default.Quill.register(l,!0),n=e.default.Quill.import("formats/link"),n.sanitize=function(s){if(typeof s!="string")return s;let d=s.slice(0,s.indexOf(":"));this.PROTOCOL_WHITELIST.indexOf(d)===-1&&(s=`https://${s}`);let c=document.createElement("a");return c.href=s,c.target="_blank",d=c.href.slice(0,c.href.indexOf(":")),this.PROTOCOL_WHITELIST.indexOf(d)>-1?s:this.SANITIZED_URL},e.default.Quill.register(n,!0),e})),Va=Oa.div`
	flex: 1;

	div.quill {
		box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08);
		border-radius: 0 5px 5px;

		.ql-container {
			height: 150px;
			/* overflow: auto; */
			color: var(${r.text500});
			background-color: transparent;
			border-radius: 0 0 5px 5px;
			border-color: var(${r.background300});

			*::selection {
				background: var(${r.text900});
			}
		}

		.ql-snow .ql-image {
			position: relative;
			color: var(${r.text500});
			font-size: 16px;

			&:hover {
				color: var(${r.text100});
			}
		}

		.ql-snow.ql-toolbar {
			border-color: var(${r.background300});
			border-radius: 5px 5px 0 0;

			.ql-expanded {
				.ql-picker-label,
				.ql-picker-options {
					background: var(${r.background800});
					border: 1px solid var(${r.background800});
					box-shadow: none;
				}
			}
		}

		.ql-snow .ql-tooltip {
			border-color: var(${r.background700});
			border-radius: 5px 5px 0 0;
			background: var(${r.background900});
			box-shadow: none;
			color: var(${r.text300});
			top: 50% !important;
			left: 50% !important;
			transform: translate(-50%, -50%);
		}

		.ql-snow .ql-tooltip.ql-editing input[type='text'] {
			max-width: 160px;
			border: 1px solid var(${r.background500});
			color: var(${r.text500});
			background: none;
			outline: none;

			&:focus {
				color: var(${r.text100});
				border-color: var(${r.primary500});
				box-shadow: none;
			}

			::placeholder {
				color: var(${r.text700});
			}
		}

		.ql-snow .ql-tooltip a {
			color: var(${r.text100});
		}

		.ql-snow .ql-stroke {
			stroke: var(${r.text500});
			opacity: 1;

			&:hover {
				stroke: var(${r.text100});
				opacity: 1;
			}
		}
		.ql-snow button:hover .ql-fill,
		.ql-snow button.ql-active .ql-fill {
			fill: var(${r.text100});
		}

		.ql-snow .ql-picker-label {
			&::before {
				color: var(${r.text500});
			}
		}

		.ql-snow .ql-picker-item {
			&::before {
				color: var(${r.text500});
			}
		}

		.ql-snow .ql-picker-item:hover,
		.ql-snow.ql-picker-item:hover,
		.ql-snow .ql-picker-item.ql-selected,
		.ql-snow.ql-picker-item.ql-selected {
			&::before {
				color: var(${r.text300});
			}
		}

		.ql-snow.ql-toolbar button {
			width: 24px;
			height: 24px;
		}

		.ql-snow.ql-toolbar button:hover,
		.ql-snow .ql-toolbar button:hover,
		.ql-snow.ql-toolbar button:focus,
		.ql-snow .ql-toolbar button:focus,
		.ql-snow.ql-toolbar button.ql-active,
		.ql-snow .ql-toolbar button.ql-active,
		.ql-snow.ql-toolbar .ql-picker-label:hover,
		.ql-snow .ql-toolbar .ql-picker-label:hover,
		.ql-snow.ql-toolbar .ql-picker-label.ql-active,
		.ql-snow .ql-toolbar .ql-picker-label.ql-active,
		.ql-snow.ql-toolbar .ql-picker-item:hover,
		.ql-snow .ql-toolbar .ql-picker-item:hover,
		.ql-snow.ql-toolbar .ql-picker-item.ql-selected,
		.ql-snow .ql-toolbar .ql-picker-item.ql-selected {
			color: var(${r.text100});
		}

		.ql-snow.ql-toolbar button:hover .ql-stroke,
		.ql-snow .ql-toolbar button:hover .ql-stroke,
		.ql-snow.ql-toolbar button:focus .ql-stroke,
		.ql-snow .ql-toolbar button:focus .ql-stroke,
		.ql-snow.ql-toolbar button.ql-active .ql-stroke,
		.ql-snow .ql-toolbar button.ql-active .ql-stroke,
		.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,
		.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,
		.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
		.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,
		.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,
		.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,
		.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
		.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
		.ql-snow.ql-toolbar button:hover .ql-stroke-miter,
		.ql-snow .ql-toolbar button:hover .ql-stroke-miter,
		.ql-snow.ql-toolbar button:focus .ql-stroke-miter,
		.ql-snow .ql-toolbar button:focus .ql-stroke-miter,
		.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,
		.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,
		.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
		.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
		.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
		.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
		.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
		.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
		.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,
		.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {
			stroke: var(${r.text100});
		}

		// .ql-snow .ql-picker.ql-align .ql-picker-label[data-value=''] svg,
		// .ql-snow .ql-picker.ql-align .ql-picker-item[data-value=''] svg {
		// opacity: 0;
		// }

		// .ql-snow .ql-picker.ql-align .ql-picker-label[data-value='']::before,
		// .ql-snow .ql-picker.ql-align .ql-picker-item[data-value='']::before {
		// 	content: '';
		// 	width: 100%;
		// 	height: 5px;
		// 	display: block;
		// }

		.ql-snow .ql-picker.ql-size {
			width: 80px;
		}

		.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='8px']::before,
		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='8px']::before {
			content: '8px';
			font-size: 16px !important;
		}

		.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='10px']::before,
		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='10px']::before {
			content: '10px';
			font-size: 16px !important;
		}

		.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='12px']::before,
		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='12px']::before {
			content: '12px';
			font-size: 16px !important;
		}

		.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='14px']::before,
		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='14px']::before {
			content: '14px';
			font-size: 16px !important;
		}

		.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='16px']::before,
		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='16px']::before {
			content: '16px';
			font-size: 16px !important;
		}

		.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='18px']::before,
		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='18px']::before {
			content: '18px';
			font-size: 16px !important;
		}

		.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='20px']::before,
		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='20px']::before {
			content: '20px';
			font-size: 16px !important;
		}

		.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='24px']::before,
		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='24px']::before {
			content: '24px';
			font-size: 16px !important;
		}

		.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='36px']::before,
		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='36px']::before {
			content: '36px';
			font-size: 16px !important;
		}
	}
`,Ua=Oa(Kp)`
	${()=>jp`
		// Quill CSS
		.ql-container {
			box-sizing: border-box;
			font-family: Helvetica, Arial, sans-serif;
			font-size: 13px;
			height: 100%;
			margin: 0px;
			position: relative;
		}
		.ql-container.ql-disabled .ql-tooltip {
			visibility: hidden;
		}
		.ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {
			pointer-events: none;
		}
		.ql-clipboard {
			left: -100000px;
			height: 1px;
			overflow-y: hidden;
			position: absolute;
			top: 50%;
		}
		.ql-clipboard p {
			margin: 0;
			padding: 0;
		}
		.ql-editor {
			box-sizing: border-box;
			line-height: 1.42;
			height: 100%;
			outline: none;
			overflow-y: auto;
			padding: 12px 15px;
			tab-size: 4;
			-moz-tab-size: 4;
			text-align: left;
			white-space: pre-wrap;
			word-wrap: break-word;
		}
		.ql-editor > * {
			cursor: text;
		}
		.ql-editor p,
		.ql-editor ol,
		.ql-editor ul,
		.ql-editor pre,
		.ql-editor blockquote,
		.ql-editor h1,
		.ql-editor h2,
		.ql-editor h3,
		.ql-editor h4,
		.ql-editor h5,
		.ql-editor h6 {
			margin: 0;
			padding: 0;
			counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8
				list-9;
		}
		.ql-editor ol,
		.ql-editor ul {
			padding-left: 1.5em;
		}
		.ql-editor ol > li,
		.ql-editor ul > li {
			padding-left: 0;
		}
		.ql-editor ol > li {
			list-style-type: decimal;
		}
		.ql-editor ul > li {
			/* list-style-type: none; */
			list-style-type: disc;
		}
		.ql-editor ul[data-checked='true'],
		.ql-editor ul[data-checked='false'] {
			pointer-events: none;
		}
		.ql-editor ul[data-checked='true'] > li *,
		.ql-editor ul[data-checked='false'] > li * {
			pointer-events: all;
		}
		.ql-editor ul[data-checked='true'] > li::before,
		.ql-editor ul[data-checked='false'] > li::before {
			color: #777;
			cursor: pointer;
			pointer-events: all;
		}
		.ql-editor li::before {
			display: inline-block;
			white-space: nowrap;
			width: 1.2em;
		}
		.ql-editor li:not(.ql-direction-rtl)::before {
			margin-left: -1.5em;
			margin-right: 0.3em;
			text-align: right;
		}
		.ql-editor li.ql-direction-rtl::before {
			margin-left: 0.3em;
			margin-right: -1.5em;
		}
		.ql-editor ol li:not(.ql-direction-rtl),
		.ql-editor ul li:not(.ql-direction-rtl) {
			/* padding-left: 1.5em; */
		}
		.ql-editor ol li.ql-direction-rtl,
		.ql-editor ul li.ql-direction-rtl {
			/* padding-right: 1.5em; */
		}
		.ql-editor ol li {
			counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8
				list-9;
			counter-increment: list-0;
		}
		.ql-editor ol li:before {
			content: counter(list-0, decimal) '. ';
		}
		.ql-editor ol li.ql-indent-1 {
			counter-increment: list-1;
		}
		.ql-editor ol li.ql-indent-1:before {
			content: counter(list-1, lower-alpha) '. ';
		}
		.ql-editor ol li.ql-indent-1 {
			counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
		}
		.ql-editor ol li.ql-indent-2 {
			counter-increment: list-2;
		}
		.ql-editor ol li.ql-indent-2:before {
			content: counter(list-2, lower-roman) '. ';
		}
		.ql-editor ol li.ql-indent-2 {
			counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
		}
		.ql-editor ol li.ql-indent-3 {
			counter-increment: list-3;
		}
		.ql-editor ol li.ql-indent-3:before {
			content: counter(list-3, decimal) '. ';
		}
		.ql-editor ol li.ql-indent-3 {
			counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
		}
		.ql-editor ol li.ql-indent-4 {
			counter-increment: list-4;
		}
		.ql-editor ol li.ql-indent-4:before {
			content: counter(list-4, lower-alpha) '. ';
		}
		.ql-editor ol li.ql-indent-4 {
			counter-reset: list-5 list-6 list-7 list-8 list-9;
		}
		.ql-editor ol li.ql-indent-5 {
			counter-increment: list-5;
		}
		.ql-editor ol li.ql-indent-5:before {
			content: counter(list-5, lower-roman) '. ';
		}
		.ql-editor ol li.ql-indent-5 {
			counter-reset: list-6 list-7 list-8 list-9;
		}
		.ql-editor ol li.ql-indent-6 {
			counter-increment: list-6;
		}
		.ql-editor ol li.ql-indent-6:before {
			content: counter(list-6, decimal) '. ';
		}
		.ql-editor ol li.ql-indent-6 {
			counter-reset: list-7 list-8 list-9;
		}
		.ql-editor ol li.ql-indent-7 {
			counter-increment: list-7;
		}
		.ql-editor ol li.ql-indent-7:before {
			content: counter(list-7, lower-alpha) '. ';
		}
		.ql-editor ol li.ql-indent-7 {
			counter-reset: list-8 list-9;
		}
		.ql-editor ol li.ql-indent-8 {
			counter-increment: list-8;
		}
		.ql-editor ol li.ql-indent-8:before {
			content: counter(list-8, lower-roman) '. ';
		}
		.ql-editor ol li.ql-indent-8 {
			counter-reset: list-9;
		}
		.ql-editor ol li.ql-indent-9 {
			counter-increment: list-9;
		}
		.ql-editor ol li.ql-indent-9:before {
			content: counter(list-9, decimal) '. ';
		}
		.ql-editor .ql-indent-1:not(.ql-direction-rtl) {
			padding-left: 3em;
		}
		.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
			padding-left: 4.5em;
		}
		.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
			padding-right: 3em;
		}
		.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
			padding-right: 4.5em;
		}
		.ql-editor .ql-indent-2:not(.ql-direction-rtl) {
			padding-left: 6em;
		}
		.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {
			padding-left: 7.5em;
		}
		.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
			padding-right: 6em;
		}
		.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
			padding-right: 7.5em;
		}
		.ql-editor .ql-indent-3:not(.ql-direction-rtl) {
			padding-left: 9em;
		}
		.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {
			padding-left: 10.5em;
		}
		.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
			padding-right: 9em;
		}
		.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
			padding-right: 10.5em;
		}
		.ql-editor .ql-indent-4:not(.ql-direction-rtl) {
			padding-left: 12em;
		}
		.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {
			padding-left: 13.5em;
		}
		.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
			padding-right: 12em;
		}
		.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
			padding-right: 13.5em;
		}
		.ql-editor .ql-indent-5:not(.ql-direction-rtl) {
			padding-left: 15em;
		}
		.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {
			padding-left: 16.5em;
		}
		.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
			padding-right: 15em;
		}
		.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
			padding-right: 16.5em;
		}
		.ql-editor .ql-indent-6:not(.ql-direction-rtl) {
			padding-left: 18em;
		}
		.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {
			padding-left: 19.5em;
		}
		.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
			padding-right: 18em;
		}
		.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
			padding-right: 19.5em;
		}
		.ql-editor .ql-indent-7:not(.ql-direction-rtl) {
			padding-left: 21em;
		}
		.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {
			padding-left: 22.5em;
		}
		.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
			padding-right: 21em;
		}
		.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
			padding-right: 22.5em;
		}
		.ql-editor .ql-indent-8:not(.ql-direction-rtl) {
			padding-left: 24em;
		}
		.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {
			padding-left: 25.5em;
		}
		.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
			padding-right: 24em;
		}
		.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
			padding-right: 25.5em;
		}
		.ql-editor .ql-indent-9:not(.ql-direction-rtl) {
			padding-left: 27em;
		}
		.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {
			padding-left: 28.5em;
		}
		.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
			padding-right: 27em;
		}
		.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
			padding-right: 28.5em;
		}
		.ql-editor .ql-video {
			display: block;
			max-width: 100%;
		}
		.ql-editor .ql-video.ql-align-center {
			margin: 0 auto;
		}
		.ql-editor .ql-video.ql-align-right {
			margin: 0 0 0 auto;
		}
		.ql-editor .ql-bg-black {
			background-color: #000;
		}
		.ql-editor .ql-bg-red {
			background-color: #e60000;
		}
		.ql-editor .ql-bg-orange {
			background-color: #f90;
		}
		.ql-editor .ql-bg-yellow {
			background-color: #ff0;
		}
		.ql-editor .ql-bg-green {
			background-color: #008a00;
		}
		.ql-editor .ql-bg-blue {
			background-color: #06c;
		}
		.ql-editor .ql-bg-purple {
			background-color: #93f;
		}
		.ql-editor .ql-color-white {
			color: #fff;
		}
		.ql-editor .ql-color-red {
			color: #e60000;
		}
		.ql-editor .ql-color-orange {
			color: #f90;
		}
		.ql-editor .ql-color-yellow {
			color: #ff0;
		}
		.ql-editor .ql-color-green {
			color: #008a00;
		}
		.ql-editor .ql-color-blue {
			color: #06c;
		}
		.ql-editor .ql-color-purple {
			color: #93f;
		}
		.ql-editor .ql-font-serif {
			font-family: Georgia, Times New Roman, serif;
		}
		.ql-editor .ql-font-monospace {
			font-family: Monaco, Courier New, monospace;
		}
		.ql-editor .ql-size-small {
			font-size: 0.75em;
		}
		.ql-editor .ql-size-large {
			font-size: 1.5em;
		}
		.ql-editor .ql-size-huge {
			font-size: 2.5em;
		}
		.ql-editor .ql-direction-rtl {
			direction: rtl;
			text-align: inherit;
		}
		.ql-editor .ql-align-center {
			text-align: center;
		}
		.ql-editor .ql-align-justify {
			text-align: justify;
		}
		.ql-editor .ql-align-right {
			text-align: right;
		}
		.ql-editor.ql-blank::before {
			color: rgba(0, 0, 0, 0.6);
			content: attr(data-placeholder);
			font-style: italic;
			left: 15px;
			pointer-events: none;
			position: absolute;
			right: 15px;
		}
		.ql-snow.ql-toolbar:after,
		.ql-snow .ql-toolbar:after {
			clear: both;
			content: '';
			display: table;
		}
		.ql-snow.ql-toolbar button,
		.ql-snow .ql-toolbar button {
			background: none;
			border: none;
			cursor: pointer;
			display: inline-block;
			float: left;
			height: 24px;
			padding: 3px 5px;
			width: 28px;
		}
		.ql-snow.ql-toolbar button svg,
		.ql-snow .ql-toolbar button svg {
			float: left;
			height: 100%;
		}
		.ql-snow.ql-toolbar button:active:hover,
		.ql-snow .ql-toolbar button:active:hover {
			outline: none;
		}
		.ql-snow.ql-toolbar input.ql-image[type='file'],
		.ql-snow .ql-toolbar input.ql-image[type='file'] {
			display: none;
		}
		.ql-snow.ql-toolbar button:hover,
		.ql-snow .ql-toolbar button:hover,
		.ql-snow.ql-toolbar button:focus,
		.ql-snow .ql-toolbar button:focus,
		.ql-snow.ql-toolbar button.ql-active,
		.ql-snow .ql-toolbar button.ql-active,
		.ql-snow.ql-toolbar .ql-picker-label:hover,
		.ql-snow .ql-toolbar .ql-picker-label:hover,
		.ql-snow.ql-toolbar .ql-picker-label.ql-active,
		.ql-snow .ql-toolbar .ql-picker-label.ql-active,
		.ql-snow.ql-toolbar .ql-picker-item:hover,
		.ql-snow .ql-toolbar .ql-picker-item:hover,
		.ql-snow.ql-toolbar .ql-picker-item.ql-selected,
		.ql-snow .ql-toolbar .ql-picker-item.ql-selected {
			color: #06c;
		}
		.ql-snow.ql-toolbar button:hover .ql-fill,
		.ql-snow .ql-toolbar button:hover .ql-fill,
		.ql-snow.ql-toolbar button:focus .ql-fill,
		.ql-snow .ql-toolbar button:focus .ql-fill,
		.ql-snow.ql-toolbar button.ql-active .ql-fill,
		.ql-snow .ql-toolbar button.ql-active .ql-fill,
		.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,
		.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,
		.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,
		.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,
		.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,
		.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,
		.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,
		.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,
		.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,
		.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,
		.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,
		.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,
		.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,
		.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,
		.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
		.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
		.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
		.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
		.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
		.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
		.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,
		.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {
			fill: #06c;
		}
		.ql-snow.ql-toolbar button:hover .ql-stroke,
		.ql-snow .ql-toolbar button:hover .ql-stroke,
		.ql-snow.ql-toolbar button:focus .ql-stroke,
		.ql-snow .ql-toolbar button:focus .ql-stroke,
		.ql-snow.ql-toolbar button.ql-active .ql-stroke,
		.ql-snow .ql-toolbar button.ql-active .ql-stroke,
		.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,
		.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,
		.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
		.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,
		.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,
		.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,
		.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
		.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
		.ql-snow.ql-toolbar button:hover .ql-stroke-miter,
		.ql-snow .ql-toolbar button:hover .ql-stroke-miter,
		.ql-snow.ql-toolbar button:focus .ql-stroke-miter,
		.ql-snow .ql-toolbar button:focus .ql-stroke-miter,
		.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,
		.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,
		.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
		.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
		.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
		.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
		.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
		.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
		.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,
		.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {
			stroke: #06c;
		}
		@media (pointer: coarse) {
			.ql-snow.ql-toolbar button:hover:not(.ql-active),
			.ql-snow .ql-toolbar button:hover:not(.ql-active) {
				color: #444;
			}
			.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,
			.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,
			.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,
			.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {
				fill: #444;
			}
			.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,
			.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,
			.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,
			.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {
				stroke: #444;
			}
		}
		.ql-snow {
			box-sizing: border-box;
		}
		.ql-snow * {
			box-sizing: border-box;
		}
		.ql-snow .ql-hidden {
			display: none;
		}
		.ql-snow .ql-out-bottom,
		.ql-snow .ql-out-top {
			visibility: hidden;
		}
		.ql-snow .ql-tooltip {
			position: absolute;
			transform: translateY(10px);
		}
		.ql-snow .ql-tooltip a {
			cursor: pointer;
			text-decoration: none;
		}
		.ql-snow .ql-tooltip.ql-flip {
			transform: translateY(-10px);
		}
		.ql-snow .ql-formats {
			display: inline-block;
			vertical-align: middle;
		}
		.ql-snow .ql-formats:after {
			clear: both;
			content: '';
			display: table;
		}
		.ql-snow .ql-stroke {
			fill: none;
			stroke: #444;
			stroke-linecap: round;
			stroke-linejoin: round;
			stroke-width: 2;
		}
		.ql-snow .ql-stroke-miter {
			fill: none;
			stroke: #444;
			stroke-miterlimit: 10;
			stroke-width: 2;
		}
		.ql-snow .ql-fill,
		.ql-snow .ql-stroke.ql-fill {
			fill: var(${r.text500});
		}
		.ql-snow .ql-empty {
			fill: none;
		}
		.ql-snow .ql-even {
			fill-rule: evenodd;
		}
		.ql-snow .ql-thin,
		.ql-snow .ql-stroke.ql-thin {
			stroke-width: 1;
		}
		.ql-snow .ql-transparent {
			opacity: 0.4;
		}
		.ql-snow .ql-direction svg:last-child {
			display: none;
		}
		.ql-snow .ql-direction.ql-active svg:last-child {
			display: inline;
		}
		.ql-snow .ql-direction.ql-active svg:first-child {
			display: none;
		}
		.ql-snow .ql-editor h1 {
			font-size: 2em;
		}
		.ql-snow .ql-editor h2 {
			font-size: 1.5em;
		}
		.ql-snow .ql-editor h3 {
			font-size: 1.17em;
		}
		.ql-snow .ql-editor h4 {
			font-size: 1em;
		}
		.ql-snow .ql-editor h5 {
			font-size: 0.83em;
		}
		.ql-snow .ql-editor h6 {
			font-size: 0.67em;
		}
		.ql-snow .ql-editor a {
			text-decoration: underline;
		}
		.ql-snow .ql-editor blockquote {
			border-left: 4px solid #ccc;
			margin-bottom: 5px;
			margin-top: 5px;
			padding-left: 16px;
		}
		.ql-snow .ql-editor code,
		.ql-snow .ql-editor pre {
			background-color: #f0f0f0;
			border-radius: 3px;
		}
		.ql-snow .ql-editor pre {
			white-space: pre-wrap;
			margin-bottom: 5px;
			margin-top: 5px;
			padding: 5px 10px;
		}
		.ql-snow .ql-editor code {
			font-size: 85%;
			padding: 2px 4px;
		}
		.ql-snow .ql-editor pre.ql-syntax {
			background-color: #23241f;
			color: #f8f8f2;
			overflow: visible;
		}
		.ql-snow .ql-editor img {
			max-width: 100%;
		}
		.ql-snow .ql-picker {
			color: #444;
			display: inline-block;
			float: left;
			font-size: 14px;
			font-weight: 500;
			height: 24px;
			position: relative;
			vertical-align: middle;
		}
		.ql-snow .ql-picker-label {
			cursor: pointer;
			display: inline-block;
			height: 100%;
			padding-left: 8px;
			padding-right: 2px;
			position: relative;
			width: 100%;
		}
		.ql-snow .ql-picker-label::before {
			display: inline-block;
			line-height: 22px;
		}
		.ql-snow .ql-picker-options {
			background-color: #fff;
			display: none;
			min-width: 100%;
			padding: 4px 8px;
			position: absolute;
			white-space: nowrap;
		}
		.ql-snow .ql-picker-options .ql-picker-item {
			cursor: pointer;
			display: block;
			padding-bottom: 5px;
			padding-top: 5px;
		}
		.ql-snow .ql-picker.ql-expanded .ql-picker-label {
			color: #ccc;
			z-index: 2;
		}
		.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {
			fill: #ccc;
		}
		.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {
			stroke: #ccc;
		}
		.ql-snow .ql-picker.ql-expanded .ql-picker-options {
			display: block;
			margin-top: -1px;
			top: 100%;
			z-index: 1;
		}
		.ql-snow .ql-color-picker,
		.ql-snow .ql-icon-picker {
			width: 28px;
		}
		.ql-snow .ql-color-picker .ql-picker-label,
		.ql-snow .ql-icon-picker .ql-picker-label {
			padding: 2px 4px;
		}
		.ql-snow .ql-color-picker .ql-picker-label svg,
		.ql-snow .ql-icon-picker .ql-picker-label svg {
			right: 4px;
		}
		.ql-snow .ql-icon-picker .ql-picker-options {
			padding: 4px 0px;
		}
		.ql-snow .ql-icon-picker .ql-picker-item {
			height: 24px;
			width: 24px;
			padding: 2px 4px;
		}
		.ql-snow .ql-color-picker .ql-picker-options {
			padding: 3px 5px;
			width: 152px;
		}
		.ql-snow .ql-color-picker .ql-picker-item {
			border: 1px solid transparent;
			float: left;
			height: 16px;
			margin: 2px;
			padding: 0px;
			width: 16px;
		}
		.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
			position: absolute;
			margin-top: -9px;
			right: 0;
			top: 50%;
			width: 18px;
		}
		.ql-snow
			.ql-picker.ql-header
			.ql-picker-label[data-label]:not([data-label=''])::before,
		.ql-snow
			.ql-picker.ql-font
			.ql-picker-label[data-label]:not([data-label=''])::before,
		.ql-snow
			.ql-picker.ql-size
			.ql-picker-label[data-label]:not([data-label=''])::before,
		.ql-snow
			.ql-picker.ql-header
			.ql-picker-item[data-label]:not([data-label=''])::before,
		.ql-snow
			.ql-picker.ql-font
			.ql-picker-item[data-label]:not([data-label=''])::before,
		.ql-snow
			.ql-picker.ql-size
			.ql-picker-item[data-label]:not([data-label=''])::before {
			content: attr(data-label);
		}
		.ql-snow .ql-picker.ql-header {
			width: 98px;
		}
		.ql-snow .ql-picker.ql-header .ql-picker-label::before,
		.ql-snow .ql-picker.ql-header .ql-picker-item::before {
			content: 'Normal';
		}
		.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='1']::before,
		.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before {
			content: 'Heading 1';
		}
		.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='2']::before,
		.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before {
			content: 'Heading 2';
		}
		.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='3']::before,
		.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3']::before {
			content: 'Heading 3';
		}
		.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='4']::before,
		.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='4']::before {
			content: 'Heading 4';
		}
		.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='5']::before,
		.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='5']::before {
			content: 'Heading 5';
		}
		.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='6']::before,
		.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='6']::before {
			content: 'Heading 6';
		}
		.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before {
			font-size: 2em;
		}
		.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before {
			font-size: 1.5em;
		}
		.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3']::before {
			font-size: 1.17em;
		}
		.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='4']::before {
			font-size: 1em;
		}
		.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='5']::before {
			font-size: 0.83em;
		}
		.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='6']::before {
			font-size: 0.67em;
		}
		.ql-snow .ql-picker.ql-font {
			width: 108px;
		}
		.ql-snow .ql-picker.ql-font .ql-picker-label::before,
		.ql-snow .ql-picker.ql-font .ql-picker-item::before {
			content: 'Sans Serif';
		}
		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='serif']::before,
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {
			content: 'Serif';
		}
		.ql-snow
			.ql-picker.ql-font
			.ql-picker-label[data-value='monospace']::before,
		.ql-snow
			.ql-picker.ql-font
			.ql-picker-item[data-value='monospace']::before {
			content: 'Monospace';
		}
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {
			font-family: Georgia, Times New Roman, serif;
		}
		.ql-snow
			.ql-picker.ql-font
			.ql-picker-item[data-value='monospace']::before {
			font-family: Monaco, Courier New, monospace;
		}
		.ql-snow .ql-picker.ql-size {
			width: 98px;
		}
		.ql-snow .ql-picker.ql-size .ql-picker-label::before,
		.ql-snow .ql-picker.ql-size .ql-picker-item::before {
			content: 'Normal';
		}
		.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='small']::before,
		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='small']::before {
			content: 'Small';
		}
		.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='large']::before,
		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='large']::before {
			content: 'Large';
		}
		.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='huge']::before,
		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {
			content: 'Huge';
		}
		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='small']::before {
			font-size: 10px;
		}
		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='large']::before {
			font-size: 18px;
		}
		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {
			font-size: 32px;
		}
		.ql-snow .ql-color-picker.ql-background .ql-picker-item {
			background-color: #fff;
		}
		.ql-snow .ql-color-picker.ql-color .ql-picker-item {
			background-color: #000;
		}
		.ql-toolbar.ql-snow {
			border: 1px solid #ccc;
			box-sizing: border-box;
			font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
			padding: 8px;
		}
		.ql-toolbar.ql-snow .ql-formats {
			margin-right: 15px;
		}
		.ql-toolbar.ql-snow .ql-picker-label {
			border: 1px solid transparent;
		}
		.ql-toolbar.ql-snow .ql-picker-options {
			border: 1px solid transparent;
			box-shadow: rgba(0, 0, 0, 0.2) 0 2px 8px;
		}
		.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
			border-color: #ccc;
		}
		.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
			border-color: #ccc;
		}
		.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,
		.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {
			border-color: #000;
		}
		.ql-toolbar.ql-snow + .ql-container.ql-snow {
			border-top: 0px;
		}
		.ql-snow .ql-tooltip {
			background-color: #fff;
			border: 1px solid #ccc;
			box-shadow: 0px 0px 5px #ddd;
			color: #444;
			padding: 5px 12px;
			white-space: nowrap;
		}
		.ql-snow .ql-tooltip::before {
			content: 'Visit URL:';
			line-height: 26px;
			margin-right: 8px;
		}
		.ql-snow .ql-tooltip input[type='text'] {
			display: none;
			border: 1px solid #ccc;
			font-size: 13px;
			height: 26px;
			margin: 0px;
			padding: 3px 5px;
			width: 170px;
		}
		.ql-snow .ql-tooltip a.ql-preview {
			display: inline-block;
			max-width: 200px;
			overflow-x: hidden;
			text-overflow: ellipsis;
			vertical-align: top;
		}
		.ql-snow .ql-tooltip a.ql-action::after {
			border-right: 1px solid #ccc;
			content: 'Edit';
			margin-left: 16px;
			padding-right: 8px;
		}
		.ql-snow .ql-tooltip a.ql-remove::before {
			content: 'Remove';
			margin-left: 8px;
		}
		.ql-snow .ql-tooltip a {
			line-height: 26px;
		}
		.ql-snow .ql-tooltip.ql-editing a.ql-preview,
		.ql-snow .ql-tooltip.ql-editing a.ql-remove {
			display: none;
		}
		.ql-snow .ql-tooltip.ql-editing input[type='text'] {
			display: inline-block;
		}
		.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
			border-right: 0px;
			content: 'Save';
			padding-right: 0px;
		}
		.ql-snow .ql-tooltip[data-mode='link']::before {
			content: 'Enter link:';
		}
		.ql-snow .ql-tooltip[data-mode='formula']::before {
			content: 'Enter formula:';
		}
		.ql-snow .ql-tooltip[data-mode='video']::before {
			content: 'Enter video:';
		}
		.ql-snow a {
			color: #06c;
		}
		.ql-container.ql-snow {
			border: 1px solid #ccc;
		}
	`}
`;import{Fragment as o0,jsx as ht,jsxs as r0}from"react/jsx-runtime";var t0=e=>{let{onChange:t,onKeyDown:o,html:i,formats:l,modules:n,imageUpload:s,imageUploadTrigger:d}=e,[c,m]=Xa(i||""),[p,f]=Xa(!0);function v(h){p||m(h)}Ya(()=>{t(c)},[c]),Ya(()=>{!p||typeof window<"u"&&window.setTimeout(()=>{t(c),f(!1)},10)},[]);let k=()=>d?d(a("rich-editor-image-upload-button"),u=>{Lo(u)}):ht(o0,{}),$=s?Ze:_o,b=s?zo:To,q=n?{...n,toolbar:Jp(n.toolbar)?{...n.toolbar,handlers:{...n.toolbar.handlers,...s?{image:Ze.toolbar.handlers.image}:{}},...s?{imageResize:Ze.imageResize}:{}}:{...$.toolbar,container:n.toolbar}}:$;return r0(Va,{className:a("rich-editor-wrapper"),children:[ht(e0,{fallback:ht(J,{size:14}),children:ht(Ua,{defaultValue:c,onKeyDown:o?h=>o(h):()=>{},onChange:v,theme:"snow",formats:l||b,modules:q,scrollingContainer:"body"})}),s&&k()]})};import{useInView as i0}from"react-intersection-observer";import Ja from"classnames";import Za,{css as ja}from"styled-components";import No from"polished/lib/color/transparentize";var Ka=Za.span`
  ${()=>ja`
    position: relative;
    width: 1px;
    height: 1px;
    flex: none;
    flex-basis: 1px;
    opacity: 0;
  `}
`,Qa=Za.div`
  ${({size:e=12,color:t=""})=>{let o=[No(.75,t||"#000"),No(.92,t||"#000"),No(1,t||"#000")];return ja`
      position: sticky;
      z-index: 10;
      opacity: 1;
      transition: 0.1s;

      &.in-view {
        opacity: 0;
      }

      &.bottom,
      &.top {
        width: 100%;
        height: ${e}px;
        flex: none;
      }

      &.bottom {
        bottom: 0;
        background: linear-gradient(
          0deg,
          ${o[0]},
          ${o[1]} 52.5%,
          ${o[2]}
        );
      }

      &.top {
        top: 0;
        background: linear-gradient(
          180deg,
          ${o[0]},
          ${o[1]} 52.5%,
          ${o[2]}
        );

        &.in-view {
          height: 0px;
        }
      }

      &.right,
      &.left {
        width: ${e}px;
        height: 100%;
        flex: none;

        &.in-view {
          width: 0px;
        }
      }

      &.right {
        right: 0;
        background: linear-gradient(
          270deg,
          ${o[0]},
          ${o[1]} 52.5%,
          ${o[2]}
        );
      }

      &.left {
        left: 0;
        background: linear-gradient(
          90deg,
          ${o[0]},
          ${o[1]} 52.5%,
          ${o[2]}
        );
      }
    `}}
`;import{Fragment as l0,jsx as el,jsxs as n0}from"react/jsx-runtime";var a0=e=>{let{position:t,shadowStyle:o}=e,[i,l]=i0({threshold:1,rootMargin:`${e.size||12}px`});return n0(l0,{children:[el(Ka,{...e,className:Ja(a("shadow-hint-ref"),t,{active:!l}),ref:i}),el(Qa,{...e,className:Ja(a("shadow-hint"),t,{"in-view":l}),style:o})]})};import xt from"classnames";import s0,{css as c0}from"styled-components";var tl=s0.aside`
	${e=>c0`
		overflow: hidden;
		height: 100vh;
		width: ${e.width||256}px;
		color: var(${r.text500});
		background: var(${r.background900});
		position: relative;
		position: sticky;
		top: 0;
		display: grid;
		grid-template-columns: 1fr;
		grid-template-rows: auto 1fr auto;
		grid-template-areas:
			'header'
			'body'
			'footer';

		.${a("sidebar-header")} {
			grid-area: header;
			max-width: 100%;
		}

		.${a("sidebar-body")} {
			grid-area: body;
			overflow: auto;
		}

		.${a("sidebar-footer")} {
			grid-area: footer;
			max-width: 100%;
			position: relative;
		}
	`}
`;import{jsx as yt}from"react/jsx-runtime";var d0=({...e})=>yt(tl,{...e,className:xt(a("sidebar"),e.className),children:e.children}),p0=({...e})=>yt("div",{...e,className:xt(a("sidebar-body"),e.className),children:e.children}),m0=({...e})=>yt("div",{...e,className:xt(a("sidebar-header"),e.className),children:e.children}),f0=({...e})=>yt("div",{...e,className:xt(a("sidebar-footer"),e.className),children:e.children});import u0,{css as b0}from"styled-components";import g0 from"polished/lib/color/lighten";var ol=u0.div`
  ${e=>{let t=`var(${r.text100})`;return e.highlightColor?t=e.highlightColor:e.baseColor&&(t=g0(.15,e.baseColor)),b0`
      --base-color: ${e.baseColor||`var(${r.text500})`};
      --highlight-color: ${t};
      --animation-duration: ${e.animationDuration||"1.5s"};
      --animation-direction: ${e.animationDirection||"normal"};
      --pseudo-element-display: ${e.pseudoElementDisplay||"block"};

      background-color: var(--base-color);
      width: 100%;
      border-radius: 0.25rem;
      display: inline-flex;
      line-height: 1;
      position: relative;
      overflow: hidden;
      z-index: 1;

      &:after {
        content: ' ';
        display: var(--pseudo-element-display);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 100%;
        background-repeat: no-repeat;
        background-image: linear-gradient(
          90deg,
          var(--base-color),
          var(--highlight-color),
          var(--base-color)
        );
        transform: translate(-100%);
        animation-name: react-loading-skeleton;
        animation-direction: var(--animation-direction);
        animation-duration: var(--animation-duration);
        animation-timing-function: ease-in-out;
        animation-iteration-count: infinite;
      }

      @keyframes react-loading-skeleton {
        to {
          transform: translate(100%);
        }
      }
    `}}`;import{jsx as x0}from"react/jsx-runtime";var h0=e=>x0(ol,{...e,className:`${a("skeleton")} ${e.className||""}`});import il from"classnames";import{v4 as q0}from"uuid";import y0,{css as v0}from"styled-components";var rl=y0.div`
	${({height:e=25,width:t=void 0})=>v0`
		&.toggle {
			input[type='checkbox'] {
				display: none;

				&:checked {
					+ label {
						background: var(${r.primary500});

						&::after {
							left: 50%;
							margin-left: -1px;
						}
					}
				}

				&:disabled {
					+ label {
						opacity: 0.4;
					}
				}
			}

			label {
				outline: 0;
				display: block;
				width: ${t||e*1.8}px;
				height: ${e}px;
				position: relative;
				cursor: pointer;
				-webkit-user-select: none;
				-moz-user-select: none;
				-ms-user-select: none;
				user-select: none;
				background: var(${r.background300});
				border-radius: 50em;
				transition: 0.2s;

				/* &:hover {
        background: rgba(255, 255, 255, 0.15);
      } */

				&::after {
					position: relative;
					display: block;
					content: '';
					width: ${e-4}px;
					height: ${e-4}px;
					left: 3px;
					top: 2px;
					border-radius: 50em;
					transition: 0.2s;
					background: var(${r.white});
				}
			}
		}

		&.true-false {
			input[type='checkbox'] {
				display: none;
			}

			.${a("switch-wrapper")} {
				display: inline-flex;
				align-items: center;
				justify-content: center;
				position: relative;
				cursor: pointer;
				-webkit-user-select: none;
				-moz-user-select: none;
				-ms-user-select: none;
				user-select: none;
				background: var(${r.background600});
				border-radius: 50em;
				transition: 0.2s;
				font-size: 0.9rem;
			}

			label {
				color: var(${r.text300});
				border-radius: 50em;
				padding: 5px 10px;
				cursor: pointer;
				transition: 0.2s;

				&.active {
					background: var(${r.primary500});
					color: var(${r.white});
				}
			}
		}
	`}
`;import{Fragment as w0,jsx as Me,jsxs as al}from"react/jsx-runtime";var k0=({isChecked:e,name:t,disabled:o,width:i,height:l,onChange:n,variant:s="toggle",checkedLabel:d="True",uncheckedLabel:c="False",style:m})=>{let p=t||`toggle_${q0()}`;function f(k){let $=k.target;n(k,$.checked)}function v(){return s==="true-false"?al("div",{className:a("switch-wrapper"),children:[Me("label",{htmlFor:p,className:il({active:!e}),children:c}),Me("input",{type:"checkbox",id:p,onChange:f,checked:e,disabled:!!o}),Me("label",{htmlFor:p,className:il({active:e}),children:d})]}):al(w0,{children:[Me("input",{type:"checkbox",id:p,onChange:f,checked:e,disabled:!!o}),Me("label",{htmlFor:p,title:e?"Disable":"Enable"})]})}return Me(rl,{height:l,width:i,className:s,style:m,children:v()})};import nl from"classnames";import{useEffect as sl,useState as $0}from"react";import S0,{css as C0}from"styled-components";var ll=S0.div`
	${()=>C0`
		display: flex;
		flex-direction: column;

		&.classic {
			.${a("tabs")} {
				display: flex;
				justify-content: flex-start;
				align-items: flex-end;
				gap: 10px;
				border-bottom: 1px solid var(${r.background300});
				margin: 10px 10px 0;
			}

			.${a("tab-trigger")} {
				cursor: pointer;
				background: none;
				border: none;
				font-family: var(${r.primaryFont});
				color: var(${r.text500});
				font-weight: 700;
				font-size: 1rem;
				transition: 0.2s;
				padding: 7px 15px;
				position: relative;

				&::after {
					content: '';
					position: absolute;
					bottom: -2px;
					left: 0;
					width: 100%;
					height: 3px;
					background: var(${r.primary500});
					z-index: 1;
					opacity: 0;
					transition: inherit;
					border-radius: 3px;
				}

				&:hover {
					color: var(${r.text100});
				}

				&.active {
					color: var(${r.primary500});

					&::after {
						opacity: 1;
					}
				}
			}
		}

		&.capsule {
			background-color: var(${r.background700});
			border-radius: 50em;
			max-width: fit-content;

			.${a("tabs")} {
				display: flex;
				justify-content: flex-start;
				align-items: flex-end;
				gap: 0;
				padding: 3px;
			}

			.${a("tab-trigger")} {
				cursor: pointer;
				background: none;
				border: none;
				font-family: var(${r.primaryFont});
				color: var(${r.text500});
				font-weight: 500;
				font-size: 1rem;
				transition: 0.2s;
				padding: 7px 15px;
				position: relative;
				border-radius: 50em;

				&:hover {
					color: var(${r.text100});
				}

				&.active {
					color: var(${r.white});
					background-color: var(${r.primary500});

					&::after {
						opacity: 1;
					}
				}
			}
		}
	`}
`;import{Fragment as P0,jsx as vt,jsxs as T0}from"react/jsx-runtime";var I0=({items:e,onChange:t,activeTabId:o,variant:i="classic",watchActiveTabId:l=!1,...n})=>{var c;let[s,d]=$0(o||e[0].id);return sl(()=>{!s||t==null||t(s)},[s]),sl(()=>{o&&l&&d(o)},[o]),T0(ll,{...n,className:nl(i),children:[vt("header",{className:a("tabs"),children:e.map((m,p)=>vt("button",{title:m.name,className:nl(a("tab-trigger"),{active:s===m.id}),onClick:()=>d(m.id),children:m.name||m.id},`tab_${p}`))}),vt("div",{className:a("active-tab"),children:((c=e.find(m=>m.id===s))==null?void 0:c.component)||vt(P0,{})})]})};import Mo from"classnames";import{useEffect as z0,useState as dl}from"react";import _0,{css as L0}from"styled-components";var cl=_0.div`
	${()=>L0`
		width: 100%;

		input {
			width: 100%;
		}

		.nindo-select .add-tag-button {
			border: none;
			margin: auto;
		}

		.${a("multi-select-tags")} {
			display: flex;
			flex-wrap: wrap;
			gap: 5px;
			margin-top: 10px;

			.${a("tag")} {
				color: var(${r.text300});
				border: 1px solid var(${r.text500});
				color: var(${r.text500});
				padding: 3px 25px 2px 10px;
				border-radius: 20px;
				font-size: 0.9rem;
				position: relative;
				transition: 0.2s;
				cursor: pointer;

				&:hover {
					border: 1px solid var(${r.text300});
					color: var(${r.text300});

					&::after {
						color: var(${r.text300});
					}
				}

				&::after {
					content: 'X';
					cursor: pointer;
					color: var(${r.text500});
					position: absolute;
					top: 50%;
					right: 10px;
					font-size: 0.85rem;
					transform: translateY(-45%);
					transition: 0.2s;
				}
			}
		}
	`}
`;import{FaPlus as pl}from"@react-icons/all-files/fa/FaPlus";import{Fragment as M0,jsx as ve,jsxs as Ro}from"react/jsx-runtime";var N0=({options:e=[],value:t=[],enableAddButton:o=!1,noOptionsMessage:i,onChange:l,...n})=>{let[s,d]=dl(""),[c,m]=dl([]),p=e.map(b=>b.label),f=b=>{!s||c.find(q=>q===s)||b.key==="Enter"&&(m([...c,s]),l==null||l([...c,s]),d(""))},v=b=>{if(!!b){if(c.find(q=>q===b))return d(p.includes(b)?b:"");d(""),m([...c,b]),l==null||l([...c,b])}},k=b=>{let q=c.findIndex(u=>u===b);if(q===-1)return;let h=[...c];h.splice(q,1),l==null||l(h),m(h)},$=()=>n!=null&&n.loadOptions?ve(M0,{children:ve(co,{onKeyDown:b=>f(b),value:s,onChange:b=>v(b),noOptionsMessage:b=>o?Ro(A,{className:"add-tag-button",variant:"add",onClick:q=>{q.target.focus(),v(b.inputValue)},children:[ve(pl,{}),`Add ${b.inputValue}`]}):i||"No Options",placeholder:n.placeholder||"Select...",cacheOptions:!0,defaultOptions:!0,loadOptions:n.loadOptions})}):e.length?ve(Ue,{onKeyDown:b=>f(b),value:s,onChange:b=>v(b),noOptionsMessage:b=>o?Ro(A,{className:"add-tag-button",variant:"add",onClick:q=>{q.target.focus(),v(b.inputValue)},children:[ve(pl,{}),`Add ${b.inputValue}`]}):i||"No Options",options:e.length?[{value:"",label:"-- Select --"},...e]:[],placeholder:n.placeholder||"Select..."}):ve(V,{onKeyDown:f,type:"text",value:s,onChange:b=>d(b.target.value),placeholder:n.placeholder||"Enter value and press enter."});return z0(()=>{t&&t.length>0&&m(t)},[t]),Ro(cl,{...n,onChange:()=>{},className:Mo(a("checkbox"),n.className),children:[$(),ve("div",{className:Mo(a("multi-select-tags")),children:c.length>0&&c.map(b=>ve("div",{onClick:()=>k(b),className:Mo(a("tag")),children:b},`tag-${b}`))})]})};import{Suspense as D0}from"react";import{FaInfo as A0}from"@react-icons/all-files/fa/FaInfo";import R0 from"react";import ml,{css as E0}from"styled-components";var F0=R0.lazy(()=>import("@tippyjs/react")),Eo=ml(F0)`
	background-color: var(${r.background600});
	color: var(${r.text100});
	padding: 10px;
	border-radius: 10px;
	font-size: 0.9rem;
	line-height: 1.3;

	.tippy-arrow {
		color: var(${r.background600});
		width: 16px;
		height: 7px;

		&::before {
			content: '';
			position: absolute;
			border-color: transparent;
			border-style: solid;
			left: 0;
			transform-origin: center top;
		}
	}

	&[data-placement^='top'] > .tippy-arrow {
		top: 100%;

		&:before {
			border-top-color: initial;
			border-width: 7px 7px 0;
		}
	}

	&[data-placement^='bottom'] > .tippy-arrow {
		bottom: 100%;

		&:before {
			border-bottom-color: initial;
			border-width: 0 7px 7px;
		}
	}

	p {
		margin: 0 0 10px;

		&:last-child {
			margin-bottom: 0;
		}
	}
`,fl=ml.span`
	${()=>E0`
		background: var(${r.primary500});
		color: var(${r.white});
		border-radius: 50em;
		display: flex;
		justify-content: center;
		align-items: center;
		min-width: 20px;
		width: 20px;
		height: 20px;
		font-size: 0.8rem;
		font-weight: 700;
	`}
`;import{Fragment as H0,jsx as Re}from"react/jsx-runtime";var B0=e=>{let{content:t,pointer:o,direction:i="top",width:l=350,delay:n=0}=e;return Re(Eo,{className:a("tooltip"),children:Re(D0,{fallback:Re(H0,{}),children:Re(Eo,{content:t,className:a("tooltip-content"),allowHTML:!0,maxWidth:l,placement:i,arrow:!0,interactiveBorder:10,delay:n,animation:n>0,children:Re(fl,{className:a("tooltip-pointer"),children:o||Re(A0,{})})})})})};export{Ct as Accordion,co as AsyncSelect,Sl as Avatar,ao as BackgroundCSSEditor,Il as Badge,A as Button,Xc as CSSPropertiesEditor,r as CSSVars,zl as Card,Ml as CardBody,El as CardDescription,Dl as CardFooter,Nl as CardMedia,Fl as CardSubtitle,Rl as CardTitle,Jo as Checkbox,Hl as CheckboxGroup,an as CodeEditor,sn as ColorPalette,Le as ColorPicker,Lt as ColorScheme,Yn as ConfirmationPopup,Kn as ContextMenuSection,We as ContextMenuSectionTitle,ls as ContextMenuWrapper,ps as CopyInput,Jc as DatePicker,ed as DateRangePicker,pd as Drawer,xd as FileUpload,Sd as FormDescription,O as FormInput,De as FormInputError,he as FormLabel,oe as FormRow,Td as HelpArticles,Rd as ImageUpload,V as Input,no as ItemsManager,Gd as List,J as Loader,gl as LocalTheme,Pp as MultiSelect,Pn as Notifications,yc as NumberInput,Rp as Pagination,Be as Popover,zt as Popup,Rt as PopupButtons,Mt as PopupContent,Nt as PopupTitle,Wp as Position,Ga as Radio,Up as RadioGroup,t0 as RichEditor,Ue as Select,a0 as ShadowHint,d0 as Sidebar,p0 as SidebarBody,f0 as SidebarFooter,m0 as SidebarHeader,h0 as Skeleton,Ft as Slider,k0 as Switch,I0 as Tabs,N0 as TagSelect,Tt as Textarea,bl as Theme,po as ToggleGroup,B0 as Tooltip,lt as createGradientString,To as defaultFormats,zo as defaultFormatsWithImage,_o as defaultModules,Ze as defaultModulesWithImage,io as extractColorsFromGradientString,T as icons,W as notificationHelper,Bp as usePagination};
//# sourceMappingURL=nindo.esm.js.map
